import { Configuration, Connection, Connector, ConnectorInfo, Entity, EntityCreateCallback, Material, MaterialFilter, Module, MeshVisibility, ModuleCreateCallback, Product, Project, ProjectFilter, Series, User, YUIContext, SeriesFilter, DragConnector, ConfigurationData } from "./types/type_def";
import { ErrorHandler, PDFHandler } from "./handlers";
import { ConversionHelper, CryptographyHelper, DataHelper, EntityHelper, FormatHelper, MaterialSelector, MathHelper, MeshHelper, ModuleHelper, ProductHelper, ProductSelector } from "./helpers";
import { configurationLibrary, materialLibrary, meshLibrary, productLibrary, projectLibrary, seriesLibrary } from "./libraries";
import { AppSettings } from "./settings";
import "../node_modules/parsleyjs";
import i18next from "../node_modules/i18next";
import i18nextHttpBackend from "../node_modules/i18next-http-backend";
import "./styles/site.less"
import { createEngine, createEnvironment, createGround, createLight, createMainCamera, createRenderTargetCamera, createScene, createShadowgenerator } from "./engine";
import FileSaver from "file-saver";

/*declare namespace i18next {
    function init(options: any): any
    function use(o: any): any
    function t(s: string, o?: any): any
}*/

//declare class i18nextHttpBackend { }

(window as any).YUI({
    "debug": (window.location.hostname.indexOf("localhost") >= 0) || (window.location.hostname.indexOf("cadesignform") >= 0),
    "combine": true,
    "comboBase": "https://yui.customizer.cadesignform.dk/combo?" // Everything is bundled so we do not rely on external source
}).use("node", "anim", "io", "handlebars", "event-outside", "datatype-number", "event", "event-delegate", "event-touch", "event-move", "dd", "scrollview", "scrollview-scrollbars", "slider", function (Y: YUIContext) {

    let canvas: HTMLCanvasElement;
    let engine: BABYLON.Engine;
    let scene: BABYLON.Scene;
    let mainCamera: BABYLON.ArcRotateCamera;
    let renderTargetCamera: BABYLON.ArcRotateCamera;
    let topviewCamera: BABYLON.ArcRotateCamera;
    let light: BABYLON.ShadowLight;
    let light2: BABYLON.ShadowLight;
    let sg: BABYLON.ShadowGenerator;
    let sg2: BABYLON.ShadowGenerator;
    let ground: BABYLON.Mesh;
    let ground2: BABYLON.Mesh;

    let rootNode: BABYLON.TransformNode;
    let modulesNode: BABYLON.TransformNode;
    let productsNode: BABYLON.TransformNode;
    let instanceNode: BABYLON.TransformNode;

    let GUI: BABYLON.GUI.AdvancedDynamicTexture;
   
    let currentModule: Module;
    let currentProduct: Product;
    let currentEntityNode: BABYLON.TransformNode;
    let currentConfiguration: Configuration;
    let currentProject: Project;
    let currentModuleNode: BABYLON.TransformNode;
    let currentConnector: BABYLON.TransformNode;
    let currentPage: string;
    let previousPage: string;

    let isNewConfig: boolean;
    let isSeriesConstrained: boolean;
    let seriesConstrainedId: number;

    let loggedIn: boolean = false;
    let render: boolean = true;
    let rendererInitialized: boolean = false;

    let isDragging: boolean = false;
    let isPlacing: boolean = false;
    let isOverCanvas: boolean = false;
    let isB2C: boolean = false;
    let meshLoading: boolean = false;    

    let scaleFactor = 0.01;
    let connectorNodeSize = 0.2;

    let initialCameraRadius = 12;
    enum ACTIONS {
        NONE,
        DRAGOUT,
        DRAGOVER
    }

    let currentAction: ACTIONS = ACTIONS.NONE;

    let user: User;
    let viewMode: string;
    let materialFilters = [] as MaterialFilter[];

    let animRotation: BABYLON.Animatable;
    let animFitviewTarget: BABYLON.Animatable;
    let animFitviewRadius: BABYLON.Animatable;

    let dragPosition: BABYLON.Vector3 = BABYLON.Vector3.Zero();
    let scenePointerPosition: BABYLON.Vector3 = BABYLON.Vector3.Zero();
    let screenPointerPosition: BABYLON.Vector2 = BABYLON.Vector2.Zero();
    let cameraTarget: BABYLON.Vector3 = BABYLON.Vector3.Zero();
    let targetRotation: BABYLON.Vector3 = BABYLON.Vector3.Zero();

    let easingFunction = new BABYLON.BackEase(.0);
    easingFunction.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEOUT);

    let moduleHelper = new ModuleHelper();
    let entityHelper = new EntityHelper()

    moduleHelper.scaleFactor = scaleFactor;
    moduleHelper.entityHelper = entityHelper;


    //Handlers 
    let pdfHandler = new PDFHandler();
    let errorHandler = new ErrorHandler(Y, ".errors");

    let projectFilter: ProjectFilter = {
        search: "",
        hideInactive: false,
        currentPage: 1,
        itemsShown: 20
    }

    let seriesFilter: SeriesFilter = {
        search: ""
    }

    i18next.use(i18nextHttpBackend).init({
        lng: 'en', // if you're using a language detector, do not define the lng option
        fallbackLng: 'en',
        ns: ['ui'],
        debug: true,
        backend: {
            loadPath: 'static/locales/{{lng}}/{{ns}}.json'
        }
    }).then(() => {
        const elements = document.querySelectorAll("[data-i18n]");
        elements.forEach(el => {

            if (el.hasAttribute("placeholder")) {
                let key = el.getAttribute("placeholder");
                let value = i18next.t(key) || key;
                el.setAttribute("placeholder", value);
            }

            if (el.hasAttribute("title")) {
                let key = el.getAttribute("title");
                let value = i18next.t(key) || key;
                el.setAttribute("title", value);
            }

            if (el.innerHTML) {
                let key = el.innerHTML;
                let value = i18next.t(key) || key;
                el.innerHTML = value;
            }

        });

         if (window.location.href.toLowerCase().includes("seriesid")) {           

            showLoader();

            isSeriesConstrained = true;

            var params = new URLSearchParams(window.location.search.toLowerCase());
            var seriesId = params.get("seriesid");
            seriesConstrainedId = parseInt(seriesId);

            var cfg = {
                method: 'POST',          
                headers: {
                    'Content-Type': 'application/json',
                },
                on: {
                    success: async function (transactionid, response) {
                        var authJSON = JSON.parse(response.responseText);

                        if (authJSON.success) {
                            window.localStorage.setItem("accessToken", authJSON.accessToken);
                            window.localStorage.setItem("refreshToken", authJSON.refreshToken);   

                            user = getUser();                            
                            isB2C = user.isB2C;

                            const userMenuElem = Y.one(".user-menu__wrapper");
                            userMenuElem.remove(true)

                            const priceMenuElem = Y.one(".summary-menu__price");
                            priceMenuElem.remove(true)

                            const series = await seriesLibrary.fetchSeriesByID(seriesConstrainedId)
                            if (series) {

                                materialLibrary.defaultMaterial = series.defaultMaterial;
                                materialLibrary.materials = series.materials;        

                                let project = {} as Project;
                                project.seller = "B2C";
                                project.name = "B2C";
                                project.phone = "";
                                project.status = 1;
                                project.configurations = [{
                                    series: series.name,
                                    data: {
                                        id: "configuration" + Date.now(),
                                        offsetY: 0,
                                        material: "",
                                        thumbnail: "",
                                        leg: "",
                                        modules: [],
                                        options: {},
                                        customOptions: []
                                    } as ConfigurationData                                                     
                                } as Configuration];

                                const configuration = project.configurations[0];
                                var defaultLeg = seriesLibrary.getSeriesLeg(series, "standard");
                                configuration.data.options["leg"] = defaultLeg.productNumber;
                                
                                var defaultPackageLeg = seriesLibrary.getSeriesLegPackage(series, "standard");              
                                configuration.data.leg = defaultPackageLeg.identifier;

                                var newproject = await projectLibrary.createProject(project);
                                if (newproject) {

                                    currentProject = newproject;
                                    currentProject.name = `B2C (${newproject.identifier})`;
                                    currentConfiguration = newproject.configurations[0];                                                              
                                   
                                    await projectLibrary.saveProject(currentProject);

                                    renderProject().then(() => {
                                        instantiateModule(currentConfiguration, currentModule, function (module, moduleNode) {
                                            currentModule = module;                                          
                                            updateSummaryMenuTotalPrice();
                                            mainCamera.radius = initialCameraRadius;
                                            hideLoader();
                                        });
                                    });
                                }
                            }

                        }
                    },
                    failure: function (transactionid, response) {                       
                        window.localStorage.removeItem("accessToken");
                        window.localStorage.removeItem("refreshToken");
                        hideLoader();
                        handleLogin();
                    }
                }
            };

            Y.io('api/auth/b2c', cfg);     
                       
        } else {

            user = getUser();
            if (!user || user.isB2C) {
                window.localStorage.removeItem("accessToken");
                window.localStorage.removeItem("refreshToken");
                hideLoader();
                handleLogin();
            }

            const brandLogo = Y.one(".brand-logo");
            brandLogo.setAttribute("href","/")
            handleLogin();
        }
    });

    //Render thumbnail
    /*window.addEventListener("thumbnail_render", function (e: Event) {
        renderConfigurationThumbnail(currentConfiguration);
    });*/

    window.addEventListener("thumbnail_rendered", function (e: Event) {
        updateConfigurationSelector();
        let summaryImage = Y.one(".summary-page .summary__description--series .summary-image");
        summaryImage.setAttribute("src", currentConfiguration.data.thumbnail);
    });

    window.addEventListener("saveconfigurations", function (e: Event) {
        saveProjectConfiguration();
    });

    window.addEventListener("removeconfiguration", function (e: Event) {

        configurationLibrary.removeConfiguration(currentConfiguration);
        updateConfigurationSelector();
        showPage("series");
        saveProjectConfiguration();
        //window.dispatchEvent(new Event("saveconfigurations"));

    });

    /*window.addEventListener("error", function (e: Event) {

        var hasError = errorHandler.errors.length > 0;
        var summaryMenuButton = Y.one(".summary-menu__button");
        summaryMenuButton.set("disabled", hasError ? "disabled" : null);

    });*/

    // @ts-ignore
    $("#editprojectform").parsley();
    // @ts-ignore
    $("#createprojectform").parsley();
    // @ts-ignore
    $("#openprojectform").parsley();

    //User
    let getUser = () => {

        let authUser = null;
      
        if (localStorage.getItem("accessToken")) {
            var payload = CryptographyHelper.parseJwt(localStorage.getItem("accessToken"));
            var name = payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'];
            var role = payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/role'];

            authUser = {
                name: name,
                role: role,
                contactId: payload.ContactId,
                isB2C: (payload.IsB2C === "True")
            } as User;
        }

        return authUser;
    }

    //Selectors
    let productSelector = new ProductSelector(Y, productLibrary, Y.one(".product-selector"));
    let materialSelector = new MaterialSelector(Y, materialLibrary, Y.one(".material-selector"));
    materialSelector.selectCallBack = async function () {

        pauseRender();
        showLoader();

       // let count = 0;

        var entities = currentModule.entities.filter(x => productLibrary.getProductCategory(x.category) === "UPHOLSTRY");
        entities.forEach(entity => {

            //  let product = productLibrary.getProductByProductNo(entity.productNo);
            let productVariant = getProductVariant(entity.productNo, entity);
            let entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);

            let material = materialLibrary.getMaterialByProductNumber(currentConfiguration.data["material"]);
            if (material) {
                materialLibrary.assignMaterial(Y, productVariant, [entityNode], material, scene, function () {
                    entityNode.setEnabled(true);
                   // count++;

                    /*if (count === entities.length) { 
                        
                    }*/
                });
            }
        });

        resumeRender().then(() => {    
            handleModuleUpdating();            
        });       

    }
    materialSelector.selectGroupCallback = function () {
        var materialGroupModal = Y.one(".modals .material-group-modal");
        materialGroupModal.addClass("is-active");
        updateMaterialGroupModal();
    }

    //Reset configurations
    let resetConfigurations = function () {
        localStorage.removeItem("Configurations");
    }

    let displayBackButton = function (show: boolean) {
        var backButton = Y.one(".back-button");
        (show) ? backButton.addClass("show") : backButton.removeClass("show");
    }

    let displaySummaryButton = function (show: boolean) {
        var summaryMenuButton = Y.one(".summary-menu__button");
        (show) ? summaryMenuButton.addClass("show") : summaryMenuButton.removeClass("show");

        disableSummaryButton();
    }

    let disableSummaryButton = function () {
        var summaryMenuButton = Y.one(".summary-menu__button");
        if (!currentModule || currentModule.entities.length === 0)
            summaryMenuButton.set("disabled", "disabled");
    }

    let updateSeriesName = function (configuration: Configuration) {
        let series = seriesLibrary.getSeriesByName(configuration.series);
        var summaryMenuSeries = Y.one(".summary-menu__series");
        var summaryMenuSeriesName = summaryMenuSeries.one(".summary-menu__series__name");
        summaryMenuSeriesName.setHTML(series.name);
    }

    let updateSummaryMenuTotalPrice = function () {
        if (isB2C) return;
        if (currentConfiguration == undefined) {
            return;
        }       

        var summaryMenuPrice = Y.one(".summary-menu__price");
        var summaryMenuPriceValue = summaryMenuPrice.one(".summary-menu__price__value");
        var summaryMenuPriceCurrency = summaryMenuPrice.one(".summary-menu__price__currency");

        var moduleTotalPrice = moduleHelper.getTotalModulePrice(currentModule, currentConfiguration);
        summaryMenuPriceValue.setHTML(FormatHelper.formatNumber(moduleTotalPrice.totalPrice));
        summaryMenuPriceCurrency.setHTML(moduleTotalPrice.currency);

    }

    let showPage = function (pageName: string) {

        previousPage = currentPage;

        Y.all("[data-page]").each(function (p) {
            p.removeClass("is-shown")
        });

        var shownPage = Y.one("[data-page='" + pageName + "']");
        shownPage.addClass("is-shown");

        handlePageSetup(pageName);
    }

    let handlePageSetup = async function (pageName: string) {

        currentPage = pageName;

        displayBackButton(false);
        displaySummaryButton(false);

        switch (pageName) {
            case "landing": {

            }
                break;
            case "configurations": {

                let identifierElem = Y.one("#openprojectform input");
                identifierElem.set("value", "");

                updateProjectsList();
            }
                break;
            case "series": {

                //  clearConfigurationAssets();
                cleanupAssets();
                currentModule = null;
                currentModuleNode = null;

                displaySummaryMenu(false);
                showSeriesWizardStep("series");

                //Update series list             
                updateSeriesList();

            }
                break;

            case "viewport": {
                updateConfigurationSelector();
                displaySummaryMenu(true);
                displaySummaryButton(true);
                
            }
                break;
            case "summary": {
                displayBackButton(true);
            }
        }
    }

    //Initialization
    let initApp = function () {

        viewMode = "module";
        resetConfigurations();

        showLoader();
        setDisplayName();

        showPage("configurations");
         
        updateSummaryMenuTotalPrice();

        initCollapsibles();

        seriesLibrary.fetchSeries(seriesFilter);
    }

    let initCollapsibles = function () {

        /*@ts-ignore*/
        const bulmaCollapsibleInstances = bulmaCollapsible.attach('.is-collapsible');
    }

    //Login
    let handleLogin = function () {

        loggedIn = !!localStorage.getItem("accessToken");
        if (loggedIn) {
            user = getUser();    
            initApp();
        } else {
            showPage("login");
        }
    }

    let handleLogout = function () {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        user = null;
        window.location.reload();
    }

    let setDisplayName = function () {

        var userDisplayName = Y.one(".user-menu__label");
        userDisplayName.setHTML(user.name);
    }

    let cleanupAssets = function () {

        //Remove UI controls 
        if (GUI) {
            GUI.rootContainer.clearControls();
        }

        //Remove all meshes in module
        if (scene) {

            let modulesNode = scene.getNodeById("modules") as BABYLON.TransformNode;
            if (modulesNode) {

                const childMeshes = modulesNode.getChildMeshes(false, x => x.metadata && x.metadata.meshtype !== "leg");
                const childNodes = modulesNode.getChildTransformNodes(false);

                childMeshes.forEach(function (mesh) {
                    mesh.dispose(true, true);
                    mesh = null;
                });

                childNodes.forEach(function (node) {
                    node.dispose(true, false);
                    node = null;
                });
            }
        }
    }

    let resetMainCamera = function () {
        if (mainCamera) {
            mainCamera.alpha = Math.PI / 2;
            mainCamera.beta = Math.PI / 2.5;
            mainCamera.radius = 15;
        }
    }

    let initRenderer = async function () {

        return new Promise((resolve) => {
            canvas = document.getElementById("renderCanvas") as unknown as HTMLCanvasElement;
            engine = createEngine(canvas, scaleFactor);
            scene = createScene(engine);

            moduleHelper.scene = scene;  

            mainCamera = createMainCamera(scene);
            scene.activeCamera = mainCamera;
            mainCamera.attachControl(true, false);

            renderTargetCamera = createRenderTargetCamera(scene);
            topviewCamera = createRenderTargetCamera(scene);

            createEnvironment(scene);

            light = createLight("DirectionalLight", scene, new BABYLON.Vector3(0, 0, 0), new BABYLON.Vector3(-0.38, -1, -0.38), 1.5, -5, 1);  
            sg = createShadowgenerator(light, 0.3, 0.15);   
            ground = createGround(light, scene);
        
            GUI = BABYLON.GUI.AdvancedDynamicTexture.CreateFullscreenUI("UI", true, scene, BABYLON.DynamicTexture.BILINEAR_SAMPLINGMODE);
            GUI.renderAtIdealSize = true;

            rootNode = new BABYLON.TransformNode("root", scene);
            rootNode.position = BABYLON.Vector3.Zero();

            instanceNode = new BABYLON.TransformNode("instanceables", scene);

            modulesNode = new BABYLON.TransformNode("modules", scene);
            modulesNode.parent = rootNode;
            modulesNode.position = BABYLON.Vector3.Zero();

            productsNode = new BABYLON.TransformNode("products", scene);
            productsNode.parent = rootNode;

            meshLibrary.loadedMeshesNode = productsNode;
            meshLibrary.rootNode = modulesNode;
            meshLibrary.instanceNode = instanceNode;         

            scene.executeWhenReady(() => {                    

                /**
                 * Scene pointer move (dragging etc.)
                 * @param e
                 */
                scene.onPointerMove = function (e) {
                    if (currentEntityNode) {
                        if (isDragging) {

                            dragCanvas();

                            screenPointerPosition = new BABYLON.Vector2(scene.pointerX, scene.pointerY);
                            scenePointerPosition = getTargetPosition(screenPointerPosition.x, screenPointerPosition.y);
                            dragPosition = getZeroPlaneVector(mainCamera.position, scenePointerPosition);

                            //Move according to real center of entity
                            var centerNode = currentEntityNode.getChildTransformNodes(false, function (m) { return m.id === "center" })[0];
                            dragPosition.subtractInPlace(centerNode.position);

                            currentEntityNode.setAbsolutePosition(new BABYLON.Vector3(dragPosition.x, currentEntityNode.position.y, dragPosition.z));
                        }
                    }
                };

                /**
                 * Scene pointer up (stop drag etc.)
                 * @param e
                 */
                scene.onPointerUp = function (e) {

                    if (isPlacing) {

                        handleModuleUpdating();

                        currentEntityNode = null;
                        isPlacing = false;                                    
                    }

                    if (isDragging) {
                        dragEndCanvas();                   
                    }
                };

                    /**
                     * Scene pointer down (click on scene, unselect meshes etc.)
                     * @param e
                     * @param pickInfo
                     * @param type
                     */
                    scene.onPointerDown = function (e, pickInfo, type) {
                        if (pickInfo.pickedMesh === null) {

                            if (isPlacing) {

                                if (currentEntityNode) {

                                    hideAvailableConnectors();

                                    screenPointerPosition = new BABYLON.Vector2(scene.pointerX, scene.pointerY);
                                    scenePointerPosition = getTargetPosition(screenPointerPosition.x, screenPointerPosition.y);
                                    dragPosition = getZeroPlaneVector(mainCamera.position, scenePointerPosition);

                                    currentEntityNode.setAbsolutePosition(new BABYLON.Vector3(dragPosition.x, currentEntityNode.position.y, dragPosition.z));

                                    let currentEntity = getCurrentEntity();

                                    let productVariant = getProductVariant(currentEntity.productNo, currentEntity);

                                    var entityBounds = currentEntityNode.getChildMeshes(true, function (m) { return m.id === "entitybounds" })[0];
                                    entityBounds.setEnabled(true);

                                    //Load entity mesh
                                    meshLibrary.loadMeshAsync(productVariant.productNo, currentEntity, productVariant.type, "furniture/", productVariant.model + ".glb", productVariant.isFlipped, scene, false, sg, sg2, onProgress, function (clonedMeshEntityId, clonedMesh) {

                                        //Set material
                                        let material = materialLibrary.getMaterialByProductNumber(currentConfiguration.data["material"]);
                                        if (material) {
                                            materialLibrary.assignMaterial(Y, productVariant, [clonedMesh], material, scene, function () {                                           
                                                clonedMesh.setEnabled(true);                                               
                                            });
                                        }
                                     
                                        //Create leg attachments
                                        createLegAttachments(currentModule, currentEntity, productVariant, scene);
                                        //Create legs
                                        constructLegs(currentModule, currentEntity);

                                        clonedMesh.scaling.x = productVariant.isFlipped ? -1 : 1;
                                        clonedMesh.position.y = currentConfiguration.data.offsetY;                                        
                                    });  
                                 
                                }

                            } else {
                                hideHighlight(currentModuleNode);
                                hideEntityActions();
                                currentEntityNode = null;                                
                            }
                        } else {

                            if (currentEntityNode) {
                                let entityNode = getParentMesh(pickInfo.pickedMesh, "entity") as BABYLON.Mesh;
                                if (entityNode.id === currentEntityNode.id) {

                                    mainCamera.detachControl();
                                    dragStartCanvas();

                                    showHighlight(currentEntityNode);

                                    screenPointerPosition = new BABYLON.Vector2(scene.pointerX, scene.pointerY);

                                    scenePointerPosition = getTargetPosition(screenPointerPosition.x, screenPointerPosition.y);
                                    dragPosition = getZeroPlaneVector(mainCamera.position, scenePointerPosition);

                                    //Move according to real center of entity
                                    var centerNode = currentEntityNode.getChildTransformNodes(false, function (m) { return m.id === "center" })[0];
                                    dragPosition.subtractInPlace(centerNode.position);

                                    currentEntityNode.setAbsolutePosition(new BABYLON.Vector3(dragPosition.x, currentEntityNode.position.y, dragPosition.z));
                                }
                            }

                        }
                    }

                    /**
                     * Scene pointer pick (picking meshes etc.)
                     * @param e
                     * @param pickInfo
                     */
                    scene.onPointerPick = function (e, pickInfo) {

                        hideEntityActions();
                        // currentEntityNode = null;

                        if (e.button === 0) {
                            if (pickInfo.pickedMesh !== null) {

                                let mesh = pickInfo.pickedMesh;
                                let moduleNode = getParentMesh(mesh, "module") as BABYLON.TransformNode;
                                let module = currentConfiguration.data.modules.find(function (m) { return m.id === moduleNode.id });

                                currentModule = module;
                                currentModuleNode = moduleNode;
                        
                                if (isPlacing) {

                                    isPlacing = false;

                                /* var entity = getCurrentEntity();
                                    if (entity) {
                                        deleteEntity(entity);
                                    }*/

                                    hideAvailableConnectors();

                                } else {

                                    let entityNode = getParentMesh(mesh, "entity") as BABYLON.Mesh;
                                    hideHighlight(moduleNode);

                                    if (entityNode) {
                                        currentEntityNode = entityNode;
                                        showHighlight(entityNode);
                                        showEntityActions();
                                    }
                                }                      
                            }
                        }
                    }

                    /**
                     * Renderlopp
                     */
                    engine.runRenderLoop(function () {
                        if (render) {
                            scene.render();
                        }
                    });
            
                    rendererInitialized = true;
                    resolve(true);            

            })
        });
    }

    /*
     * Debug
     * */

    let enableDebug = function () {
        var keysPressed = {};

        document.addEventListener("keydown", function (event) {
            keysPressed[event.key] = true;

            if (keysPressed["Alt"]) {
                scene.debugLayer.show({
                    embedMode: true
                });
            }
        });
    };

    if (Y.config.debug) {
        enableDebug();
    };

    /*
     * Functions
     * */

    //let ioActivities = 0;

    let pauseRender = function () {
        render = false;
    }

    let isReady = function () {
        if (!scene.isReady()) return false;

        if (!light.isReady(true)) return false;

        for (let tex of scene.textures) {
            if (!tex.isReady()) return false;
        }

        for (let mesh of scene.meshes) {
            if (!mesh.isReady()) return false;
        }

        return true;
    }


    let resumeRender = async function () {

        let renderInterval;
        return new Promise(resolve => {
            renderInterval = setInterval(function () {
                if (isReady()) {
                    clearInterval(renderInterval);
                    render = true;
                    resolve(true);
                }
            }, 250);
        });
    }

    let showLoader = function () {
        let loader = Y.one(".loader-wrapper");
        loader.addClass("is-active");
    }

    let hideLoader = function () {
        let loader = Y.one(".loader-wrapper");
        loader.removeClass("is-active");
    }

    let showLoadingCanvas = function () {

        showLoader();

        let viewport = Y.one(".viewport");
        viewport.addClass("is-loading");

        let loadCanvas = viewport.one("#loadCanvas");
        loadCanvas.addClass("is-active");      
        loadCanvas.getDOMNode().width = engine.getRenderWidth();
        loadCanvas.getDOMNode().height = engine.getRenderHeight();
        let loadCanvasContext = loadCanvas.getDOMNode().getContext("2d");        
        
        scene.render();       
        loadCanvasContext.drawImage(engine.getRenderingCanvas(), 0, 0, engine.getRenderWidth(), engine.getRenderHeight());   

    }

    let showNotification = function (message: string) {

        let notification = Y.one(".notification");
        let notificationBody = notification.one(".notification-body");
        notificationBody.setHTML(message);
    }

    let hideLoadingCanvas = function () {

        let viewport = Y.one(".viewport");
        let loadCanvas = viewport.one("#loadCanvas");

        loadCanvas.addClass("is-fade");

        // Y.later(500, this, function () {
        loadCanvas.removeClass("is-active");
        loadCanvas.removeClass("is-fade");
        //Y.later(100, this, function () {
        viewport.removeClass("is-loading");
        //});
        hideLoader();
        // });
    }

    /* let toggleMetrics = function (show) {
 
         Metrics.ClearMetrics(scene, rulerGUI);
         if (show) {
             Metrics.CreateModuleRulers(currentModule, productLibrary, scene, rulerGUI);
         }
     }*/

    let createProjectConfiguration = function (project: Project, series: string) {

        let configuration = {
            series: series,
            data: {
                id: "configuration" + Date.now(),
                offsetY: 0,
                material: "",
                leg: "",
                thumbnail: "",
                modules: [],
                options: {},
                customOptions: [{id: "Removable cover", value: "Removable cover"}]
            }
        } as Configuration;

        projectLibrary.createConfiguration(project, configuration);

        currentConfiguration = configuration;

    }

    let saveProjectConfiguration = async function () {

        if (currentConfiguration) {
            currentConfiguration.data.modules.forEach(function (module) {

                var moduleNode = scene.getTransformNodeByUniqueId(module.uniqueId);
                if (moduleNode) {
                    module.position = moduleNode.position;
                    module.rotation = moduleNode.rotation;
                }

                module.entities.forEach(function (entity) {

                    var entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);
                    if (entityNode) {
                        entity.position = entityNode.position;
                        entity.rotation = entityNode.rotation;
                    }

                });

            });

            currentProject.configurations = currentProject.configurations.filter(x => x.data.id !== currentConfiguration.data.id);
            currentProject.configurations.push(currentConfiguration);
        }

        await projectLibrary.saveProject(currentProject);
    }

    let renderConfigurationThumbnail = function (configuration: Configuration) {                
      
        zoomToMeshHierarchy(renderTargetCamera, currentModuleNode, scene, Math.PI/2.5, Math.PI/2.5,2);
      
        let result = BABYLON.Tools.CreateScreenshotUsingRenderTargetAsync(engine, renderTargetCamera, { width: 396, height: 222 }, "image/png", 2, true);               
        return result;
      
    }

    let renderConfigurationImage = (configuration: Configuration, callback: (image: string) => void, resolutionMultiplier: number = 1, alpha: number = Math.PI / 2, beta: number = (Math.PI / 2) * 0.97, height?: number) => {

        if (isReady()) {

            let heightRes = 768;
            let mutiplier = 1;

            if (beta === 0) {
                heightRes = 1365;
            }

            if (height) {
                renderTargetCamera.position.y = height;
                const dir = renderTargetCamera.position.subtract(renderTargetCamera.target);
                beta = Math.acos(dir.y / dir.length());       
                mutiplier = 2;         
            }

            zoomToMeshHierarchy(renderTargetCamera, currentModuleNode, scene, alpha, beta, mutiplier);       

            BABYLON.Tools.CreateScreenshotUsingRenderTargetAsync(engine, renderTargetCamera, { width: 1365 * resolutionMultiplier, height: heightRes * resolutionMultiplier }, "image/jpeg", 6, true).then((data) => {
                callback(data);
            });
         
        }
    }

    let renderConfigurationImages = (configuration: Configuration, callback?: () => void) => {

        renderConfigurationImage(configuration, (frontImage) => {
            renderConfigurationImage(configuration, (sideImage) => {
                renderConfigurationImage(configuration, (backImage) => {
                    renderConfigurationImage(configuration, (topImage) => {

                    FileSaver.saveAs(frontImage, currentConfiguration.series + "-front.png");
                    FileSaver.saveAs(sideImage, currentConfiguration.series + "-side.png");
                    FileSaver.saveAs(backImage, currentConfiguration.series + "-back.png");
                    FileSaver.saveAs(topImage, currentConfiguration.series + "-top.png");

                    if(callback){
                        callback();
                    }
                    }, 3, Math.PI * 0.5, 0);
                }, 3, Math.PI * 1.5, Math.PI/2.5, 1.7);
            }, 3, Math.PI * 0.25, Math.PI/2.5, 1.7);
        }, 3,  Math.PI * 0.5, Math.PI/2.5, 1.7);
    }

    let renderDrawingWithGUI = (configuration: Configuration, callback: () => void) => {
        zoomToMeshHierarchy(topviewCamera, currentModuleNode, scene);    

        topviewCamera.beta = 0;
        topviewCamera.alpha = Math.PI / 2;
        topviewCamera.update();

        GUI.rootContainer.children.forEach(function (c) {
            if (c.name.indexOf("_label") >= 0) {
                c.dispose();                                      
            }
        });

        const entities = currentModule.entities.filter(function (entity: Entity) { return productLibrary.getProductCategory(entity.category) === "UPHOLSTRY" })

        for (let i = 0; i < entities.length; i++) {

            var entity = entities[i];
            var entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);
            var centerNode = entityNode.getChildTransformNodes(true, function (t) { return t.id === "center" })[0];          

            var labelContainer = new BABYLON.GUI.Rectangle(currentModule.id + "_" + entity.id + "_label");
            labelContainer.width = "220px";
            labelContainer.height = "52px";
            labelContainer.cornerRadius = 4;
            labelContainer.color = "black";
            labelContainer.thickness = 1;
            labelContainer.background = "white";
            GUI.addControl(labelContainer);
            labelContainer.linkWithMesh(centerNode);
            labelContainer.linkOffsetY = -16;

            labelContainer.isVisible = false;

            var product = productLibrary.getProductByProductNo(entity.productNo);
            var productVariant = productLibrary.getProductVariantByConnectionType(product, moduleHelper.getEntityConnectionType(currentModule, entity));

            var text1 = new BABYLON.GUI.TextBlock(currentModule.id + "_" + entity.id + "_productNo");
            text1.text = productVariant.productNo.replace("/", "/\r\n") + "\r\n" + productVariant.axProductNo;
            text1.color = "black";
            text1.fontSize = 14;
            labelContainer.addControl(text1);
        }

        scene.executeWhenReady(() => {
            GUI.rootContainer.children.forEach(function (c) {
                if (c.name.indexOf("_label") >= 0) {
                    c.isVisible = true;
                }
            });

            scene.render();

            renderWithGUI((data) => {
                configuration.drawing = data;

                GUI.rootContainer.children.forEach(function (c) {
                    if (c.name.indexOf("_label") >= 0) {
                        c.isVisible = false;                                            
                    }
                });

                callback();
            });
        });
    }

    let renderWithGUI = async function (successCallback: (data: any) => void) {

        const camera = topviewCamera;
        const width = 1500;
        const height = 1500;
        const antialiasing = true;
        let targetTextureSize = { width, height };

        if (!(height && width)) {
            BABYLON.Logger.Error("Invalid 'size' parameter !");
            return;
        }

        var save = engine.getAspectRatio;

        var scene = camera.getScene();
        var previousCamera = null;
        var previousCameras = scene.activeCameras;

        scene.activeCameras = null;

        if (scene.activeCamera !== camera) {
            previousCamera = scene.activeCamera;
            scene.activeCamera = camera;
        }

        engine.getAspectRatio = () => {
            return width / height;
        };

        GUI.scaleTo(width, height);
        GUI.markAsDirty();
        GUI.invalidateRect(0, 0, width - 1, height - 1);

        scene.render(); // make sure the scene is ready to be rendered in the RTT with the right list of active meshes (which depends on the camera, that may have been changed above)

        // At this point size can be a number, or an object (according to engine.prototype.createRenderTargetTexture method)
        var texture = new BABYLON.RenderTargetTexture("screenShot", targetTextureSize, scene, false, false, BABYLON.Constants.TEXTURETYPE_UNSIGNED_INT, false, BABYLON.Texture.NEAREST_SAMPLINGMODE, undefined, true, undefined, undefined, undefined, 1);
        texture.renderList = null;
        texture.samples = 1;
        texture.renderSprites = true;

        texture.onBeforeRenderObservable.add(() => {
        });

        texture.onAfterRenderObservable.add(() => {
            engine.setDepthBuffer(false);
            GUI.layer.render();
            engine.setDepthBuffer(true);
            //advancedTexture._onResize();
        });

        engine.onEndFrameObservable.addOnce(() => {
            const prom = texture.readPixels(undefined, undefined, undefined, false)

            prom.then((data) => {
                BABYLON.Tools.DumpData(width, height, data, successCallback, "image/jpeg", undefined, true);
                texture.dispose();
            });
        });

        const renderToTexture = () => {
            // render the RTT
            scene.incrementRenderId();
            scene.resetCachedMaterial();
            texture.render(true);

            // re-render the scene after the camera has been reset to the original camera to avoid a flicker that could occur
            // if the camera used for the RTT rendering stays in effect for the next frame (and if that camera was different from the original camera)
            scene.incrementRenderId();
            scene.resetCachedMaterial();
            if (previousCamera) {
                scene.activeCamera = previousCamera;
            }
            scene.activeCameras = previousCameras;
            engine.getAspectRatio = save;
            camera.getProjectionMatrix(true); // Force cache refresh;
            scene.render();
        };

        if (antialiasing) {
            const fxaaPostProcess = new BABYLON.FxaaPostProcess('antialiasing', 1.0, scene.activeCamera);
            texture.addPostProcess(fxaaPostProcess);
            // Async Shader Compilation can lead to none ready effects in synchronous code
            if (!fxaaPostProcess.getEffect().isReady()) {
                fxaaPostProcess.getEffect().onCompiled = () => {
                    renderToTexture();
                };
            }
            // The effect is ready we can render
            else {
                renderToTexture();
            }
        }
        else {
            // No need to wait for extra resources to be ready
            renderToTexture();
        }
    }

    let toggleMeshVisibility = function (mesh: BABYLON.TransformNode, state: MeshVisibility) {

        if (mesh) {
            var childmeshes = mesh.getChildMeshes(false, function (m) { return !BABYLON.Tags.MatchesQuery(m, "connector") && !BABYLON.Tags.MatchesQuery(m, "entity")  });
            childmeshes.forEach(function (m, index) {

                if (m.isAnInstance)
                    return;

                switch (state) {

                    case MeshVisibility.VISIBLE: {
                        if (m.material) {
                            m.visibility = 1;
                            m.material.alpha = 1;
                            m.material.disableDepthWrite = false;
                            m.material.transparencyMode = 0;
                            m.material.alphaMode = 2;
                            m.material.needDepthPrePass = false;
                            m.renderingGroupId = 0;
                            m.setEnabled(true);
                        }
                    }
                        break;
                    case MeshVisibility.HIDDEN: {
                        if (m.material) {
                            m.visibility = 0;
                            m.material.alpha = 1;
                            m.material.disableDepthWrite = false;
                            m.material.transparencyMode = 0;
                            m.material.alphaMode = 0;
                            m.material.needDepthPrePass = false;
                            m.renderingGroupId = 0;
                            m.setEnabled(false);
                        }
                    }
                        break;
                    case MeshVisibility.HIGHLIGHTED: {
                        if (m.material) {
                            m.visibility = 1;
                            m.material.alpha = 1;
                            m.material.disableDepthWrite = false;
                            m.material.transparencyMode = 0;
                            m.material.alphaMode = 0;
                            m.material.needDepthPrePass = false;
                            m.renderingGroupId = 1;
                        }
                    }
                        break;
                    case MeshVisibility.FADED: {
                        if (m.material) {
                            m.renderingGroupId = 0;
                            m.material.alpha = 0.2;
                            m.material.disableDepthWrite = true;
                            m.material.transparencyMode = 1;
                            m.material.alphaMode = 7;
                            m.material.needDepthPrePass = true;
                        }
                    }
                        break;

                }

                m.updateCache(true);
            });
        }
    }

    let hideAllHighlights = function () {

        if (currentModule) {
            currentModule.entities.forEach(function (entity) {
                var entityNode = scene.getTransformNodeById(entity.id);
                hideHighlight(entityNode);
            });
        }
    }

    let hideAvailableConnectors = function () {

        if (currentModuleNode) {
            if (GUI.rootContainer.children.length > 0) {
                GUI.rootContainer.children.forEach(function (c) {
                    if (c.name.indexOf("_connector_") >= 0) {
                        c.alpha = 0;
                        c.isEnabled = false;
                    }
                });
            }

            var childmeshes = currentModuleNode.getChildMeshes(false, function (m) { return BABYLON.Tags.MatchesQuery(m, "connector") });
            childmeshes.forEach(function (m, index) {
                m.setEnabled(false);
            });
        }
    }


    let getCurrentEntity = function () {
        if (currentEntityNode) {
            return currentModule.entities.find(function (e) { return e.uniqueId === currentEntityNode.uniqueId });
        }
        return null;
    }

    let getAvailableConnectors = function (entity: Entity, availableEntity: Entity) {

        let availableConnectors = [] as Array<string>        
        entity.connectors.forEach(function (connector: Connector) {
            availableConnectors.push(...getMatchingConnectors(connector, entity, availableEntity));
        });

        return availableConnectors.filter((value, index, self) => self.indexOf(value) === index);
    }  

    let getMatchingConnectors = function (connector: Connector, parentEntity: Entity, childEntity: Entity) {

        const parentConnections = parentEntity.connections.map(x => x.id);
        const childConnections = childEntity.connections.map(x => x.id);

        let adjacentEntities = entityHelper.getAdjacentEntities(currentModule, childEntity, scene);
        const childDirections = adjacentEntities.map(x => x.direction);

        const parentProduct = productLibrary.getProductByProductNo(parentEntity.productNo);
        const childProduct = productLibrary.getProductByProductNo(childEntity.productNo);
      
        let matchingConnectors = [] as Array<string>;

        switch (connector.id) {
            case "CT01_L": {
                matchingConnectors.push("CT04", "CT06", "CT10_R", "CT01_R");
            }
                break;
            case "CT01_R": {
                matchingConnectors.push("CT03", "CT05", "CT10_L", "CT01_L");
            }
                break;
            case "CT03":
            case "CT05":
            case "CT10_L": {    
                
                if ([148882,157547,157546].includes(childProduct.series)) {

                    if (childEntity.category === "BACK") {
                        if (!(childDirections.includes("FRONT") && childDirections.includes("RIGHT_FRONT"))) {
                            matchingConnectors.push("CT39"); 
                        } 
                    }

                    if (childEntity.category === "SEATFRAME") {
                        matchingConnectors.push("CT04","CT39"); 
                    }

                } else if ([148881].includes(childProduct.series)) {
                    if (parentConnections.length > 0) {
                        matchingConnectors.push("CT04", "CT11","CT37", "CT03");
                    } else {
                        matchingConnectors.push("CT04");
                     }
                    
                } else {
                    matchingConnectors.push("CT04", "CT06", "CT10_R", "CT01_R");
                }            
            }
                break;
            case "CT04":
            case "CT06":
            case "CT10_R": {      
                
                if ([148882,157547,157546].includes(childProduct.series)) {

                    if (childEntity.category === "BACK") {
                        if (!(childDirections.includes("FRONT") && childDirections.includes("LEFT_FRONT"))) {
                            matchingConnectors.push("CT38");
                        }
                     }

                    if (childEntity.category === "SEATFRAME") {                         
                        matchingConnectors.push("CT03", "CT38"); 
                    }  
                } else if ([148881].includes(childProduct.series)) {  
                     if (parentConnections.length > 0) {                 
                        matchingConnectors.push("CT03", "CT11","CT37", "CT04");
                     } else {
                        matchingConnectors.push("CT03");
                     }

                } else {
                    matchingConnectors.push("CT03", "CT05", "CT10_L", "CT01_L");
                }

            }
                break;             
        
            case "CT11": {
               
                if (!childConnections.includes("CT11") && !childConnections.includes("CT37")) {
                    matchingConnectors.push("CT37")
                } 

                if (childConnections.includes("CT37") &&
                    !childConnections.includes("CT36")) {
                    matchingConnectors.push("CT36")
                } 
                
                if ([148881].includes(childProduct.series)) {     
                     if (parentConnections.length > 0) {             
                        matchingConnectors.push("CT03", "CT11","CT37", "CT04");
                     }  else {
                        matchingConnectors.push("CT37");
                     }
                }
                             
            }
                break;
            case "CT36": {
                if (parentEntity.category === "SEATFRAME") {
                    if (childConnections.includes("CT37")) {
                        matchingConnectors.push("CT11")
                    }     
                }           
            }
                break;
            case "CT37": {
              
                if (!childConnections.includes("CT37") && !childConnections.includes("CT11"))                    
                {
                    matchingConnectors.push("CT11")
                }

                if ([148881].includes(childProduct.series)) {       
                     if (parentConnections.length > 0) {            
                        matchingConnectors.push("CT03", "CT11","CT37", "CT04");
                     } else {
                        matchingConnectors.push("CT11");
                     }
                }
              
            }
                break;
            case "CT38": {
              
                if ([148882,157547,157546].includes(childProduct.series)) {

                    if (childEntity.category === "ARM") {

                        if (!childDirections.includes("RIGHT_BACK") && childConnections.includes("CT44")) {
                            matchingConnectors.push("CT45");
                        } else if (!childDirections.includes("RIGHT") && childConnections.includes("CT44_center")) {
                            matchingConnectors.push("CT45_center");
                        } else if (!childDirections.includes("RIGHT") && !childDirections.includes("RIGHT_BACK")) {
                            matchingConnectors.push("CT45","CT45_center");          
                        }
                      
                    } else {                       
                        matchingConnectors.push("CT04","CT39","CT45");

                        if (parentProduct.depth >= 120) {
                             matchingConnectors.push("CT45_center");
                        }
                    }  


                } else {                  
                    matchingConnectors.push("CT04","CT39","CT45","CT45_center");                    
                }

            }
                break;
            case "CT39": {                    
               
                if ([148882,157547,157546].includes(childProduct.series)) {

                    if (childEntity.category === "ARM") {
                    
                        if (!childDirections.includes("LEFT_BACK") && childConnections.includes("CT45")) {
                            matchingConnectors.push("CT44");
                        } else if (!childDirections.includes("LEFT") && childConnections.includes("CT45_center")) {
                            matchingConnectors.push("CT44_center");
                        } else if (!childDirections.includes("LEFT") && !childDirections.includes("LEFT_BACK")) {
                            matchingConnectors.push("CT44","CT44_center");          
                        }
                      
                    } else {
                        matchingConnectors.push("CT03", "CT38","CT44");   
                        
                        if (parentProduct.depth >= 120) {
                             matchingConnectors.push("CT44_center");
                        }
                    }

                } else {  
                    matchingConnectors.push("CT03", "CT38","CT44","CT44_center");                    
                }

            }
                break;
            case "CT44_center":           
            case "CT44": {
                matchingConnectors.push("CT39")    
            }
                break;
            case "CT45_center":           
            case "CT45": {
                matchingConnectors.push("CT38")              
            }
                break;

        }

        return matchingConnectors;
    }

    let showAvailableConnectors = function (module: Module, entity: Entity) {

        hideAvailableConnectors();

        var traversedEntityIds = [];

        if (module && entity) {            

            //Iterate over all entities except current entity
            var availableEntities = module.entities.filter(function (e: Entity) {
                return productLibrary.getProductCategory(e.category) === "UPHOLSTRY" &&
                    e.id !== entity.id &&
                    e.connectors.length > 0
            });           

            availableEntities.forEach(function (availableEntity: Entity) {

                const product = productLibrary.getProductByProductNo(availableEntity.productNo);

                let availableConnectors = getAvailableConnectors(entity, availableEntity);
                availableConnectors.forEach(function (availableConnectorId: string) {

                    let availableEntityProduct = productLibrary.getProductByProductNo(availableEntity.productNo);

                    //TODO: Skal v�lges ud fra valgte cushionpackage i frontend
                    let availableEntityVariants = availableEntityProduct.cushionPackages[0].variants;

                    let currentEntityConnection = entity.connections.find(function (entityConnection: Connection) { return entityConnection.entityId === availableEntity.id });

                    let entityConnection = availableEntity.connections.find(function (entityConnection: Connection) { return entityConnection.id === availableConnectorId });
                    let actionIcon = (!entityConnection) ? AppSettings.Paths.LinkIcon : AppSettings.Paths.InsertIcon;
                    let connectorEnabled = true;

                    if (entityConnection) {
                        //Deny entity to be inserted when we only have one connector
                        if (entity.connectors.length === 1) {
                            connectorEnabled = false;
                        }

                        //Ares
                        if ([148881].includes(product.series)) {
                            if (entityConnection || currentEntityConnection)
                                connectorEnabled = false
                        }
                    }

                    //Bure (remove insert)                       
                    if ([148882,157547,157546].includes(product.series)) {
                        const adjacentEntities = entityHelper.getAdjacentEntities(module, availableEntity, scene);
                        const directions = adjacentEntities.map(x => x.direction);

                        if (availableEntity.category === "SEATFRAME" || availableEntity.category === "BACK" || availableEntity.category === "ARM") {                               

                            if ((directions.includes("RIGHT") || directions.includes("RIGHT_BACK") || directions.includes("RIGHT_FRONT")) && (availableConnectorId == "CT04" || availableConnectorId == "CT39" || availableConnectorId == "CT45"  || availableConnectorId == "CT45_center")) {
                                connectorEnabled = false;
                            }
                            if ((directions.includes("LEFT") || directions.includes("LEFT_BACK") || directions.includes("LEFT_FRONT")) && (availableConnectorId == "CT03" || availableConnectorId == "CT38" || availableConnectorId == "CT44"  || availableConnectorId == "CT44_center")) {
                                connectorEnabled = false;
                            }
                        }                         
                    }

                    if (availableEntity.category === "SOFA" &&
                        availableEntityVariants.filter(x => x.connectionType === "CT07").length === 0 &&
                        availableEntity.connections.length === 1) {
                        connectorEnabled = false;
                    }

                    var actionUIControl = GUI.rootContainer.getChildByName(module.id + "_" + availableEntity.id + "_connector_" + availableConnectorId) as BABYLON.GUI.Image;

                    //Create connection GUI elements                           
                    if (actionUIControl) {
                        actionUIControl.source = actionIcon;
                        actionUIControl.isEnabled = connectorEnabled;
                        actionUIControl.alpha = connectorEnabled ? 1 : 0;                       
                    }

                    //Enable connection mesh         
                    var entityNode = scene.getTransformNodeByUniqueId(availableEntity.uniqueId);
                    var connectorMesh = entityNode.getChildMeshes(false, function (m) { return m.name === availableConnectorId })[0];
                    if (connectorMesh) {                      
                        connectorMesh.setEnabled(connectorEnabled);
                        actionUIControl.linkWithMesh(connectorMesh)
                    }

                });

                traversedEntityIds.push(availableEntity.id);
            })
            
        }
    }

    let getPositionConnectorInfo = function (position: BABYLON.Vector2, mesh: BABYLON.TransformNode) {

        let connectorInfos = [] as Array<ConnectorInfo>;

        var ray = scene.createPickingRay(position.x, position.y, BABYLON.Matrix.Identity(), mainCamera);
        var pickingInfo: BABYLON.PickingInfo[] = scene.multiPickWithRay(ray, function (pickmesh) { return BABYLON.Tags.MatchesQuery(pickmesh, "connector") && pickmesh.parent !== mesh });

        pickingInfo.forEach(function (pi) {

            if (pi.pickedMesh) {

                var connectorMesh = pi.pickedMesh;
                if (connectorMesh.isEnabled()) {
                    let connectorInfo = {} as ConnectorInfo;
                    connectorInfo.entityNode = connectorMesh.parent as BABYLON.AbstractMesh;
                    connectorInfo.connectorNode = connectorMesh;
                    connectorInfo.isEnabled = connectorMesh.isEnabled();
                    connectorInfos.push(connectorInfo);
                }

            }
        });

        return connectorInfos;
    }

    let setTargetRotation = function (
        entity: Entity,
        parentNode: BABYLON.TransformNode,
        parentConnector: BABYLON.TransformNode,
        childNode: BABYLON.TransformNode,
        childConnector: BABYLON.TransformNode) {

        var parentRotation = BABYLON.Quaternion.Identity();
        parentConnector.getWorldMatrix().decompose(BABYLON.Vector3.Zero(), parentRotation, BABYLON.Vector3.Zero());

        var childRotation = BABYLON.Quaternion.Identity();
        childConnector.getWorldMatrix().decompose(BABYLON.Vector3.Zero(), childRotation, BABYLON.Vector3.Zero());

        let newRotationAngle = MathHelper.normalizePi((parentRotation.toEulerAngles().y - childRotation.toEulerAngles().y));
        let newRotation = new BABYLON.Vector3(0, newRotationAngle, 0);

        targetRotation = childNode.rotation.add(newRotation);   
        entity.rotation = targetRotation     
        childNode.computeWorldMatrix(true);
    }

   /* let animateRotation = function (node, targetRotation) {
        animRotation = BABYLON.Animation.CreateAndStartAnimation("animRotate", node, "rotation", 60, 30, node.rotation, targetRotation, BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT, easingFunction);
    }*/

    let moveEntity = function (
        entity: Entity,
        parentNode: BABYLON.TransformNode,
        parentConnector: BABYLON.TransformNode,
        childNode: BABYLON.TransformNode,
        childConnector: BABYLON.TransformNode) {

        if (!childConnector || !parentConnector)
            return;

        parentNode.computeWorldMatrix(true);
        parentConnector.computeWorldMatrix(true);
        childConnector.computeWorldMatrix(true);

        var parentRotation = BABYLON.Quaternion.Identity();
        parentConnector.getWorldMatrix().decompose(BABYLON.Vector3.Zero(), parentRotation, BABYLON.Vector3.Zero());

        var childRotation = BABYLON.Quaternion.Identity();
        childConnector.getWorldMatrix().decompose(BABYLON.Vector3.Zero(), childRotation, BABYLON.Vector3.Zero());

        let newRotationAngle = MathHelper.normalizePi((parentRotation.toEulerAngles().y - childRotation.toEulerAngles().y));
        let newRotation = new BABYLON.Vector3(0, newRotationAngle, 0);
      
        childNode.rotation.addInPlace(newRotation);
        entity.rotation =  childNode.rotation;
        childConnector.computeWorldMatrix(true);

        var positionDiff = parentConnector.getAbsolutePosition().subtract(childConnector.getAbsolutePosition());     
               
        childNode.position = childNode.position.add(positionDiff);
        entity.position = childNode.position
        childNode.computeWorldMatrix(true);
    }

    let connectEntities = function (
        parentNode: BABYLON.TransformNode,
        parentConnector: BABYLON.TransformNode,
        childNode: BABYLON.TransformNode,
        childConnector: BABYLON.TransformNode) {

        var parentEntity = moduleHelper.getEntityByID(currentModule, parentNode.id);
        var childEntity = moduleHelper.getEntityByID(currentModule, childNode.id);

        if (childEntity) {
            var childConnection = childEntity.connections.find(function (c) { return c.id === childConnector.name });
            if (childConnection) {
                var index = childEntity.connections.indexOf(childConnection);
                childEntity.connections.splice(index, 1);
            }

            if (parentEntity) {
                childEntity.connections.push({ id: childConnector.name, entityId: parentEntity.id });
            }
        }

        if (parentEntity) {
            var parentConnection = parentEntity.connections.find(function (c) { return c.id === parentConnector.name });
            if (parentConnection) {
                var index = parentEntity.connections.indexOf(parentConnection);
                parentEntity.connections.splice(index, 1);
            }

            if (childEntity) {
                parentEntity.connections.push({ id: parentConnector.name, entityId: childEntity.id });
            }
        }
    }

    let instantiateModule = function (configuration: Configuration, module?: Module, callback?: ModuleCreateCallback) {

        let moduleNode: BABYLON.TransformNode = null;

        if (!module) {

            module = {} as Module;
            module.id = "module" + Date.now();
            module.position = BABYLON.Vector3.Zero();
            module.rotation = BABYLON.Vector3.Zero();
            module.entities = [];

            configuration.data.modules.push(module);
        }

        moduleNode = scene.getTransformNodeByUniqueId(module.uniqueId);
        if (!moduleNode) {
            moduleNode = new BABYLON.TransformNode(module.id, scene);
            module.uniqueId = moduleNode.uniqueId;
            BABYLON.Tags.AddTagsTo(moduleNode, "module");
        }

        moduleNode.position = new BABYLON.Vector3(module.position._x, module.position._y, module.position._z);
        moduleNode.rotation = new BABYLON.Vector3(module.rotation._x, module.rotation._y, module.rotation._z);
        moduleNode.metadata = {};
        moduleNode.metadata.meshtype = "module";
        moduleNode.parent = modulesNode;
        moduleNode.computeWorldMatrix(true);

        if (callback) {
            callback(module, moduleNode);
        }

        return { module, moduleNode }
    }

    let instantiateEntity = function (
        module: Module,
        product: Product,
        entity?: Entity,
        callback?: EntityCreateCallback) {

        var moduleNode = scene.getTransformNodeByUniqueId(module.uniqueId);

        if (!entity) {

            entity = {} as Entity;
            entity.id = "entity" + Date.now();
            entity.connections = [];
            entity.connectors = [];
            entity.position = BABYLON.Vector3.Zero();
            entity.rotation = BABYLON.Vector3.Zero();
            entity.productNo = product.productNo;
            entity.parentId = moduleNode.id;
            entity.category = product.type;

            module.entities.push(entity);
        }

        //Entity node
        let entityNode = new BABYLON.TransformNode(entity.id, scene);
        entity.uniqueId = entityNode.uniqueId;
        entityNode.metadata = {};
        entityNode.metadata.meshtype = "entity";
        entityNode.metadata.productNo = entity.productNo;
        entityNode.rotation = BABYLON.Vector3.Zero();

        entityNode.computeWorldMatrix(true);

        var entityAttachNode = null;
        if (entity.attachId) {
            var parentNode = scene.getNodeById(entity.parentId);
            entityAttachNode = parentNode.getChildren(function (c) { return c.id === entity.attachId }, false)[0];
        } else {
            entityAttachNode = moduleNode;
        }

        entityNode.parent = entityAttachNode;

        BABYLON.Tags.EnableFor(entityNode);
        BABYLON.Tags.AddTagsTo(entityNode, "entity");

        //Entitybounds
        var entityBounds = BABYLON.MeshBuilder.CreateBox("entitybounds", {
            width: ConversionHelper.scale(product.width, scaleFactor) as number,
            height: ConversionHelper.scale(product.height, scaleFactor) as number,
            depth: ConversionHelper.scale(product.depth, scaleFactor) as number
        }, scene);
        var entityExtendSize = entityBounds.getBoundingInfo().boundingBox.extendSize;
        entityBounds.position.addInPlace(new BABYLON.Vector3(0, 0, entityExtendSize.z));
    
        entityBounds.parent = entityNode;        
        entityBounds.visibility = 0.5;
        entityBounds.isPickable = true;
        entityBounds.setEnabled(false);

        entityBounds.setPivotMatrix(BABYLON.Matrix.Translation(0, entityBounds.getBoundingInfo().boundingBox.extendSize.y, 0), false);
        entityNode.setPivotPoint(entityBounds.position, BABYLON.Space.LOCAL);
        entityNode.computeWorldMatrix(true);

        BABYLON.Tags.EnableFor(entityBounds);
        BABYLON.Tags.AddTagsTo(entityBounds, "entitybounds");

        if (productLibrary.getProductCategory(entity.category) === "UPHOLSTRY") {

            //Create center
            createCenter(module, entity, scene);

            //Create actions for entity
            createEntityActions(module, entity, scene, product);

            //Create connectors for entity
            createEntityConnectors(module, entity, product, scene);   
        }

        entityNode.position = ConversionHelper.toVector3(entity.position);
        entityNode.rotation = ConversionHelper.toVector3(entity.rotation);

        if (callback) {
            callback(entity, entityNode, entity.productNo);
        }
      
        return { entity, entityNode }
    }

    let createFreestandingAttachments = function (entity: Entity, entityNode: BABYLON.TransformNode, positionX: number, positionZ: number, offsetX: number, offsetZ: number) {

        createAttachmentPoint("left_front", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), BABYLON.Vector3.One());
        createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
        createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
        createAttachmentPoint("right_front", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
    }

    let createLegAttachments = function (module: Module, entity: Entity, product: Product, scene: BABYLON.Scene) {

        var entityConnectionType = moduleHelper.getEntityConnectionType(module, entity);
        const adjacentEntities =  entityHelper.getAdjacentEntities(module, entity, scene);       

        var seriesDepth = ConversionHelper.scale(getSeriesDepth(), scaleFactor) as number;
        var series = seriesLibrary.getSeriesById(product.series);

        var rotationSingle = 0;
        var offsetFrontSingle = 0;        
        var offsetSideSingle = 0;

        var legProductSingle = seriesLibrary.getSeriesLeg(series, "standard", "lt01");
        if (legProductSingle) {
            rotationSingle = legProductSingle.legRotation;
            offsetFrontSingle = ConversionHelper.scale(legProductSingle.legOffsetFromFront, scaleFactor) as number || 0;
            offsetSideSingle = ConversionHelper.scale(legProductSingle.legOffsetFromSide, scaleFactor) as number || 0;
        }

        var rotationConnection = 0;
        var offsetFrontConnection = 0;
        var offsetSideConnection = 0;
        
        var legProductConnection = seriesLibrary.getSeriesLeg(series, "standard", "lt02");
        if (legProductConnection) {
            rotationConnection = legProductConnection.legRotation;
            offsetFrontConnection = ConversionHelper.scale(legProductSingle.legOffsetFromFront, scaleFactor) as number || 0;
            offsetSideConnection = ConversionHelper.scale(legProductSingle.legOffsetFromSide, scaleFactor) as number || 0;
        }

        var entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);        
        if (entityNode) {

            var entityBounds = entityNode.getChildMeshes(true, function (m) { return m.id === "entitybounds" })[0];
            entityBounds.refreshBoundingInfo()
            var bv = entityBounds.getHierarchyBoundingVectors(true);
            var bb = new BABYLON.BoundingBox(bv.min, bv.max);

            var offsetX = 0;
            var offsetZ = 0;

            let rotationMatrix = BABYLON.Matrix.RotationYawPitchRoll(-entity.rotation._y, entity.rotation._x, entity.rotation._z);            
            let entityExtendSize = BABYLON.Vector3.TransformCoordinates(bb.extendSize, rotationMatrix);    

            var positionX = Math.abs(entityExtendSize.x);
            var positionZ = Math.abs(entityExtendSize.z) * 2;

            let rightOffsetZ = positionZ;
            let rightDepth = 0;
            let entityRight = adjacentEntities.find(x => ["RIGHT", "RIGHT_BACK"].includes(x.direction));
            if (!entityRight)
                entityRight = adjacentEntities.find(x => ["RIGHT_FRONT"].includes(x.direction));

            let entityRightConnectionType = ""

            if (entityRight) {
                const entityProductRight = productLibrary.getProductByProductNo(entityRight.entity.productNo);
                const rightBb = entityHelper.getEntityBoundingBox(entityRight.entity, scene);
                let entityExtendSize = BABYLON.Vector3.TransformCoordinates(rightBb.extendSize, rotationMatrix);    
                rightDepth = entityProductRight.depth;
                rightOffsetZ = Math.abs(entityExtendSize.z) * 2;

                entityRightConnectionType = moduleHelper.getEntityConnectionType(module, entityRight.entity);
            }  
            
            let leftOffsetZ = positionZ;
            let leftDepth = 0;
            let entityLeft = adjacentEntities.find(x => ["LEFT","LEFT_BACK"].includes(x.direction));
            if (!entityLeft)
                entityLeft = adjacentEntities.find(x => ["LEFT_FRONT"].includes(x.direction));

            let entityLeftConnectionType = ""
         
            if (entityLeft) {
                const entityProductLeft = productLibrary.getProductByProductNo(entityLeft.entity.productNo);
                const leftBb = entityHelper.getEntityBoundingBox(entityLeft.entity, scene);
                let entityExtendSize = BABYLON.Vector3.TransformCoordinates(leftBb.extendSize, rotationMatrix);  
                leftDepth = entityProductLeft.depth;
                leftOffsetZ = Math.abs(entityExtendSize.z) * 2;

                entityLeftConnectionType = moduleHelper.getEntityConnectionType(module, entityLeft.entity);
            }   

            let entityFront =  adjacentEntities.find(x => ["FRONT"].includes(x.direction));
            let entityBack =  adjacentEntities.find(x => ["BACK"].includes(x.direction));

            //Ares
            if ([148881].includes(series.id)) { 
                createFreestandingAttachments(entity, entityNode, positionX, positionZ, offsetX, offsetZ);
                return;
            }

            //Has connections! 
            switch (entity.category) {

                case "CENTER_SECTION":
                case "CENTER_SECTION_LEFT_SHORTBACK":
                case "CENTER_SECTION_RIGHT_SHORTBACK":
                case "CENTER_SECTION_WO_BACK":
                case "COMBI_SECTION_LEFT_SHORTBACK":
                case "COMBI_SECTION_RIGHT_SHORTBACK":    {

                    switch (entityConnectionType) {                      
                        case "CT02": {
                            let legFrontType = "lt02";

                            if (rightDepth > 0 && product.depth > rightDepth) {                                                    
                                createAttachmentPoint("right_center", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, rightOffsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                                legFrontType = "lt01"
                            }

                            if (leftDepth > 0 && product.depth > leftDepth) {
                                createAttachmentPoint("left_front", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), BABYLON.Vector3.One());
                            }

                            createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                            createAttachmentPoint("right_front", `leg ${legFrontType}`, entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                        }
                            break;
                        case "CT03": {
                            if (leftDepth > 0 && product.depth > leftDepth) {
                                createAttachmentPoint("left_front", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), BABYLON.Vector3.One());
                            }

                            createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                            createAttachmentPoint("right_front", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));  
                        }
                            break;
                        case "CT04": {
                            let legFrontType = "lt02";

                            if (rightDepth > 0 && product.depth > rightDepth) {                                                    
                                createAttachmentPoint("right_center", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, rightOffsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                                legFrontType = "lt01"
                            }

                            createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                            createAttachmentPoint("right_front", `leg ${legFrontType}`, entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                            createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                            createAttachmentPoint("left_front", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), BABYLON.Vector3.One());
                        }
                            break;

                        case "CT37":
                        case "CT38":
                        case "CT39":   
                        case "CT40":    
                            createAttachmentPoint("left_front", "leg lt02", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                            createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ + 0.2), MathHelper.getRotationVector(-Math.PI / 2, 0, BABYLON.Axis.Y), new BABYLON.Vector3(1, 1, -1));
                            createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ + 0.2), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), new BABYLON.Vector3(-1, 1, -1));
                            createAttachmentPoint("right_front", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), new BABYLON.Vector3(1, 1, -1));
                        break;    


                        default: 
                            createFreestandingAttachments(entity, entityNode, positionX, positionZ, offsetX, offsetZ);
                            break;
                    }

                }
                    break;
                case "CORNER_SECTION":
                case "CLOSING_CORNER_SECTION_LEFT":
                case "CLOSING_CORNER_SECTION_RIGHT": {

                    let cornerLegType = series.legPackages.filter(x => x.type === "LT03").length > 0 ? "LT03" : "LT01"

                    let frontOffsetZ = positionZ
                    if (leftDepth > 0 && product.depth > leftDepth) {     
                        frontOffsetZ = leftOffsetZ  
                    }
                    if (rightDepth > 0 && product.depth > rightDepth) {
                        frontOffsetZ = rightOffsetZ   
                    }

                    switch (entityConnectionType) {
                        case "CT10":
                        case "CT10_L":
                        case "CT10_R": {
                            createAttachmentPoint("left_back", `leg ${cornerLegType}`, entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                            createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                            createAttachmentPoint("right_front", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, frontOffsetZ), BABYLON.Vector3.Zero(), BABYLON.Vector3.One());
                        }
                            break;
                    }

                }
                    break;
                case "CLOSING_SECTION_LEFT":
                case "CLOSING_SECTION_LEFT_SHORTBACK": 
                case "CLOSING_SECTION_LEFT_WO_ARM": {

                    switch (entityConnectionType) {                       
                        case "CT01": {
                            createAttachmentPoint("left_front", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), BABYLON.Vector3.One());
                            createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                            createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), MathHelper.getRotationVector(Math.PI, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                            createAttachmentPoint("right_front", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), MathHelper.getRotationVector(0, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                        }
                            break;
                        case "CT05": {
                            createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                            createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                            createAttachmentPoint("right_front", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                        }
                            break;
                        case "CT08": {
                            createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                            createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), MathHelper.getRotationVector(Math.PI, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                            createAttachmentPoint("right_front", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), MathHelper.getRotationVector(0, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                        }
                            break;
                        default: 
                            createFreestandingAttachments(entity, entityNode, positionX, positionZ, offsetX, offsetZ);
                            break;
                    }

                }
                    break;
                case "CLOSING_SECTION_RIGHT":
                case "CLOSING_SECTION_RIGHT_SHORTBACK": 
                case "CLOSING_SECTION_RIGHT_WO_ARM": {
                    switch (entityConnectionType) {
                        case "CT01": {
                            createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                            createAttachmentPoint("right_front", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                        }
                            break;
                        case "CT06": {
                            createAttachmentPoint("left_front", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), BABYLON.Vector3.One());
                            createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                            createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                            createAttachmentPoint("right_front", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), MathHelper.getRotationVector(-Math.PI / 2, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                            createAttachmentPoint("middle_front", "leg lt02", entityNode, new BABYLON.Vector3((seriesDepth - positionX) - offsetX, 0, positionZ - offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                        }
                            break;
                        case "CT09": {
                            createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                            createAttachmentPoint("right_front", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), MathHelper.getRotationVector(-Math.PI / 2, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                            createAttachmentPoint("left_front", "leg lt02", entityNode, new BABYLON.Vector3((seriesDepth - positionX) - offsetX, 0, positionZ - offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                        }
                            break;
                        default: 
                            createFreestandingAttachments(entity, entityNode, positionX, positionZ, offsetX, offsetZ);
                            break;
                    }
                }
                    break;
                case "CHAISELONG_LEFT":
                case "CHAISELONG_LEFT_WO_ARM":    
                case "CHAISELONG_RIGHT": 
                case "CHAISELONG_RIGHT_WO_ARM": {

                     switch (entityConnectionType) {       
                                  
                        case "CT01": {

                            if (entity.connections.length === 0) {
                                 createFreestandingAttachments(entity, entityNode, positionX, positionZ, offsetX, offsetZ); 
                            }
 
                            if (entityLeft) {                               

                                createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                                createAttachmentPoint("right_front", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                                createAttachmentPoint("left_front", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), BABYLON.Vector3.One());    
                            }
                            if (entityRight) {

                                let legFrontType = "lt02"

                                if (rightDepth > 0 && product.depth > rightDepth) {                                                    
                                    createAttachmentPoint("right_center", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, rightOffsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                                    legFrontType = "lt01"
                                }

                                createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                                createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                                createAttachmentPoint("right_front", `leg ${legFrontType}`, entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                                createAttachmentPoint("left_front", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), BABYLON.Vector3.One());
                            }
                         }
                        break;
                        default: 
                            createFreestandingAttachments(entity, entityNode, positionX, positionZ, offsetX, offsetZ);
                            break;
                     }
                }
                break;
                case "SOFA":
                case "SOFA_LEFT":
                case "SOFA_RIGHT": 
                case "SOFA_SECTIONAL": {

                    switch (entityConnectionType) {                      
                        case "CT05": {
                            createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                            createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                            createAttachmentPoint("right_front", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                        }
                            break;
                        case "CT06": {
                            createAttachmentPoint("left_front", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), BABYLON.Vector3.One());
                            createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                            createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                            createAttachmentPoint("right_front", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), MathHelper.getRotationVector(-Math.PI / 2, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                            createAttachmentPoint("middle_front", "leg lt02", entityNode, new BABYLON.Vector3((seriesDepth - positionX) - offsetX, 0, positionZ - offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                        }
                            break;
                        case "CT07": {
                            createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                            createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                            createAttachmentPoint("right_front", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), MathHelper.getRotationVector(-Math.PI / 2, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                            createAttachmentPoint("middle_front", "leg lt02", entityNode, new BABYLON.Vector3((seriesDepth - positionX) - offsetX, 0, positionZ - offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                        }
                            break;
                        default: 
                            createFreestandingAttachments(entity, entityNode, positionX, positionZ, offsetX, offsetZ);
                            break;
                    }
                }
                    break;
                case "FOOTSTOOL": {
                    switch (entityConnectionType) {

                        case "CT00": {

                            const regex = /(Ø{1}(\({1}.*\){1}))|(Ø{1}\d.+)/g
                            const isRound = regex.test(product.name)

                            if (isRound) {                                           
                              
                                var bbx = entityNode.getHierarchyBoundingVectors(true);
                                var bb = new BABYLON.BoundingBox(bbx.min, bbx.max);
                                var radius = Math.abs(bb.extendSize.x);

                                var center = entityNode.getChildTransformNodes(true, n => n.id === "center")[0];

                                createAttachmentPoint("left_back", "leg lt01", entityNode, MathHelper.getCircleXYZ(0,radius, center.position), MathHelper.getRotationVector(Math.PI / 4, 0, BABYLON.Axis.Y), new BABYLON.Vector3(1, 1, 1));
                                createAttachmentPoint("right_back", "leg lt01", entityNode, MathHelper.getCircleXYZ((Math.PI*2)*0.25, radius, center.position), MathHelper.getRotationVector(Math.PI / 4, 0, BABYLON.Axis.Y), new BABYLON.Vector3(-1, 1, 1));
                                createAttachmentPoint("right_front", "leg lt01", entityNode, MathHelper.getCircleXYZ(Math.PI, radius,center.position), MathHelper.getRotationVector(Math.PI / 4, 0, BABYLON.Axis.Y), new BABYLON.Vector3(-1, 1, -1));
                                createAttachmentPoint("left_front", "leg lt01", entityNode,  MathHelper.getCircleXYZ((Math.PI*2)*0.75,radius, center.position), MathHelper.getRotationVector(Math.PI / 4, 0, BABYLON.Axis.Y), new BABYLON.Vector3(1, 1, -1));


                             } else {

                                createFreestandingAttachments(entity, entityNode, positionX, positionZ, offsetX, offsetZ);

                               /* if (product.width >= product.depth && product.width <= seriesDepth) {
                                    createFreestandingAttachments(entity, entityNode, positionX, positionZ, offsetX, offsetZ);
                                } else {
                                    createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), new BABYLON.Vector3(-1, 1, 1));
                                    createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), new BABYLON.Vector3(1, 1, 1));
                                    createAttachmentPoint("right_front", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), new BABYLON.Vector3(1, 1, -1));
                                    createAttachmentPoint("left_front", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), new BABYLON.Vector3(-1, 1, -1));
                                }*/
                            }
                        }
                            break;
                        case "CT02": {
                            createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                            createAttachmentPoint("right_front", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, seriesDepth - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                        }
                            break;
                        case "CT03": {
                            createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                            createAttachmentPoint("right_front", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, seriesDepth - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                        }
                            break;
                        case "CT04": {
                            createAttachmentPoint("left_front", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, seriesDepth - offsetZ), BABYLON.Vector3.Zero(), BABYLON.Vector3.One());
                            createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                            createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                            createAttachmentPoint("right_front", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, seriesDepth - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                        }
                            break;
                        case "CT10": {
                         
                            if (entityFront && entityRight) {                              
                                createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                                createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                                createAttachmentPoint("right_front", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, seriesDepth - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));                                                       
                            }

                            if (entityFront && entityLeft) {    
                                createAttachmentPoint("left_front", "leg lt02", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, seriesDepth - offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                                createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                                createAttachmentPoint("right_front", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, seriesDepth - offsetZ), MathHelper.getRotationVector(-Math.PI / 2, 0, BABYLON.Axis.Y), new BABYLON.Vector3(-1, 1, 1));                                     
                            }                            
                                                   
                        }
                            break;
                        case "CT11": {
                            if (product.width !== product.depth) {
                                if (entity.connections.map(x => x.id).includes("CT03")) {
                                    createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                                    createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                                } else {                              
                                    createAttachmentPoint("left_front", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), BABYLON.Vector3.One());
                                    createAttachmentPoint("left_back", "leg lt02", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), MathHelper.getRotationVector(-Math.PI / 2, 0, BABYLON.Axis.Y), new BABYLON.Vector3(1, 1, -1));
                                    createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), MathHelper.getRotationVector(-Math.PI / 2, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                                    createAttachmentPoint("right_front", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                                }
                            } else {
                                if (entity.connections.map(x => x.id).includes("CT03")) {
                                    createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), new BABYLON.Vector3(1, 1, -1));
                                    createAttachmentPoint("right_front", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, seriesDepth - offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), new BABYLON.Vector3(-1, 1, -1));
                                } else {
                                    createAttachmentPoint("left_front", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, seriesDepth - offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), new BABYLON.Vector3(-1, 1, 1));
                                    createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                                    createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                                    createAttachmentPoint("right_front", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, seriesDepth - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));

                                }

                            }
                        }
                            break;
                    }
                }
                    break;
                case "BACK": {

                      if ([148882,157547,157546].includes(product.series)) {

                        switch (entityConnectionType) {
                            case "CT12":
                            case "CT34":
                            case "CT35":    
                            case "CT36":
                                createAttachmentPoint("left_front", "leg lt02", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                                createAttachmentPoint("left_back", "leg lt02", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), MathHelper.getRotationVector(-Math.PI / 2, 0, BABYLON.Axis.Y), new BABYLON.Vector3(1, 1, -1));
                                createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), new BABYLON.Vector3(-1, 1, -1));
                                createAttachmentPoint("right_front", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), new BABYLON.Vector3(1, 1, -1));
                                break;
                            case "CT37":
                            case "CT38":
                            case "CT39":   
                            case "CT40":    
                                createAttachmentPoint("left_front", "leg lt02", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                                createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ + 0.2), MathHelper.getRotationVector(-Math.PI / 2, 0, BABYLON.Axis.Y), new BABYLON.Vector3(1, 1, -1));
                                createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ + 0.2), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), new BABYLON.Vector3(-1, 1, -1));
                                createAttachmentPoint("right_front", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), new BABYLON.Vector3(1, 1, -1));
                            break;
                            default: 
                                createFreestandingAttachments(entity, entityNode, positionX, positionZ, offsetX, offsetZ);
                                break;
                        }
                    }
                }
                    break;
                case "ARM":
                case "ARM_LEFT":
                case "ARM_RIGHT": {

                    if ([148882,157547,157546].includes(product.series)) {
                  
                        switch (entityConnectionType) {
                            case "CT45":
                            case "CT48":
                                createAttachmentPoint("left_front", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                                createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                                createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));                             
                                createAttachmentPoint("right_front", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, 1));

                                if (product.depth >= 120) {
                                    createAttachmentPoint("right_center", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ/2 - offsetZ - offsetFrontConnection), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                                }
                                break;
                            case "CT44":
                            case "CT47":
                                createAttachmentPoint("left_front", "leg lt02", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                                createAttachmentPoint("left_back", "leg lt02", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                                createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                                createAttachmentPoint("right_front", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, 1));

                                if (product.depth >= 120) {
                                    createAttachmentPoint("left_center", "leg lt02", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ/2 - offsetZ - offsetFrontConnection), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                                }
                                break;
                            case "CT46": 
                            case "CT49": 
                                createAttachmentPoint("left_front", "leg lt02", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                                createAttachmentPoint("left_back", "leg lt02", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                                createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                                createAttachmentPoint("right_front", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, 1));

                                 if (product.depth >= 120) {                                 
                                    createAttachmentPoint("left_center", "leg lt02", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ/2 - offsetZ - offsetFrontConnection), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                                    createAttachmentPoint("right_center", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ/2 - offsetZ - offsetFrontConnection), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                                }
                                break;
                            default: 
                                createFreestandingAttachments(entity, entityNode, positionX, positionZ, offsetX, offsetZ);
                                break;
                        }
                    } else {

                          switch (entityConnectionType) {

                            case "CT02": {                                
                                createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                                createAttachmentPoint("right_front", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));    
                            }
                                break;
                            case "CT03": {
                                if (product.width >= 40) { 
                                    createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                                    createAttachmentPoint("right_front", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));  
                                }                             
                            }
                                break;
                            case "CT04": {
                                createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                                createAttachmentPoint("right_front", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));

                                if (product.width >= 40) { 
                                    createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                                    createAttachmentPoint("left_front", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), BABYLON.Vector3.One());
                                }
                            }
                                break;
                            default: 
                                createFreestandingAttachments(entity, entityNode, positionX, positionZ, offsetX, offsetZ);
                                break;
                        }
                    }
                }
                    break;               
                case "SEATFRAME": {                  
                  
                    //Bure
                    if ([148882,157547,157546].includes(product.series)) {            
                        
                        //Single legs 
                        createAttachmentPoint("left_front_single", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ - offsetFrontSingle*2), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), BABYLON.Vector3.One());
                        createAttachmentPoint("right_front_single", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ - offsetFrontSingle*2), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), new BABYLON.Vector3(1, 1, -1));                              
                                                        
                        if (!entity.connections.map(x => x.id).includes("CT11")) {
                            createAttachmentPoint("left_back_single", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ + offsetFrontSingle*2), MathHelper.getRotationVector(-Math.PI / 2, 0, BABYLON.Axis.Y), new BABYLON.Vector3(1, 1, -1));
                            createAttachmentPoint("right_back_single", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ + offsetFrontSingle*2), MathHelper.getRotationVector(Math.PI / 2, 0, BABYLON.Axis.Y), new BABYLON.Vector3(-1, 1, -1));
                        }

                        let frontOffsetZ = positionZ
                        if (leftDepth > 0 && product.depth > leftDepth) {        
                            if (entityLeft.entity.category === "SEATFRAME")                 
                                frontOffsetZ = leftOffsetZ  
                        }
                        if (rightDepth > 0 && product.depth > rightDepth) {  
                            if (entityRight.entity.category === "SEATFRAME")                              
                                frontOffsetZ = rightOffsetZ   
                        }  

                        switch (entityConnectionType) {
                            case "CT02": {

                                if (leftDepth > 0 && product.depth < leftDepth) {    
                                    createAttachmentPoint("left_front", "leg lt02", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                                    createAttachmentPoint("left_back", "leg lt02", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                                }

                                if (rightDepth > 0 && product.depth <= rightDepth) {
                                    createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                                    createAttachmentPoint("right_front", `leg lt02`, entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, 1));                                                        
                                }                     
                               
                            }
                            break;
                            case "CT03": {
                                if ((leftDepth > 0 && product.depth < leftDepth)) {                                 
                                    createAttachmentPoint("left_front", "leg lt02", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                                    createAttachmentPoint("left_back", "leg lt02", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));                                   
                                }
                            }
                            break;
                            case "CT44": {
                               
                                if (adjacentEntities.filter(x => x.direction === "LEFT").map(x => x.entity.category).includes("BACK")) {              
                                    createAttachmentPoint("left_front", "leg lt02", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                                    createAttachmentPoint("left_back", "leg lt02", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                                }                              

                                if ((rightDepth > 0 && product.depth <= rightDepth)) {                                  
                                    createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                                    createAttachmentPoint("right_front", `leg lt02`, entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, 1));                                  
                                }
                           
                            }
                                break;
                            case "CT04": 
                            {
                                 if ((rightDepth > 0 && product.depth <= rightDepth)) {                                 
                                    createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                                    createAttachmentPoint("right_front", `leg lt02`, entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, 1));                                  
                                 }
                            }
                            break;
                            case "CT45": {

                              
                               if (adjacentEntities.filter(x => x.direction === "RIGHT").map(x => x.entity.category).includes("BACK")) {                      
                                    createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                                    createAttachmentPoint("right_front", `leg lt02`, entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, 1));  
                               }   
                               
                               if ((leftDepth > 0 && product.depth < leftDepth)) {                                  
                                    createAttachmentPoint("left_front", "leg lt02", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                                    createAttachmentPoint("left_back", "leg lt02", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));                                 
                                }
                               
                            }
                                break;
                            case "CT11":  
                            case "CT25":
                            case "CT26":     
                            case "CT36":                          
                            case "CT41":     
                                     
                                if (adjacentEntities.filter(x => x.direction === "LEFT").map(x => x.entity.category).includes("BACK") ||
                                    (leftDepth > 0 && product.depth < leftDepth) && entity.connections.map(x => x.id).includes("CT03")) {                                                
                                    createAttachmentPoint("left_front", "leg lt02", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                                    createAttachmentPoint("left_back", "leg lt02", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                                }                              

                                if ( adjacentEntities.filter(x => x.direction === "RIGHT").map(x => x.entity.category).includes("BACK") ||
                                   (rightDepth > 0 && product.depth <= rightDepth) && entity.connections.map(x => x.id).includes("CT04")) {  
                                    createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                                    createAttachmentPoint("right_front", `leg lt02`, entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, 1)); 
                                } 

                                break;                          
                            case "CT46":   

                                if (adjacentEntities.filter(x => x.direction === "LEFT").map(x => x.entity.category).includes("BACK") || 
                                    (leftDepth > 0 && product.depth < leftDepth)) {       
                                    createAttachmentPoint("left_front", "leg lt02", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                                    createAttachmentPoint("left_back", "leg lt02", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1)); 
                                } 

                                if (adjacentEntities.filter(x => x.direction === "RIGHT").map(x => x.entity.category).includes("BACK") || 
                                    (rightDepth > 0 && product.depth <= rightDepth)) {                          
                                    createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                                    createAttachmentPoint("right_front", `leg lt02`, entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, 1));   
                                }

                                break;
                            default: 
                                createFreestandingAttachments(entity, entityNode, positionX, positionZ, offsetX, offsetZ);
                                break;
                        }

                     } else {
                 
                        //Default (Chaiselong etc.)
                        switch (entityConnectionType) {
                            case "CT02": {

                                let legFrontType = "lt02";

                                if (product.depth > rightDepth) {                                                    
                                   createAttachmentPoint("right_center", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, rightOffsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                                   legFrontType = "lt01"
                                }

                                if (product.depth > leftDepth) {
                                    createAttachmentPoint("left_front", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), BABYLON.Vector3.One());
                                }

                                createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                                createAttachmentPoint("right_front", `leg ${legFrontType}`, entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                              

                            }
                                break;
                            case "CT03": {  

                                if (product.depth > leftDepth) {
                                    createAttachmentPoint("left_front", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), BABYLON.Vector3.One());
                                }

                                createAttachmentPoint("right_back", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                                createAttachmentPoint("right_front", "leg lt01", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));  


                            }
                                break;
                            case "CT04": {

                                let legFrontType = "lt02";

                                if (product.depth > rightDepth) {                                                    
                                   createAttachmentPoint("right_center", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, rightOffsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                                   legFrontType = "lt01"
                                }

                                createAttachmentPoint("right_back", "leg lt02", entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, -1));
                                createAttachmentPoint("right_front", `leg ${legFrontType}`, entityNode, new BABYLON.Vector3(-positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(-1, 1, 1));
                                createAttachmentPoint("left_back", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, offsetZ), BABYLON.Vector3.Zero(), new BABYLON.Vector3(1, 1, -1));
                                createAttachmentPoint("left_front", "leg lt01", entityNode, new BABYLON.Vector3(positionX - offsetX, 0, positionZ - offsetZ), BABYLON.Vector3.Zero(), BABYLON.Vector3.One());

                            }
                                break;
                            default: 
                                createFreestandingAttachments(entity, entityNode, positionX, positionZ, offsetX, offsetZ);
                                break;
                        }

                     }
                }
                    break;
                case "CHAIR": 
                case "CHAIR_LEFT": 
                case "CHAIR_RIGHT": {
                    createFreestandingAttachments(entity, entityNode, positionX, positionZ, offsetX, offsetZ);
                }
                    break;
                default: 
                    createFreestandingAttachments(entity, entityNode, positionX, positionZ, offsetX, offsetZ);
                    break;
            }
        }
    }

    let createAttachmentPoint = function (id: string, tags: string, parent: BABYLON.TransformNode | BABYLON.AbstractMesh, position: BABYLON.Vector3, rotation: BABYLON.Vector3, scaling: BABYLON.Vector3): BABYLON.TransformNode {

        let attachmentNode = new BABYLON.TransformNode(parent.id + "_attachment_" + id, scene);

        attachmentNode.parent = parent;
        attachmentNode.rotation = rotation;
        attachmentNode.position = position;
        attachmentNode.scaling = scaling;

        BABYLON.Tags.EnableFor(attachmentNode);
        BABYLON.Tags.AddTagsTo(attachmentNode, tags);

        return attachmentNode;
    }
    
    let adjustLegAttachments = function(module: Module) {

        //const firstEntity =  moduleHelper.getFirstEntity(module);

        const filteredEntities = module.entities.filter(function (entity: Entity) { return productLibrary.getProductCategory(entity.category) === "UPHOLSTRY" });
        for (var i = 0; i < filteredEntities.length; i++)  {
            const entity = filteredEntities[i];
            const entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);
            const childNodes = entityNode.getChildTransformNodes(false, c => BABYLON.Tags.MatchesQuery(c, "lt02"));
            if (childNodes.length > 0) {
                const bv1 = entityNode.getHierarchyBoundingVectors(true);
                const bb1 = new BABYLON.BoundingBox(bv1.min, bv1.max);         

                const rightConnection = entity.connections.filter(x => ["CT04","CT06","CT39","CT01_R","CT10_R",].includes(x.id))[0];  
                if (rightConnection) {         
                    const rightConnectionEntity = moduleHelper.getEntityByID(currentModule, rightConnection.entityId);
                    const rightConnectionEntityNode = scene.getTransformNodeById(rightConnection.entityId);
                    const bv2 = rightConnectionEntityNode.getHierarchyBoundingVectors(true);
                    const bb2 = new BABYLON.BoundingBox(bv2.min, bv2.max); 
                    
                    const connector = rightConnectionEntity.connections.find(x => x.entityId === entityNode.id);
                    const connectionNode = rightConnectionEntityNode.getChildMeshes(true, x => x.name.includes(connector.id))[0];

                    for (var j = 0; j < childNodes.length; j++) {
                        const childNode = childNodes[j];                     

                        if (!childNode.name.includes("back")) {

                             if (connectionNode) {

                                const bb1length = bb1.maximum.z - bb1.minimum.z
                                const bb2length = bb2.maximum.z - bb2.minimum.z

                                if (bb1length > bb2length) {
                                    childNode.position.z = Math.floor(bb2length);
                                    childNode.computeWorldMatrix(true);
                                }                                
                              }                                           
                            
                        }
                    } 
                }
            }
        }

    }

    let createEntityWeights = function (entity: Entity) {

        var entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);
        if (entityNode) {

           // let offset = ConversionHelper.scale(30, scaleFactor) as number;

            //var weightPosition = bb.center.subtract(new BABYLON.Vector3(0, 0, offset));

            //TODO - Needs to be part of model
            /*if (bb.extendSize.x / bb.extendSize.z === 1) {
                weightPosition = bb.center.subtract(new BABYLON.Vector3(offset, 0, offset));
            }*/

           // var weightPosition = bb.center

            var cameraPos = topviewCamera.position;
            cameraPos.y = entityNode.position.y;
            cameraPos.z = 10;
            cameraPos.normalize();

            var entitytPos = rootNode.position.clone();
            entitytPos.normalize();

            var angle =  BABYLON.Vector3.GetAngleBetweenVectors(cameraPos, entitytPos, BABYLON.Vector3.Up());      

            var weight = BABYLON.MeshBuilder.CreateBox("weight", { size: 10 * scaleFactor }, scene);
            weight.setEnabled(false);           
            weight.rotation = new BABYLON.Vector3(0, Math.PI/4 + angle, 0)
            weight.parent = entityNode;           
           
        }
    }

    let getParentMesh = function (mesh: BABYLON.Node, tags?: string): BABYLON.Node {

        if (BABYLON.Tags.HasTags(mesh.parent)) {
            if (BABYLON.Tags.MatchesQuery(mesh.parent, tags)) {
                return mesh.parent;
            }
        }

        return getParentMesh(mesh.parent, tags);
    }

    let createActionButton = function (module: Module, entity: Entity, name: string, textureUrl: string, onPointerDown: any, onPointerUp: any) {

        var actionButton = new BABYLON.GUI.Image(module.id + "_" + entity.id + "_" + name, textureUrl);
        actionButton.paddingBottom = "2px";
        actionButton.paddingLeft = "2px";
        actionButton.paddingTop = "2px";
        actionButton.paddingRight = "2px";
        actionButton.width = "48px";
        actionButton.height = "48px";
        actionButton.metadata = {};
        actionButton.metadata.entityId = entity.id;
        actionButton.isEnabled = true;
        actionButton.isPointerBlocker = true;
        actionButton.alpha = 0.6;
        actionButton.onPointerEnterObservable.add(function (e, ec) {
            actionButton.alpha = 1;
        });
        actionButton.onPointerOutObservable.add(function (e, ec) {
            actionButton.alpha = 0.6;
        });
        actionButton.onPointerUpObservable.add(function (e, ec) {
            actionButton.alpha = 0.6;

            if (typeof (onPointerUp) === "function") {
                onPointerUp(e, ec);
            }
        });
        actionButton.onPointerDownObservable.add(function (e, ec) {
            actionButton.alpha = 1;
            if (typeof (onPointerDown) === "function") {
                onPointerDown(e, ec);
            }
        });
        return actionButton;

    }

    var createProgressBar = function (module, entity) {

        var entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);
        var entityBounds = entityNode.getChildMeshes(true, function (m) { return m.id === "entitybounds"; })[0];

        var progressbg = new BABYLON.GUI.Rectangle(module.id + "_" + entity.id + "_progressbg");
        progressbg.width = "100px";
        progressbg.height = "12px";
        progressbg.color = "Gray";
        // progressbg.thickness = 2;
        progressbg.background = "Gray";
        progressbg.alpha = 0.6;

        var progresspct = new BABYLON.GUI.Rectangle(module.id + "_" + entity.id + "_progresspct");
        progresspct.width = "0px";
        progresspct.height = "12px";
        progresspct.color = "Gray";
        // progresspct.thickness = 2;
        progresspct.background = "Gray";

        GUI.addControl(progressbg);
        GUI.addControl(progresspct);

        progressbg.linkWithMesh(entityBounds);
        progresspct.linkWithMesh(entityBounds);

        return progressbg;
    }

    let createCenter = function (module: Module, entity: Entity, scene: BABYLON.Scene) {

        var entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);
        if (entityNode) {
            var entityBounds = entityNode.getChildMeshes(true, function (m) { return m.id === "entitybounds" })[0];
            var entityExtendSize = entityBounds.getBoundingInfo().boundingBox.extendSize;

            var centerNode = new BABYLON.TransformNode("center", scene);
            centerNode.parent = entityNode;
            centerNode.position.addInPlace(new BABYLON.Vector3(0, 0, entityExtendSize.z));
            centerNode.setEnabled(true);
            centerNode.computeWorldMatrix(true);
        }
    }

    let createEntityActions = function (module: Module, entity: Entity, scene: BABYLON.Scene, product: Product) {

        var entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);
        if (entityNode) {

            var actionContainer = new BABYLON.GUI.StackPanel(module.id + "_" + entity.id + "_actionContainer");
            actionContainer.isVertical = false;

            //Rotate action
            let actionRotateButton = createActionButton(module, entity, "action_rotate", AppSettings.Paths.RotateIcon, function (e, ec) {

                var entityId = ec.target.metadata.entityId;
                var entity = moduleHelper.getEntityByID(module, entityId);// currentModule.entities.find(function (e) { return e.id === entityId });

                removeEntityConnections(entity);               

                entity.rotation.y += Math.PI / 2;
                currentConnector = null;
                currentEntityNode = null;
                
                constructModule(currentModule).then(() => {   

                    //validateConstruction(currentModule); 
                    //zoomToMeshHierarchy(mainCamera, currentModuleNode, scene, mainCamera.alpha, mainCamera.beta, 2); 
                  //  fitView(currentModuleNode, mainCamera);
                    handleModuleUpdating();
                });             


            }, null);
            actionContainer.addControl(actionRotateButton);

            //Delete action
            let actionDeleteButton = createActionButton(module, entity, "action_delete", AppSettings.Paths.DeleteIcon, function (e, ec) {

                var entityId = ec.target.metadata.entityId;
                var entity = moduleHelper.getEntityByID(module, entityId);

                hideEntityActions();
                deleteEntity(entity);

                constructModule(currentModule).then(() => {                            
                    zoomToMeshHierarchy(mainCamera, currentModuleNode, scene, mainCamera.alpha, mainCamera.beta, 2);
                    handleModuleUpdating();
                });

            }, null);
            actionContainer.addControl(actionDeleteButton);

            GUI.addControl(actionContainer);

            var centerNode = entityNode.getChildTransformNodes(true, function (t) { return t.id === "center" })[0];
            actionContainer.linkWithMesh(centerNode);

           /* var labelContainer = new BABYLON.GUI.Rectangle(module.id + "_" + entity.id + "_label");
            labelContainer.width = "220px";
            labelContainer.height = "52px";
            labelContainer.cornerRadius = 4;
            labelContainer.color = "black";
            labelContainer.thickness = 1;
            labelContainer.background = "white";
            GUI.addControl(labelContainer);
            labelContainer.linkWithMesh(centerNode);
            labelContainer.linkOffsetY = -16;

            labelContainer.isVisible = false;

            var productVariant = productLibrary.getProductVariantByConnectionType(product, moduleHelper.getEntityConnectionType(module, entity));

            var text1 = new BABYLON.GUI.TextBlock(module.id + "_" + entity.id + "_productNo");
            text1.text = product.productNo.replace("/", "/\r\n") + "\r\n" + productVariant.axProductNo;
            text1.color = "black";
            text1.fontSize = 14;
            labelContainer.addControl(text1);*/
        }
    }

    let detectCircular = function (entityId: string) {

        let traversed = [] as Array<string>;

        //Detect
        let detect = function (entityId: string, previousId: string) {

            if (entityId) {

                var entity = moduleHelper.getEntityByID(currentModule, entityId);
                if (entity) {

                    if (traversed.indexOf(entityId) !== -1) {
                        return true;
                    }

                    traversed.push(entityId);

                    let filteredConnections = entity.connections.filter(function (e) { return e.entityId != previousId });

                    for (var i = 0; i < filteredConnections.length; i++) {

                        var connectedEntity = moduleHelper.getEntityByID(currentModule, filteredConnections[i].entityId);
                        if (connectedEntity) {
                            if (detect(connectedEntity.id, entityId)) {
                                return true;
                            }
                        }
                    }
                }
                return false;
            }
        }
        return detect(entityId, null);
    }

    let getConnectedConnectorInfo = function (entity: Entity) {

        let connectors = [];

        let entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);
        if (entityNode) {

            //Iterate entity connections
            entity.connections.forEach(function (cn) {

                let connectedEntity = moduleHelper.getEntityByID(currentModule, cn.entityId) as Entity;
                if (connectedEntity) {

                    //Connected entity node
                    let connectedEntityNode = scene.getTransformNodeByUniqueId(connectedEntity.uniqueId);
                    var connectedEntityConnection = connectedEntity.connections.find(c => { return c.entityId === entity.id });
                    if (connectedEntityConnection) {
                        var connectedEntityConnector = connectedEntity.connectors.find(c => { return c.id === connectedEntityConnection.id });
                        var connectedEntityConnectorNode = connectedEntityNode.getChildMeshes(true, function (childNode) { return childNode.name === connectedEntityConnector.id })[0];
                        connectors.push({ mesh: connectedEntityNode, connector: connectedEntityConnectorNode, weight: 0 });
                    }
                }
            });
        }

        return connectors;
    }

    let moveConnectedEntities = function (entity: Entity, traversedIds: Array<string>) {

        if (!traversedIds.includes(entity.id)) {

            traversedIds.push(entity.id);

            entity.connections.forEach(function (connection) {

                let entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);
                if (entityNode) {
                    let entityConnectorNode = entityNode.getChildMeshes(true, function (c) { return c.name === connection?.id })[0];

                    var connectedEntity = moduleHelper.getEntityByID(currentModule, connection?.entityId);
                    let connectedEntityNode = scene.getTransformNodeByUniqueId(connectedEntity?.uniqueId ?? 0);
                    if (connectedEntityNode) {
                        var connectedEntityConnection = connectedEntity.connections.find(c => { return c.entityId === (entity?.id ?? 0)});
                        var connectedEntityConnector = connectedEntity.connectors.find(c => { return c.id === (connectedEntityConnection?.id ?? 0)});                
                        var connectedEntityConnectorNode = connectedEntityNode.getChildMeshes(true, function (childNode) { return childNode.name === (connectedEntityConnector?.id ?? 0)})[0];

                        if (connectedEntityConnectorNode) {
                           moveEntity(connectedEntity, entityNode, entityConnectorNode, connectedEntityNode, connectedEntityConnectorNode);
                           moveConnectedEntities(connectedEntity, traversedIds);
                        }
                    }
                }
            });
        }
    }

    let moveAllEntities = function (module: Module) {

        let traversedIds = [] as Array<string>;

        module.entities.filter(x => productLibrary.getProductCategory(x.category) === "UPHOLSTRY").forEach(function (entity) {
            if (!traversedIds.includes(entity.id)) {

                traversedIds.push(entity.id);

                let entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);

                entity.connections.forEach(function (connection) {

                    let entityConnectorNode = entityNode.getChildMeshes(true, function (c) { return c.name === connection.id })[0];

                    var connectedEntity = moduleHelper.getEntityByID(module, connection.entityId);
                    if (connectedEntity) {
                        let connectedEntityNode = scene.getTransformNodeByUniqueId(connectedEntity.uniqueId);
                        if (connectedEntityNode) {
                            var connectedEntityConnection = connectedEntity.connections.find(c => { return c.entityId === entity.id });
                            if (connectedEntityConnection) {
                                var connectedEntityConnector = connectedEntity.connectors.find(c => { return c.id === connectedEntityConnection.id });
                                if (connectedEntityConnector) {
                                    var connectedEntityConnectorNode = connectedEntityNode.getChildMeshes(true, function (childNode) { return childNode.name === connectedEntityConnector.id })[0];

                                    moveEntity(connectedEntity, entityNode, entityConnectorNode, connectedEntityNode, connectedEntityConnectorNode);
                                    moveConnectedEntities(connectedEntity, traversedIds);
                                }
                            }
                        }
                    }
                });               
            }
        });

    }

    let discoverEntityConnections = function(entity: Entity) {

        let adjacentEntities = currentModule.entities.filter(function (e) { return productLibrary.getProductCategory(e.category) === "UPHOLSTRY" })
        if (adjacentEntities) {

            removeEntityConnections(entity);

            var entityMesh = scene.getTransformNodeById(entity.id);
            entityMesh.computeWorldMatrix(true)
         
            for (let i = 0; i < entity.connectors.length; i++) {
                let connector = entity.connectors[i]
                var connectorMesh = entityMesh.getChildMeshes(true, c => c.name === connector.id)[0]; 
                 connectorMesh.computeWorldMatrix(true)         

                for(let a = 0; a < adjacentEntities.length; a++) {
                    var adjEntity = adjacentEntities[a];                    

                    if (adjEntity.id === entity.id) continue;

                    var adjEntityMesh = scene.getTransformNodeById(adjEntity.id);
                    if (adjEntityMesh)
                        adjEntityMesh.computeWorldMatrix(true)
               
                    for (let b = 0; b < adjEntity.connectors.length; b++) {
                        let adjConnector = adjEntity.connectors[b]
                        var adjConnectorMesh = adjEntityMesh.getChildMeshes(true, c => c.name === adjConnector.id)[0];  
                        adjConnectorMesh.computeWorldMatrix(true)         

                        if (BABYLON.Vector3.Distance(connectorMesh.absolutePosition, adjConnectorMesh.absolutePosition) <= 0.01) {
                            if (!entity.connections.find(x => x.id === connector.id))
                                entity.connections.push({ entityId: adjEntity.id, id: connector.id })
                           /* if (!adjEntity.connections.find(x => x.id === adjConnector.id))
                                adjEntity.connections.push({ entityId: entity.id, id: adjConnector.id })*/
                        }
                    }
                }
            }
        }
    }

    let deleteEntity = function (entity: Entity) {

        let connectors = [];

        let product = productLibrary.getProductByProductNo(entity.productNo);
        let entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);
        if (entityNode) {            
            
            cleanupResources(entityNode);

            //Are entities connected in a circular loop?
            let isCircular = detectCircular(entity.id);

            //Get connected connectorinfos
            connectors = getConnectedConnectorInfo(entity);
            if (connectors.length === 2 && !isCircular) {
                connectEntities(connectors[0].mesh, connectors[0].connector, connectors[1].mesh, connectors[1].connector);

                if (![148881].includes(product.series)) {       
                    var connectedEntity = moduleHelper.getEntityByID(currentModule, connectors[0].mesh.id);                
                    moveConnectedEntities(connectedEntity, []);
                }
            }

            //Remove entity connections
            removeEntityConnections(entity);

            //Dispose child entities
            var disposableEntities = currentModule.entities.filter(function (e) { return e.parentId === entity.id });
            disposableEntities.forEach(function (c) {
                deleteEntity(c);
            });
            
            entityNode.dispose();
            currentEntityNode = null;
            currentConnector = null;

            //Remove entity from module
            let index = currentModule.entities.indexOf(entity);
            currentModule.entities.splice(index, 1);          

        }
    }

    let cleanupResources = function (mesh: BABYLON.TransformNode | BABYLON.AbstractMesh) {

        if (mesh instanceof BABYLON.AbstractMesh && !mesh.isAnInstance) {
            if (mesh.material) {
                mesh.material.dispose(true, true);
                mesh.material = null;
            }
        }

        mesh.getChildTransformNodes(false).forEach(function (t) {
            cleanupResources(t);
        });

        mesh.getChildMeshes(false).forEach(function (m) {
            cleanupResources(m);
        });

    }

    let showEntityActions = function () {

        GUI.rootContainer.children.forEach(function (c) {

            if (currentEntityNode) {
                if (c.name.indexOf(currentModuleNode.id + "_" + currentEntityNode.id + "_actionContainer") >= 0) {
                    c.isVisible = true;
                }
            }
        });
    }

    let hideEntityActions = function () {

        GUI.rootContainer.children.forEach(function (c) {
            if (c.name.indexOf("_actionContainer") >= 0) {
                c.isVisible = false;
            }
        });
    }  

    let getDefaultDepth = function() {
        const widths = [];
        const depths = [];

        productLibrary.productsCategories.forEach((category) => {
            category.products.forEach((product) => {
            widths.push(product.width);
            depths.push(product.depth);
            });
        });

        var widthData = DataHelper.findDuplicate(widths);
        var depthData = DataHelper.findDuplicate(depths);

        return widthData.repeated > depthData.repeated ? widthData.value : depthData.value;
    }

    let getDefaultHeight = function() {
        const heights = [];

        productLibrary.productsCategories.forEach((category) => {
            category.products.forEach((product) => {
                heights.push(product.height);            
            });
        });

        var heightData = DataHelper.findDuplicate(heights);
        return heightData.value
    }

    let getSeriesDepth = function (entity?: Entity, connectorId?: string): number {
        let seriesDepth = getDefaultDepth();

        if (entity) {
            const entityType = entity.category.toLowerCase();
            switch (currentConfiguration.series.toLowerCase()) {
                case "bure plain w. down top":
                case "bure plain w. fiberfill":
                case "bure wave":
                {
                    switch (entityType) {
                        case "back":
                            {
                            if (["CT38", "CT39"].includes(connectorId)) {
                                const productCategory = productLibrary.productsCategories.filter((x) => x.type.toLowerCase() === "back");
                                const product = productCategory[0].products.find((x) => x.type.toLowerCase() === "back");
                                seriesDepth = product.depth;
                            }
                            }
                            break;
                        case "seatframe": {
                            if (["CT03", "CT04"].includes(connectorId)) {
                                const productCategory = productLibrary.productsCategories.filter((x) => x.type.toLowerCase() === "back");
                                const product = productCategory[0].products.find((x) => x.type.toLowerCase() === "back");
                                seriesDepth = product.depth;
                            }
                        }
                            break;
                        case "arm": {
                            if (["CT44", "CT45"].includes(connectorId)) {
                                const productCategory = productLibrary.productsCategories.filter((x) => x.type.toLowerCase() === "back");
                                const product = productCategory[0].products.find((x) => x.type.toLowerCase() === "back");
                                seriesDepth = product.depth;
                            }
                        }
                            break;
                    }
                }
                break;
            }              
        }

        return seriesDepth;    
    }  
   
    let createEntityConnectors = function (module: Module, entity: Entity, product: Product, scene: BABYLON.Scene) {

        var entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);
        var entityBounds = entityNode.getChildMeshes(true, function (cm) { return cm.id === "entitybounds" })[0];

        //Clear connectors
        var connectorNodes = entityNode.getChildMeshes(false, function (c) { return BABYLON.Tags.MatchesQuery(c, "connector") });
        connectorNodes.forEach(function (cn, index) {
            cn.dispose();
            cn = null;
        });
        entity.connectors = [];

        if (entityNode) {

           // let entityConnectionType = moduleHelper.getEntityConnectionType(module, entity);
            let entityBoundingBox = entityBounds.getBoundingInfo().boundingBox;
            let entityConnections = entity.connections.map(x => x.id);
           
            let entityWidth = ConversionHelper.scale(product.width, scaleFactor) as number;
            var entityDepth = ConversionHelper.scale(product.depth, scaleFactor) as number;           
            let seriesDepth = ConversionHelper.scale(getSeriesDepth(), scaleFactor) as number;

            let defaultHeight = ConversionHelper.scale(getDefaultHeight(), scaleFactor) as number;

            const connectionPointOffset = 0.1

            switch (entity.category) {

                case "CENTER_SECTION":
                case "CENTER_SECTION_LEFT_SHORTBACK":
                case "CENTER_SECTION_RIGHT_SHORTBACK":
                case "CENTER_SECTION_WO_BACK": {

                    if (productLibrary.hasProductVariants(product, ["CT11"])) {
                        createEntityConnector(module, entity, entityNode, "CT11", new BABYLON.Vector3(0, defaultHeight/2, 0), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped);
                    } 
                    if (productLibrary.hasProductVariants(product, ["CT37"])) {
                        createEntityConnector(module, entity, entityNode, "CT37", new BABYLON.Vector3(0, defaultHeight/2, entityDepth), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped);
                    } 
                    if (productLibrary.hasProductVariants(product, ["CT04", "CT02"])) {
                        createEntityConnector(module, entity, entityNode, "CT04", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    }
                    if (productLibrary.hasProductVariants(product, ["CT03", "CT02"])) {
                        createEntityConnector(module, entity, entityNode, "CT03", new BABYLON.Vector3(entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    }



                }
                    break;
                case "FOOTSTOOL": {

                    if (productLibrary.hasProductVariants(product, ["CT04", "CT03"])) {

                        if (!entityConnections.includes("CT10_L")) {                            
                            createEntityConnector(module, entity, entityNode, "CT03", new BABYLON.Vector3(entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                        }

                        if (!entityConnections.includes("CT10_R")) {
                            createEntityConnector(module, entity, entityNode, "CT04", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);                      
                        }                      
                    }
                    if (productLibrary.hasProductVariants(product, ["CT10"])) {
                         let entityConnectors = entity.connectors.map(x => x.id);

                        if (entityConnectors.includes("CT03") && !entityConnections.includes("CT04") && entityConnections.length > 0) {
                            createEntityConnector(module, entity, entityNode, "CT10_R", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, entityBoundingBox.extendSize.z*2), new BABYLON.Vector3(0, Math.PI / 2, 0), product.isFlipped);
                        }
                        if (entityConnectors.includes("CT04") && !entityConnections.includes("CT03") && entityConnections.length > 0) {
                            createEntityConnector(module, entity, entityNode, "CT10_L", new BABYLON.Vector3(entityWidth / 2, defaultHeight/2, entityBoundingBox.extendSize.z*2), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped);
                        }
                    }


                }
                    break;
                case "CLOSING_SECTION_LEFT":
                case "CLOSING_SECTION_LEFT_SHORTBACK":
                case "CLOSING_SECTION_LEFT_WO_ARM": {

                    if (productLibrary.hasProductVariants(product, ["CT11"])) {
                        createEntityConnector(module, entity, entityNode, "CT11", new BABYLON.Vector3(0, defaultHeight/2, 0), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped);
                    } 
                    if (productLibrary.hasProductVariants(product, ["CT37"])) {
                        createEntityConnector(module, entity, entityNode, "CT37", new BABYLON.Vector3(0, defaultHeight/2, entityDepth), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped);
                    } 
                    if (productLibrary.hasProductVariants(product, ["CT04", "CT02"])) {
                        createEntityConnector(module, entity, entityNode, "CT04", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    }
                    if (productLibrary.hasProductVariants(product, ["CT03", "CT02"])) {
                        createEntityConnector(module, entity, entityNode, "CT03", new BABYLON.Vector3(entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    }
                    if (productLibrary.hasProductVariants(product, ["CT01", "CT08"])) {
                        createEntityConnector(module, entity, entityNode, "CT01_R", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    }
                    if (productLibrary.hasProductVariants(product, ["CT05", "CT08"])) {
                        createEntityConnector(module, entity, entityNode, "CT05", new BABYLON.Vector3(entityWidth / 2 - seriesDepth / 2, defaultHeight/2, seriesDepth), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped);
                    }

                }
                    break;
                case "CLOSING_SECTION_RIGHT":
                case "CLOSING_SECTION_RIGHT_SHORTBACK":
                case "CLOSING_SECTION_RIGHT_WO_ARM": {

                    if (productLibrary.hasProductVariants(product, ["CT11"])) {
                        createEntityConnector(module, entity, entityNode, "CT11", new BABYLON.Vector3(0, defaultHeight/2, 0), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped);
                    } 
                    if (productLibrary.hasProductVariants(product, ["CT37"])) {
                        createEntityConnector(module, entity, entityNode, "CT37", new BABYLON.Vector3(0, defaultHeight/2, entityDepth), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped);
                    } 
                    if (productLibrary.hasProductVariants(product, ["CT04", "CT02"])) {
                        createEntityConnector(module, entity, entityNode, "CT04", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    }
                    if (productLibrary.hasProductVariants(product, ["CT03", "CT02"])) {
                        createEntityConnector(module, entity, entityNode, "CT03", new BABYLON.Vector3(entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    }
                    if (productLibrary.hasProductVariants(product, ["CT06", "CT09"])) {
                        createEntityConnector(module, entity, entityNode, "CT06", new BABYLON.Vector3(-(entityWidth / 2 - seriesDepth / 2), defaultHeight/2, seriesDepth), new BABYLON.Vector3(0, Math.PI / 2, 0), product.isFlipped);
                    }
                    if (productLibrary.hasProductVariants(product, ["CT01", "CT09"])) {
                        createEntityConnector(module, entity, entityNode, "CT01_L", new BABYLON.Vector3(entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    }

                }
                    break;
                case "CHAISELONG_LEFT":
                case "CHAISELONG_LEFT_WO_ARM": {

                    if (productLibrary.hasProductVariants(product, ["CT11"])) {
                        createEntityConnector(module, entity, entityNode, "CT11", new BABYLON.Vector3(0, defaultHeight/2, 0), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped);
                    } 
                    if (productLibrary.hasProductVariants(product, ["CT37"])) {
                        createEntityConnector(module, entity, entityNode, "CT37", new BABYLON.Vector3(0, defaultHeight/2, entityDepth), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped);
                    } 
                    if (productLibrary.hasProductVariants(product, ["CT04", "CT02"])) {
                        createEntityConnector(module, entity, entityNode, "CT04", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    }
                    if (productLibrary.hasProductVariants(product, ["CT03", "CT02"])) {
                        createEntityConnector(module, entity, entityNode, "CT03", new BABYLON.Vector3(entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    }
                    if (productLibrary.hasProductVariants(product, ["CT01"])) {
                        createEntityConnector(module, entity, entityNode, "CT01_R", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    }
                }
                    break;
                case "CHAISELONG_RIGHT":
                case "CHAISELONG_RIGHT_WO_ARM":    {

                    if (productLibrary.hasProductVariants(product, ["CT11"])) {
                        createEntityConnector(module, entity, entityNode, "CT11", new BABYLON.Vector3(0, defaultHeight/2, 0), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped);
                    } 
                    if (productLibrary.hasProductVariants(product, ["CT37"])) {
                        createEntityConnector(module, entity, entityNode, "CT37", new BABYLON.Vector3(0, defaultHeight/2, entityDepth), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped);
                    } 
                    if (productLibrary.hasProductVariants(product, ["CT04", "CT02"])) {
                        createEntityConnector(module, entity, entityNode, "CT04", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    }
                    if (productLibrary.hasProductVariants(product, ["CT03", "CT02"])) {
                        createEntityConnector(module, entity, entityNode, "CT03", new BABYLON.Vector3(entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    }
                    if (productLibrary.hasProductVariants(product, ["CT01"])) {
                        createEntityConnector(module, entity, entityNode, "CT01_L", new BABYLON.Vector3(entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    }
                }
                    break;
                case "CORNER_SECTION":
                case "CLOSING_CORNER_SECTION_LEFT":
                case "CLOSING_CORNER_SECTION_RIGHT": {

                    if (productLibrary.hasProductVariants(product, ["CT11"])) {
                        createEntityConnector(module, entity, entityNode, "CT11", new BABYLON.Vector3(0, defaultHeight/2, 0), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped);
                    } 
                    if (productLibrary.hasProductVariants(product, ["CT37"])) {
                        createEntityConnector(module, entity, entityNode, "CT37", new BABYLON.Vector3(0, defaultHeight/2, entityDepth), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped);
                    } 
                    if (productLibrary.hasProductVariants(product, ["CT04", "CT02"])) {
                        createEntityConnector(module, entity, entityNode, "CT04", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    }
                    if (productLibrary.hasProductVariants(product, ["CT03", "CT02"])) {
                        createEntityConnector(module, entity, entityNode, "CT03", new BABYLON.Vector3(entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    }
                    if (productLibrary.hasProductVariants(product, ["CT10"])) {
                        createEntityConnector(module, entity, entityNode, "CT10_R", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                        createEntityConnector(module, entity, entityNode, "CT10_L", new BABYLON.Vector3(entityWidth / 2 - seriesDepth / 2, defaultHeight/2, entityDepth), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped);
                    }

                }
                    break;
                case "SOFA":
                case "SOFA_LEFT":
                case "SOFA_RIGHT":
                case "SOFA_SECTIONAL": {

                    if (productLibrary.hasProductVariants(product, ["CT06"])) {
                        createEntityConnector(module, entity, entityNode, "CT06", new BABYLON.Vector3(-(entityWidth / 2 - seriesDepth / 2), defaultHeight/2, seriesDepth), new BABYLON.Vector3(0, Math.PI / 2, 0), product.isFlipped);
                    }
                    if (productLibrary.hasProductVariants(product, ["CT05"])) {
                        createEntityConnector(module, entity, entityNode, "CT05", new BABYLON.Vector3(entityWidth / 2 - seriesDepth / 2, defaultHeight/2, seriesDepth), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped);
                    }
                }
                    break;
                case "ARM":
                case "ARM_L":
                case "ARM_R": {

                    let armXOffset = 0;

                    if ([148882,157547,157546].includes(product.series)) {
                        armXOffset = 0.03;                                            
                    }

                    var armProducts = productLibrary.productsCategories.find(x => x.type === "ARM");
                    armProducts.products.sort((a,b) => a.depth - b.depth);

                    if (productLibrary.hasProductVariants(product, ["CT44"])) {
                        seriesDepth = ConversionHelper.scale(getSeriesDepth(entity, "CT44"), scaleFactor) as number;
                        createEntityConnector(module, entity, entityNode, "CT44", new BABYLON.Vector3(entityBoundingBox.extendSize.x+armXOffset, defaultHeight/2, seriesDepth/2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);

                        if (product.depth >= 120) {
                            createEntityConnector(module, entity, entityNode, "CT44_center", new BABYLON.Vector3(entityBoundingBox.extendSize.x+armXOffset, defaultHeight/2, entityDepth/2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);     
                        }                
                    }
                    if (productLibrary.hasProductVariants(product, ["CT45"])) {

                        createEntityConnector(module, entity, entityNode, "CT45", new BABYLON.Vector3(-(entityBoundingBox.extendSize.x+armXOffset), defaultHeight/2, seriesDepth/2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                        seriesDepth = ConversionHelper.scale(getSeriesDepth(entity, "CT45"), scaleFactor) as number;

                        if (product.depth >= 120) {
                            createEntityConnector(module, entity, entityNode, "CT45_center", new BABYLON.Vector3(-(entityBoundingBox.extendSize.x+armXOffset), defaultHeight/2, entityDepth/2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);   
                        }       
                    }  
                    
                    if (productLibrary.hasProductVariants(product, ["CT04", "CT02"])) {
                        createEntityConnector(module, entity, entityNode, "CT04", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    }
                    if (productLibrary.hasProductVariants(product, ["CT03", "CT02"])) {
                        createEntityConnector(module, entity, entityNode, "CT03", new BABYLON.Vector3(entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                    }
                
                                      
                }   
                    break;
                case "SEATFRAME": {

                    if ([148882,157547,157546].includes(product.series)) {

                        if (productLibrary.hasProductVariants(product, ["CT11"])) {
                            createEntityConnector(module, entity, entityNode, "CT11", new BABYLON.Vector3(0, defaultHeight/2, 0), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped);
                        } 
                        if (productLibrary.hasProductVariants(product, ["CT37"])) {
                            createEntityConnector(module, entity, entityNode, "CT37", new BABYLON.Vector3(0, defaultHeight/2, entityDepth), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped);
                        } 
                        if (productLibrary.hasProductVariants(product, ["CT04", "CT02"])) {
                            seriesDepth = ConversionHelper.scale(getSeriesDepth(entity, "CT04"), scaleFactor) as number;
                            createEntityConnector(module, entity, entityNode, "CT04", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                        }
                        if (productLibrary.hasProductVariants(product, ["CT03", "CT02"])) {
                            seriesDepth = ConversionHelper.scale(getSeriesDepth(entity, "CT03"), scaleFactor) as number;
                            createEntityConnector(module, entity, entityNode, "CT03", new BABYLON.Vector3(entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                        }

                    } else {
                        if (productLibrary.hasProductVariants(product, ["CT11"])) {
                            createEntityConnector(module, entity, entityNode, "CT11", new BABYLON.Vector3(0, defaultHeight/2, 0), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped);
                        } 
                        if (productLibrary.hasProductVariants(product, ["CT37"])) {
                            createEntityConnector(module, entity, entityNode, "CT37", new BABYLON.Vector3(0, defaultHeight/2, entityDepth), new BABYLON.Vector3(0, -Math.PI / 2, 0), product.isFlipped);
                        } 
                        if (productLibrary.hasProductVariants(product, ["CT04", "CT02"])) {
                            createEntityConnector(module, entity, entityNode, "CT04", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                        }
                        if (productLibrary.hasProductVariants(product, ["CT03", "CT02"])) {
                            createEntityConnector(module, entity, entityNode, "CT03", new BABYLON.Vector3(entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                        }
                    }
                }   
                    break;
                case "BACK": {

                     if ([148882,157547,157546].includes(product.series)) {
                    
                        if (productLibrary.hasProductVariants(product, ["CT36"])) {
                            createEntityConnector(module, entity, entityNode, "CT36", new BABYLON.Vector3(0, defaultHeight/2, 0), new BABYLON.Vector3(0, Math.PI/2, 0), product.isFlipped);
                        }
                        if (productLibrary.hasProductVariants(product, ["CT37"])) {
                            createEntityConnector(module, entity, entityNode, "CT37", new BABYLON.Vector3(0, defaultHeight/2, entityDepth), new BABYLON.Vector3(0, -Math.PI/2, 0), product.isFlipped);
                        } 
                        if (productLibrary.hasProductVariants(product, ["CT38"])) {
                            seriesDepth = ConversionHelper.scale(getSeriesDepth(entity, "CT38"), scaleFactor) as number;
                            createEntityConnector(module, entity, entityNode, "CT38", new BABYLON.Vector3(entityWidth / 2, defaultHeight/2, (product.depth * scaleFactor) / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                        }
                        if (productLibrary.hasProductVariants(product, ["CT39"])) {
                            seriesDepth = ConversionHelper.scale(getSeriesDepth(entity, "CT39"), scaleFactor) as number;
                            createEntityConnector(module, entity, entityNode, "CT39", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, (product.depth * scaleFactor) / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                        }

                    } else {
                        if (productLibrary.hasProductVariants(product, ["CT04", "CT02"])) {
                            createEntityConnector(module, entity, entityNode, "CT04", new BABYLON.Vector3(-entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                        }
                        if (productLibrary.hasProductVariants(product, ["CT03", "CT02"])) {
                            createEntityConnector(module, entity, entityNode, "CT03", new BABYLON.Vector3(entityWidth / 2, defaultHeight/2, seriesDepth / 2), new BABYLON.Vector3(0, 0, 0), product.isFlipped);
                        }
                    }
                    
                }   
                    break;
                default: {
                }
                    break;
            }
        }
    }

    let createEntityConnector = function (module: Module, entity: Entity, entityNode: BABYLON.TransformNode, connectorName: string, position: BABYLON.Vector3, rotation: BABYLON.Vector3, isFlipped: boolean, alignment?: string) {

        if (entity.connectors.filter(function (connector) { return connector.id === connectorName }).length === 0) {
            var connectorNode = BABYLON.Mesh.CreateBox(connectorName, connectorNodeSize, scene);
            connectorNode.id = entity.id + "_" + connectorName;
            connectorNode.visibility = 0;

            connectorNode.position = position;
            connectorNode.rotation = rotation;
            connectorNode.parent = entityNode;
            connectorNode.metadata = {}
            connectorNode.metadata.meshtype = "connector";
            connectorNode.metadata.alignment = alignment;
            connectorNode.metadata.marker = module.id + "_" + entity.id + "_connector_" + connectorName;
            connectorNode.isPickable = true;

            var connectorMarker = new BABYLON.GUI.Image(module.id + "_" + entity.id + "_connector_" + connectorName, AppSettings.Paths.LinkIcon);
            connectorMarker.width = "48px";
            connectorMarker.height = "48px";
            connectorMarker.autoScale = false;
            connectorMarker.metadata = {}
            connectorMarker.metadata.connector = entity.id + "_" + connectorName;
            connectorMarker.alpha = 0;

            connectorMarker.onPointerClickObservable.add(function (data, state) {
                if (isPlacing) {
                    screenPointerPosition = new BABYLON.Vector2(scene.pointerX, scene.pointerY);
                    //showLoadingCanvas();
                    handleDragEnd();
                }
            });
            connectorMarker.onPointerEnterObservable.add(function (data, state) {
                if (isPlacing) {
                    connectorMarker.alpha = 0.6;
                }
            });
            connectorMarker.onPointerOutObservable.add(function (data, state) {
                if (isPlacing) {
                    connectorMarker.alpha = 1;
                }
            });

            GUI.addControl(connectorMarker);
            connectorMarker.linkWithMesh(connectorNode);

            BABYLON.Tags.EnableFor(connectorNode);
            BABYLON.Tags.AddTagsTo(connectorNode, "connector");

            entity.connectors.push({ id: connectorName, position: position, rotation: rotation } as Connector);
        }
    }

    let showHighlight = function (node: BABYLON.TransformNode) {
        if (node) {
            node.getChildMeshes(false).forEach(function (m) {
                m.overlayColor = BABYLON.Color3.FromHexString("#0461b0");
                m.overlayAlpha = 0.2;
                m.renderOverlay = true;
            });
        }
    }

    let hideHighlight = function (node: BABYLON.TransformNode) {
        if (node) {
            node.getChildMeshes(false).forEach(function (m) {
                m.renderOverlay = false;
            });
        }
    }

    /*let fitWeightedView = function (camera: BABYLON.ArcRotateCamera) {

        var bv = currentModuleNode.getHierarchyBoundingVectors(true, function (m) { return !BABYLON.Tags.MatchesQuery(m, "accessory") && !BABYLON.Tags.MatchesQuery(m, "entitybounds"); });
        var bb = new BABYLON.BoundingBox(bv.min, bv.max);
        var center = bb.center;

        var weightSumVector = BABYLON.Vector3.Zero();

        if (currentModule) {
            currentModule.entities.forEach(function (e) {
                var entityNode = scene.getTransformNodeByUniqueId(e.uniqueId);
                if (entityNode) {
                    var weightNode = entityNode.getChildMeshes(false, function (c) { return c.name === "weight" })[0];
                    if (weightNode) {
                        var weight = entityNode.absolutePosition.subtract(weightNode.absolutePosition);
                        weightSumVector.addInPlace(weight.normalize());
                    }
                }
            });
        }

        let directionVector = BABYLON.Vector3.Zero();

        if (Math.abs(weightSumVector.x) > Math.abs(weightSumVector.z)) {
            directionVector = new BABYLON.Vector3(1 * Math.sign(weightSumVector.x), 0, 0);
        } else {
            directionVector = new BABYLON.Vector3(0, 0, 1 * Math.sign(weightSumVector.z));
        }

        let weightedPosition = center.subtract(directionVector.scale(camera.radius));
        weightedPosition.y = bb.extendSize.y * 5;

        camera.position = weightedPosition;
        camera.rebuildAnglesAndRadius();
    }*/

   /* let fitFrontView = function(camera: BABYLON.ArcRotateCamera) {

        var bv = currentModuleNode.getHierarchyBoundingVectors(true, function (m) { return !BABYLON.Tags.MatchesQuery(m, "accessory") && !BABYLON.Tags.MatchesQuery(m, "entitybounds"); });
        var bb = new BABYLON.BoundingBox(bv.min, bv.max);
        var center = bb.center;

        var rotation = 0

         if (currentModule) {
            currentModule.entities.forEach(function (e) {
                var entityNode = scene.getTransformNodeByUniqueId(e.uniqueId);
                if (entityNode) {
                    rotation += entityNode.rotation.y;
                }
            });

            rotation = rotation/currentModule.entities.length

            //let weightedPosition = center.add(weightSumVector.scale(camera.radius));
            //weightedPosition.y = bb.extendSize.y * 10;

            //camera.position = weightedPosition;                   
            camera.beta = Math.PI/2;
            camera.alpha = rotation;
            camera.setTarget(center);    
            camera.rebuildAnglesAndRadius();       
            camera.update();
        }         
    }  */  

    /*let fitWeightedView = function(camera: BABYLON.ArcRotateCamera) {

        var bv = currentModuleNode.getHierarchyBoundingVectors(true, function (m) { return !BABYLON.Tags.MatchesQuery(m, "accessory") && !BABYLON.Tags.MatchesQuery(m, "entitybounds"); });
        var bb = new BABYLON.BoundingBox(bv.min, bv.max);
        var center = bb.center;

         var weightSumVector = BABYLON.Vector3.Zero();

         if (currentModule) {
            currentModule.entities.forEach(function (e) {
                var entityNode = scene.getTransformNodeByUniqueId(e.uniqueId);
                if (entityNode) {
                    var weightNode = entityNode.getChildMeshes(false, function (c) { return c.name === "weight" })[0];
                    if (weightNode) {
                        const dot = BABYLON.Vector3.Dot(weightNode.forward, weightSumVector);
                        if (dot >= 0) {
                            weightSumVector = BABYLON.Vector3.Lerp(weightSumVector.normalize(), weightNode.forward.normalize(), 0.5);
                        }                
                    }
                }
            });

            let weightedPosition = center.add(weightSumVector.scale(camera.radius));
            weightedPosition.y = bb.extendSize.y * 10;

            camera.position = weightedPosition;
            camera.setTarget(center);
            camera.rebuildAnglesAndRadius();
            camera.update();
        }         
    }*/

    /*let fitRenderTargetv2 = function (node: BABYLON.TransformNode, camera: BABYLON.ArcRotateCamera) {

         if (node) {

            var bv = node.getHierarchyBoundingVectors(true);
            var bs = new BABYLON.BoundingSphere(bv.min, bv.max);

            cameraTarget = bs.center;

            camera.zoomOn(node.getChildMeshes(), true)
         }

    }*/

    let fitRenderTarget = function (node: BABYLON.TransformNode, camera: BABYLON.ArcRotateCamera) {

        if (node) {

          /*  var bv = node.getHierarchyBoundingVectors(true);
            var bs = new BABYLON.BoundingSphere(bv.min, bv.max);

            cameraTarget = bs.center;

            let radius = bs.radiusWorld;
            if (radius === Infinity) {
                return;
            }

            let aspectRatio = engine.getAspectRatio(camera);
            let halfMinFov = camera.fov / 2;
            if (aspectRatio < 1) {
                halfMinFov = Math.atan(aspectRatio * Math.tan(camera.fov / 2))
            }

            let viewRadius = Math.abs(radius / Math.sin(halfMinFov));
            let radiusTarget = viewRadius;

            if (viewRadius > camera.radius) {
                 radiusTarget = viewRadius;
            }

            if (viewRadius < initialCameraRadius) {
                radiusTarget = initialCameraRadius;
            }

            camera.upperRadiusLimit = radiusTarget;
            camera.target = cameraTarget;
            camera.radius = radiusTarget;*/

            //fitFrontView(camera);
           // return fitView(node, camera);
        }
    }
    
    let getWeightedRotation = function() {
        var entities = currentModule.entities.filter(x => productLibrary.getProductCategory(x.category) === "UPHOLSTRY")

        var rotation = 0;
        entities.filter(x => productLibrary.getProductCategory(x.category) === "UPHOLSTRY").forEach(function (e) {
            var entityNode = scene.getTransformNodeByUniqueId(e.uniqueId);                   
            if (entityNode) {
                rotation += entityNode.rotation.y;
            }
        });
        rotation = Math.abs(rotation)/entities.length
        if (!rotation) rotation = 0;
        rotation += Math.PI/2;
        
        return rotation;
    }

    let zoomToMeshHierarchy = function (camera: BABYLON.ArcRotateCamera, rootMesh: BABYLON.Node, scene: BABYLON.Scene, alpha?: number | undefined, beta?: number | undefined, multiplier?: number) {
        const { min, max } = rootMesh.getHierarchyBoundingVectors(true);
        ///const bs = new BABYLON.BoundingSphere(min, max);
        const center = BABYLON.Vector3.Center(min, max);
        const radius = BABYLON.Vector3.Distance(min, max) / 2;

        camera.setTarget(center);
        
        const aspectRatio = scene.getEngine().getAspectRatio(camera);

        const halfMinFov = camera.fovMode === BABYLON.Camera.FOVMODE_VERTICAL_FIXED
            ? camera.fov / 2
            : Math.atan(Math.tan(camera.fov / 2) * Math.min(1, aspectRatio));
        
        let distance = radius / Math.sin(halfMinFov);

        if (distance === Infinity)
            return;

        distance = (multiplier) ? distance+multiplier: distance;
        camera.radius = distance;

        camera.beta = beta;
        camera.alpha = alpha;         
        
        camera.lowerRadiusLimit = 1;
        camera.upperRadiusLimit = distance*3;  
      //  camera.update();     
      //  camera.rebuildAnglesAndRadius();
    }
    

    let removeEntityConnections = function (entity: Entity) {

        if (entity) {

            //Is connected?
            if (entity.connections.length > 0) {

                let connectedEntityIds = [];

                for (var c = 0; c < entity.connections.length; c++) {

                    let con = entity.connections[c];

                    var connectedEntity = currentModule.entities.find(function (x) { return x.id === con.entityId });
                    if (connectedEntity) {
                        connectedEntity.connections.forEach(function (ec) {
                            if (ec.entityId === entity.id) {
                                connectedEntityIds.push(connectedEntity.id);
                                var index = connectedEntity.connections.indexOf(ec);
                                connectedEntity.connections.splice(index, 1);
                            }
                        });
                    }
                }

                entity.connections = entity.connections.filter(function (x) { return connectedEntityIds.indexOf(x.entityId) === -1 });
            }
        }
    }

   /* let refreshModuleBounds = function (module: Module) {

          let moduleNode = scene.getTransformNodeByUniqueId(module.uniqueId);
          if (moduleNode) {
  
              let bv = moduleNode.getHierarchyBoundingVectors(true, function (m: BABYLON.AbstractMesh) { return BABYLON.Tags.MatchesQuery(m, "entity") });
              let bb = new BABYLON.BoundingBox(bv.min, bv.max);
  
              var centerPos = new BABYLON.Vector3(bb.center.x, 0, bb.center.z);
              var positionOffset = centerPos.subtract(moduleNode.absolutePosition);
              moduleNode.position.addInPlace(positionOffset);
              moduleNode.computeWorldMatrix(true);
  
              moduleNode.getChildMeshes(true, function (entityNode) { return BABYLON.Tags.MatchesQuery(entityNode, "entity") }).forEach(function (entityNode) {
                  entityNode.setParent(null);
                  entityNode.position.subtractInPlace(positionOffset);
  
                  var entity = moduleHelper.getEntityByID(module, entityNode.id);
                  var parentNode = scene.getNodeById(entity.parentId);
  
                  entityNode.computeWorldMatrix(true);
                  entityNode.setParent(parentNode);
 
              });
          }
    }*/

    let getTargetPosition = function (screenX: number, screenY: number) {

        var target = BABYLON.Vector3.Unproject(
            new BABYLON.Vector3(screenX, screenY, 0),
            canvas.width,
            canvas.height,
            BABYLON.Matrix.Identity(),
            mainCamera.getViewMatrix(),
            mainCamera.getProjectionMatrix()
        );

        target.x = mainCamera.position.x - target.x;
        target.y = mainCamera.position.y - target.y;
        target.z = mainCamera.position.z - target.z;

        return target;

    }

  /*  let insertEntityv2 = function (connectorInfo: DragConnector) {

        var dragNode = connectorInfo.dragNode;      
        var dragNodeEntity = moduleHelper.getEntityByID(currentModule, connectorInfo.dragNode.id);
        var dragConnectorNode = connectorInfo.dragConnector;
        var dragConnector =  dragNodeEntity.connectors.find(c => { return c.id === dragConnectorNode.name });    
        
        var childNode = connectorInfo.entityNode;
        var childNodeEntity = moduleHelper.getEntityByID(currentModule, childNode.id);
        var childConnectorNode = connectorInfo.entityConnector;
        var childConnector = childNodeEntity.connectors.find(c => { return c.id === childConnectorNode.name });      

        var currentConnection = childNodeEntity.connections.find(x => x.id === childConnector.id);
        var currentConnectionEntity = moduleHelper.getEntityByID(currentModule, currentConnection.entityId);
        var currentConnectionNode = scene.getTransformNodeByUniqueId(currentConnectionEntity.uniqueId); 
        var currentConnectionEntityConnection = currentConnectionEntity.connections.find(x => x.entityId === childNode.id);       
          
        var currentConnectionEntityConnector = currentConnectionNode.getChildMeshes(true, function (m) { return m.name === currentConnectionEntityConnection.id })[0];
        var currentConnectionConnector = currentConnectionEntity.connectors.find(c => { return c.id === currentConnectionEntityConnector.name });

        var matchingConnectors = getMatchingConnectors(currentConnectionConnector, dragNodeEntity, currentConnectionEntity);
        var dragMatchConnectorNode = dragNode.getChildMeshes(true, function (m) { return matchingConnectors.includes(m.name) })[0];

        connectEntities(dragNode, dragConnectorNode, childNode, childConnectorNode);
        connectEntities(currentConnectionNode, currentConnectionEntityConnector, dragNode, dragMatchConnectorNode);

         //Transform mesh to parent position
        setTargetRotation(childNode, childConnectorNode, dragNode, dragConnectorNode);

         //Moved connected entities       
        moveConnectedEntities(childNodeEntity, []);                
    }*/

    let insertEntity = function (entity: Entity, connectorInfos: ConnectorInfo[], placement?: string) {

        var entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);

        var parentConnection = connectorInfos[0];
        var parentConnectorEntity = moduleHelper.getEntityByID(currentModule, parentConnection.entityNode.id);
        var parentConnector = parentConnectorEntity.connectors.find(c => { return c.id === parentConnection.connectorNode.name });
        var matchingConnectors = getMatchingConnectors(parentConnector, entity, parentConnectorEntity);
        var parentConnectorNodes = currentEntityNode.getChildMeshes(true, function (m) { return matchingConnectors.includes(m.name) });

        var parentPlacementConnectorNode = parentConnectorNodes[0];
        if (placement) {           
            parentPlacementConnectorNode = parentConnectorNodes.find(x => x.name.includes(placement));// currentEntityNode.getChildMeshes(true, function (m) { return matchingConnectors.includes(placement ? m.name.split("_")[0] +"_"+ placement : m.name) })[0];
        }

        var childConnection = connectorInfos[1];
        var childConnectorEntity = moduleHelper.getEntityByID(currentModule, childConnection.entityNode.id);
        var childConnector = childConnectorEntity.connectors.find(c => { return c.id === childConnection.connectorNode.name });
        var matchingConnectors = getMatchingConnectors(childConnector, entity, childConnectorEntity);
        var childConnectorNodes = currentEntityNode.getChildMeshes(true, function (m) { return matchingConnectors.includes(m.name) });

         var childPlacementConnectorNode = childConnectorNodes[0];
        if (placement) {           
            childPlacementConnectorNode = childConnectorNodes.find(x => x.name.includes(placement));// currentEntityNode.getChildMeshes(true, function (m) { return matchingConnectors.includes(placement ? m.name.split("_")[0] +"_"+ placement : m.name) })[0];
        }

        connectEntities(entityNode, parentPlacementConnectorNode, parentConnection.entityNode, parentConnection.connectorNode);
        connectEntities(childConnection.entityNode, childConnection.connectorNode, entityNode, childPlacementConnectorNode);

        //Transform mesh to parent position
        setTargetRotation(entity, childConnection.entityNode, childConnection.connectorNode, entityNode, childPlacementConnectorNode);

        //Moved connected entities       
        moveConnectedEntities(entity, []);
    }

    let weighConnection = function (module: Module, entity: Entity, connectorName: string, traversedIds: Array<number>, weight: number) {

        if (traversedIds.indexOf(entity.id) === -1) {

            traversedIds.push(entity.id);
            weight += 1;

            entity.connections.forEach(function (c) {

                if (c.id !== connectorName) {
                    var nextEntity = moduleHelper.getEntityByID(module, c.entityId);

                    if (nextEntity) {
                        nextEntity.connections.forEach(function (c) {
                            weight = weighConnection(module, nextEntity, connectorName, traversedIds, weight);
                        });
                    }
                }
            });
        }

        return weight;
    }

    let getProductVariant = function (productNo: string, entity: Entity) {

        let product = {} as Product;
        let productVariant = {} as Product; 

        let connectionType = moduleHelper.getEntityConnectionType(currentModule, entity);

        product = productLibrary.getProductByProductNo(productNo);
        
        Object.assign(productVariant, product);

        let productConnectionTypeVariant = productLibrary.getProductVariantByConnectionType(product, connectionType);

        if (!productConnectionTypeVariant) {        
            productConnectionTypeVariant = productLibrary.getProductVariantByProductNo(product);
        }

        if (productConnectionTypeVariant) {
            productVariant.productNo = productConnectionTypeVariant.productNo;
            productVariant.axProductNo = productConnectionTypeVariant.axProductNo;
            productVariant.name = productConnectionTypeVariant.name;
            productVariant.model = productConnectionTypeVariant.model ?? product.model;
            productVariant.isFlipped = productConnectionTypeVariant.isFlipped;
        }

        switch (product.type) {
            case "SOFA": {

                if (entity.connections.length === 1 && product.series === 4220) {

                    switch (productConnectionTypeVariant.connectionType) {
                        case "CT06":
                            {
                                productConnectionTypeVariant = productLibrary.getProductVariantByConnectionType(product, "CT05");
                                productVariant.model = productConnectionTypeVariant.model;
                                productVariant.isFlipped = true;
                            }
                            break;
                    }
                }
            }
                break;
            case "BACK": {

               /* const entityConnections = entity.connections.map(x => x.id);
                if (entityConnections.includes("CT36") && entityConnections.includes("CT37")) {
                    productVariant.model = productVariant.model.replace("one side","two sides");
                }  */             

            }
                break;
            case "FOOTSTOOL": {

               if (productVariant.width !== productVariant.depth) {

                    var seriesDepth = getSeriesDepth();
                    var width = productVariant.width;
                    var depth = productVariant.depth;

                    if (connectionType !== "CT11" && connectionType !== "CT00") {
                        var tmp = depth;
                        depth = width;
                        width = tmp;
                    }

                    if (width >= seriesDepth && depth >= seriesDepth) {
                        var tmp = width;
                        width = depth;
                        depth = tmp;
                    }

                    productVariant.depth = depth;
                    productVariant.width = width;
                }
            }
        }

        return productVariant;
    }

    let onProgress = function (e: any) {

        let entity = moduleHelper.getEntityByID(currentModule, e.id);

        let progressbarBg = GUI.rootContainer.getChildByName(currentModule.id + "_" + entity.id + "_progressbg");
        if (!progressbarBg) {
            createProgressBar(currentModule, entity);
            progressbarBg = GUI.rootContainer.getChildByName(currentModule.id + "_" + entity.id + "_progressbg");
        }

        let progressbarPct = GUI.rootContainer.getChildByName(currentModule.id + "_" + entity.id + "_progresspct");
        if (progressbarPct) {
            progressbarPct.width = (e.received / e.total) * 100 + "px";
        }

        if (Math.round((e.received / e.total) * 100) === 100) {
            if (progressbarBg)
                progressbarBg.dispose();

            if (progressbarPct)
                progressbarPct.dispose();
        }
    }
    

    let reconstructEntityLegs = function(module: Module) {
        module.entities.filter(x => productLibrary.getProductCategory(x.category) === "UPHOLSTRY").forEach(function (entity: Entity) {            
          //  var productVariant = getProductVariant(entity.productNo, entity);

            const entityNode = scene.getTransformNodeById(entity.id);
            const attachments = entityNode.getChildTransformNodes(false, x => x.id.includes("attachment"))

            for (let attachment of attachments) {
                attachment.getChildren().forEach(child => {
                    child.dispose();
                })
            }
          
            //Create legs
            constructLegs(module, entity);
        });  
    }

    let constructModule = async function (module: Module) {

        return new Promise(resolve => {

            //Dispose all UI and models from scene
            cleanupAssets();           

            if (module) {

               // displaySummaryButton(false);
                showLoadingCanvas();

                instantiateModule(currentConfiguration, module, function (instantiatedModule, instantiatedModuleNode) {

                    if (module.entities.length === 0) {                        
                        hideLoadingCanvas();
                         resolve(true)                        
                    }

                    currentModule = instantiatedModule;
                    currentModuleNode = instantiatedModuleNode;

                    const filteredEntities = module.entities.filter(x => productLibrary.getProductCategory(x.category) === "UPHOLSTRY");

                    filteredEntities.forEach(function (entity: Entity) {
                        let product = productLibrary.getProductByProductNo(entity.productNo);                       
                        instantiateEntity(module, product, entity);
                    });
                   
                    hideAllHighlights();
                    hideEntityActions();                    
                  
                    constructEntities(module, (meshes) => {                       
                    
                        module.entities.filter(x => productLibrary.getProductCategory(x.category) === "UPHOLSTRY").forEach(function (entity: Entity) {            
                            var productVariant = getProductVariant(entity.productNo, entity);
                            
                            connectNeighbourEntities(entity)

                            //Create leg attachments
                            createLegAttachments(module, entity, productVariant, scene);
                            //Create legs
                            constructLegs(module, entity);
                        });  

                          
                        //Ares
                        var series = seriesLibrary.getSeriesByName(currentConfiguration.series);
                        if (![148881].includes(series.id)) {
                            //moveAllEntities(module);
                        }

                       // displaySummaryButton(true);
                        updateSummaryMenuTotalPrice();                         

                        pauseRender();
                        resumeRender().then(() => {                           

                            handleModuleUpdating(() => {
                                resolve(true);
                            });                           
                        
                        }); 

                    });  
                  
                });                
            }

             
        });
    }

    let constructEntities = function(module: Module, callback: (meshes: any[]) => void) {
      
        let count = 0;
        const meshes = [];

        var entities = module.entities.filter(x => productLibrary.getProductCategory(x.category) === "UPHOLSTRY");
        entities.forEach(function (entity: Entity, index) {   

            //Create weights to determine best view
            createEntityWeights(entity);
         
            var productVariant = getProductVariant(entity.productNo, entity);
            entity.variantProductNo = productVariant.productNo;
            const entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);
            
            entityNode.metadata.productNo = productVariant.productNo;

            var entityBounds = entityNode.getChildMeshes(true, function (m) { return m.id === "entitybounds" })[0];
            entityBounds.setEnabled(true);          

            //Load entity mesh
            meshLibrary.loadMeshAsync(productVariant.productNo, entity, productVariant.type, "furniture/", productVariant.model + ".glb", productVariant.isFlipped, scene, false, sg, sg2, onProgress, function (clonedMeshEntityId, clonedMesh) {
                            
                clonedMesh.scaling.x = productVariant.isFlipped ? -1 : 1;
                clonedMesh.position.y = currentConfiguration.data.offsetY;

                //Set material
                let material = materialLibrary.getMaterialByProductNumber(currentConfiguration.data["material"]);
                if (material) {
                    materialLibrary.assignMaterial(Y, productVariant, [clonedMesh], material, scene, function () {                     
                        clonedMesh.setEnabled(true);
                    });
                }

                meshes.push(clonedMesh);
                if (meshes.length === entities.length) {
                    callback(meshes);                                                                      
                }
            });           
        });
    }

    let constructLegs = function (module: Module, entity: Entity) {

        //Filter out existing legs
        module.entities = module.entities.filter(x => x.parentId !== entity.id);

        var entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);        
        var entityProduct = productLibrary.getProductByProductNo(entity.productNo);
        var series = seriesLibrary.getSeriesById(entityProduct.series);

        var attachmentNodes = entityNode.getChildTransformNodes(true, function (cm) { return BABYLON.Tags.MatchesQuery(cm, "leg") });
        attachmentNodes.forEach(function (attNode) {

            var offsetSide: number, offsetFront: number, rotation: number = 0;

            var legTags = BABYLON.Tags.GetTags(attNode) as string;
            var legType: string = legTags.split(" ")[1];
            var legProduct = seriesLibrary.getSeriesLeg(series, "standard", legType);

            if (legProduct) {
                
                var rotation = legProduct.legRotation;
                var offsetFront = ConversionHelper.scale(legProduct.legOffsetFromFront, scaleFactor) as number || 0;
                var offsetSide = ConversionHelper.scale(legProduct.legOffsetFromSide, scaleFactor) as number || 0;               

                if (!currentConfiguration.data.offsetY) {
                    currentConfiguration.data.offsetY = ConversionHelper.scale(legProduct.height, 0.001) as number || 0;
                }

                const productVariant = productLibrary.getProductVariantByProductNo(entityProduct);

                var additionalOffsetLeft = ConversionHelper.scale(productVariant.legPlacementAdditionalOffsetLeft, scaleFactor) as number || 0;
                var additionalOffsetRight = ConversionHelper.scale(productVariant.legPlacementAdditionalOffsetRight, scaleFactor) as number || 0;
                var additionalOffsetFront = ConversionHelper.scale(productVariant.legPlacementAdditionalOffsetFront, scaleFactor) as number || 0;
                var additionalOffsetBack = ConversionHelper.scale(productVariant.legPlacementAdditionalOffsetBack, scaleFactor) as number || 0;
                var additionalRotation =  ConversionHelper.scale(productVariant.legPlacementFCIAdditionalAngle, scaleFactor) as number || 0;

                //Connection legs have no offset from side
                if (legType.toLowerCase() === "lt02") {
                    additionalOffsetLeft = 0;
                    additionalOffsetRight = 0;
                    additionalRotation = 0;
                }      
                
                rotation += additionalRotation;

                switch (attNode.id) {
                    case entityNode.id + "_attachment_right_front":
                    case entityNode.id + "_attachment_right_front_single":
                    case entityNode.id + "_attachment_right_center":  {
                        offsetSide = -(offsetSide + additionalOffsetRight);
                        offsetFront = -(offsetFront + additionalOffsetFront);
                    }
                        break;
                    case entityNode.id + "_attachment_left_front": 
                    case entityNode.id + "_attachment_left_front_single":
                    case entityNode.id + "_attachment_left_center": {
                        offsetSide = -(offsetSide + additionalOffsetLeft);
                        offsetFront = -(offsetFront + additionalOffsetFront);
                    }
                        break;
                    case entityNode.id + "_attachment_right_back":
                    case entityNode.id + "_attachment_right_back_single": {
                        offsetSide = -(offsetSide + additionalOffsetRight);
                        offsetFront = -(offsetFront + additionalOffsetBack);
                    }
                        break;
                    case entityNode.id + "_attachment_left_back":
                    case entityNode.id + "_attachment_left_back_single": {
                        offsetSide = -(offsetSide + additionalOffsetLeft);
                        offsetFront = -(offsetFront + additionalOffsetBack);
                    }
                        break;
                }

                var legProductVariant = {} as Product;
                legProductVariant.productNo = legProduct.productNumber;
                legProductVariant.width = legProductVariant.height = legProductVariant.depth = 0.01;
                legProductVariant.model = legProduct.model;
                legProductVariant.type = "LEG";

                instantiateEntity(module, legProductVariant, null, function (instantiatedEntity, instantiatedEntityNode) {
                  
                    var entityBounds = instantiatedEntityNode.getChildMeshes(true, function (m) { return m.id === "entitybounds" })[0];
                    entityBounds.setEnabled(false);

                    instantiatedEntity.parentId = entity.id;
                    instantiatedEntityNode.parent = attNode;
                    instantiatedEntityNode.metadata = {};
                    instantiatedEntityNode.metadata.productNo = legProductVariant.productNo;
                    instantiatedEntityNode.metadata.meshtype = "leg";
                    instantiatedEntityNode.rotation.addInPlace(new BABYLON.Vector3(0, BABYLON.Angle.FromDegrees(rotation).radians(), 0));
                   // instantiatedEntityNode.computeWorldMatrix(true);
                    instantiatedEntityNode.position.addInPlace(new BABYLON.Vector3(offsetSide, 0, offsetFront));

                    meshLibrary.loadMeshAsync(legProductVariant.productNo, instantiatedEntity, "leg", "legs/", legProductVariant.model + ".glb", false, scene, true, sg, sg2, null, function (clonedMeshEntityId, clonedMesh) {

                    });
                });
            }
        });
        
    }    

    let validateConstruction = function (module: Module) {

        errorHandler.resetErrors();

        var filteredEntities = module.entities.filter(function (entity: Entity) { return productLibrary.getProductCategory(entity.category) === "UPHOLSTRY" });
        filteredEntities.forEach(function (entity: Entity) {

            const adjacentEntities = entityHelper.getAdjacentEntities(module, entity, scene);
            let rotationMatrix = BABYLON.Matrix.RotationYawPitchRoll(-entity.rotation._y, entity.rotation._x, entity.rotation._z);        

            let rightOffsetZ = 0;
            let rightDepth = 0;
            let entityRight = adjacentEntities.find(x => ["RIGHT"].includes(x.direction));         
            let entityRightConnectionType = ""  
            let entityProductRight = null;
            if (entityRight) {
                entityProductRight = productLibrary.getProductByProductNo(entityRight.entity.productNo);               
                const rightBb = entityHelper.getEntityBoundingBox(entityRight.entity, scene);
                let entityExtendSize = BABYLON.Vector3.TransformCoordinates(rightBb.extendSize, rotationMatrix);  
                entityRightConnectionType = moduleHelper.getEntityConnectionType(currentModule, entityRight.entity)   
                rightDepth = entityProductRight.depth;
                rightOffsetZ = entityExtendSize.z * 2;
            }  
            
            let leftOffsetZ = 0;
            let leftDepth = 0;
            let entityLeft = adjacentEntities.find(x => ["LEFT"].includes(x.direction));
            let entityLeftConnectionType = ""  
            let entityProductLeft = null             
            if (entityLeft) {
                entityProductLeft = productLibrary.getProductByProductNo(entityLeft.entity.productNo);
                const leftBb = entityHelper.getEntityBoundingBox(entityLeft.entity, scene);
                let entityExtendSize = BABYLON.Vector3.TransformCoordinates(leftBb.extendSize, rotationMatrix);  
                entityLeftConnectionType = moduleHelper.getEntityConnectionType(currentModule, entityLeft.entity)   
                leftDepth = entityProductLeft.depth;
                leftOffsetZ = entityExtendSize.z * 2;
            } 

            var entityConnections = entity.connections.map(function (c) { return c.id });

            let entityMesh = scene.getTransformNodeByUniqueId(entity.uniqueId);
            var entityBounds = entityMesh.getChildMeshes(true, function (cm) { return cm.id === "entitybounds" })[0] as BABYLON.AbstractMesh;
            let bv1 = entityMesh.getHierarchyBoundingVectors();
            let bb1 = new BABYLON.BoundingBox(bv1.min, bv1.max);  

            var product = productLibrary.getProductByProductNo(entity.productNo);

            if (entity.connections.length === 0 && !productLibrary.hasProductVariants(product, ["CT00"])) {
                errorHandler.addError(i18next.t("error.nofreestanding", { type: product.name }));
            }

            filteredEntities.forEach(function (entityCheck: Entity) {
                if (entity.id !== entityCheck.id) {
                    if (entity.connections.length === 0) {

                         let entityCheckMesh = scene.getTransformNodeByUniqueId(entityCheck.uniqueId);
                        var entityCheckBounds = entityCheckMesh.getChildMeshes(true, function (cm) { return cm.id === "entitybounds" })[0] as BABYLON.AbstractMesh;
                         let bv2 = entityCheckMesh.getHierarchyBoundingVectors();
                         let bb2 = new BABYLON.BoundingBox(bv2.min, bv2.max);
                      
                         if (entityBounds.intersectsMesh(entityCheckBounds,false))
                             errorHandler.addError(i18next.t("error.intersect"));
                         }
                    }                 
            });

            var entityProduct = productLibrary.getProductByProductNo(entity.productNo);
            
            /*if (entityProduct.type === "CENTER_SECTION") {
                
                if (!productLibrary.hasProductVariants(entityProduct, ["CT00"])) {
                    if (!(entity.connections.map(x => x.id).includes("CT03") && entity.connections.map(x => x.id).includes("CT04"))) {
                         errorHandler.addError(i18next.t("error.connectionmissing", { type: product.name }));
                    }
                }

            }*/

            if (entityProduct.type === "ARM") {

                //Bure
                if ([148882,157547,157546].includes(product.series)) {

                    const leftLength = adjacentEntities.filter(x => x.direction === "LEFT").length;
                    const rightLength = adjacentEntities.filter(x => x.direction === "RIGHT").length;

                    if (leftLength > 0 && leftLength < 3 ||
                        rightLength > 0 &&  rightLength < 3) {
                            if (entity.connections.map(x => x.id).includes("CT44_center") || 
                                entity.connections.map(x => x.id).includes("CT45_center")) {
                                    errorHandler.addError(i18next.t("error.connectionmissing", { type: product.name }));
                                }                       
                    }
                }

            }

            if (entityProduct.type === "CORNER_SECTION") {
                if (entity.connections.length < 2) {
                    errorHandler.addError(i18next.t("error.cornersection", { type: product.name }));
                }
            }


            if (entityProduct.type === "BACK") {
                if (!(entityConnections.includes("CT37") || entityConnections.includes("CT11"))) {
                    errorHandler.addError(i18next.t("error.frontconnect", { type: product.name }));
                }
            }

            if (entityProduct.type === "SEATFRAME") {

                //Bure
                if ([148882,157547,157546].includes(product.series)) {
                    
                    if (product.depth < 83 && (entityRight?.entity.category === "BACK" || entityLeft?.entity.category === "BACK")) {                        
                         errorHandler.addError(i18next.t("error.illegalconnection", { type: product.name }));
                    }                 

                    if (product.depth < 83 && (entityRight?.entity.category === "ARM" || entityLeft?.entity.category === "ARM")) {
                        if (entityLeftConnectionType === "CT45" || entityRightConnectionType === "CT44") {
                            if ((entityProductLeft?.depth ?? 0) >= 120 || (entityProductRight?.depth ?? 0) >= 120) {
                                errorHandler.addError(i18next.t("error.illegalconnection", { type: product.name }));
                            } 
                        }
                    }

                    if (adjacentEntities.filter(x => x.direction === "BACK").length >= 1 && !entity.connections.map(x => x.id).includes("CT11")) {
                         errorHandler.addError(i18next.t("error.intersect"));
                    }

                }               
             
            }
        });

        var summaryMenuButton = Y.one(".summary-menu__button");
        summaryMenuButton.set("disabled", errorHandler.errors.length > 0 ? "disabled" : null);

    }

    //Append entity to current connector
    let appendEntity = function (entity: Entity, connectorInfo: ConnectorInfo, placement: string) {
      
        if (currentEntityNode) {
            var parentNode = connectorInfo.entityNode;
            var parentConnector = connectorInfo.connectorNode;
          //  var childNode = currentEntityNode;
            var entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);// moduleHelper.getEntityByID(currentModule, connectorInfo.entityNode.id);
            entityNode.computeWorldMatrix(true);

            //Determine matching connector
            var connectorEntity = moduleHelper.getEntityByID(currentModule, connectorInfo.entityNode.id);
            var connector = connectorEntity.connectors.find(c => { return c.id === connectorInfo.connectorNode.name });
            var matchingConnectors = getMatchingConnectors(connector, entity, connectorEntity);  
            
            var childConnectors = entityNode.getChildMeshes(true, function (m) { return matchingConnectors.includes(m.name) });

            var childConnector = childConnectors[0];            
            if (placement) {
                childConnector = childConnectors.find(x => x.name.includes(placement));// currentEntityNode.getChildMeshes(true, function (m) { return matchingConnectors.includes(placement ? m.name.split("_")[0] +"_"+ placement : m.name) })[0];
            }

            childConnector.computeWorldMatrix(true)
            
            //Dragged over single unconnected connector
            moveEntity(entity, parentNode, parentConnector, entityNode, childConnector);

            //Connect neighbouring entities
            connectNeighbourEntities(entity); 
        }    
    }

    let connectNeighbourEntities = function (entity: Entity) {

        //Get entity node
        var entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);
        if (entityNode) {

            entityNode.computeWorldMatrix(true);

            let filteredEntities = currentModule.entities.filter(e => { return productLibrary.getProductCategory(e.category) === "UPHOLSTRY" && e.id !== entity.id });       
            
            //Iterate entity connectors
            entity.connectors.forEach(function (connector: Connector) {              

                //Determine if connector already has connection             
                var entityConnector = entityNode.getChildMeshes(false, function (childNode) { return childNode.name === connector.id })[0];
                entityConnector.computeWorldMatrix(true);             

                filteredEntities.forEach(function (availableEntity) {                    

                    var availableEntityNode = scene.getTransformNodeByUniqueId(availableEntity.uniqueId);
                    if (availableEntityNode) {
                        availableEntityNode.computeWorldMatrix(true);                     

                        var matchingConnectors = getMatchingConnectors(connector, entity, availableEntity);
                        matchingConnectors.forEach(connectorId => {
                            var matchingConnector = availableEntityNode.getChildMeshes(true, function (childNode) { return childNode.name === connectorId })[0];

                            if (matchingConnector) {
                                matchingConnector.computeWorldMatrix(true);

                                let distance = ConversionHelper.scale(10, scaleFactor) as number; 

                                if (BABYLON.Vector3.Distance(entityConnector.getAbsolutePosition(), matchingConnector.getAbsolutePosition()) <= distance) {                                   

                                    var entityConnection = entity.connections.find(function (connection) { return connection.id === connector.id });
                                    if (entityConnection) {
                                        var connectionIndex = entity.connections.indexOf(entityConnection);
                                        entity.connections.splice(connectionIndex, 1);
                                    }

                                    connectEntities(entityNode, entityConnector, availableEntityNode, matchingConnector);
                                }
                            }
                        });                       
                    }
                });     
            });                         
        }
    }

    let openConfig = async function (identifier: string) {

        if (identifier) {            

            let project = await projectLibrary.getProject(identifier);
            currentProject = project;
            currentConfiguration = project.configurations[0];

            if (!currentConfiguration)
                return false;

            if (currentConfiguration.data.modules.length > 0)
                currentModule = currentConfiguration.data.modules[0];

            for (var i = 0; i < currentProject.configurations.length; i++) {
                const config = currentProject.configurations[i];

                    var series = await seriesLibrary.fetchSeriesByName(config.series);//.then((series) => {
                    var defaultLeg = seriesLibrary.getSeriesLegPackage(series, "standard");

                    config.data.leg = config.data.leg || defaultLeg.type;

                    materialLibrary.defaultMaterial = series.defaultMaterial;
                    materialLibrary.materials = series.materials;

                    renderProject().then(() => {
                        constructModule(currentModule).then(() => {

                            resetMainCamera();
                            
                            zoomToMeshHierarchy(mainCamera, currentModuleNode, scene, Math.PI/2.5, Math.PI/2.5, 2);   
                            handleModuleUpdating();                       

                            engine.resize(true);
                        });
                    });
                //});
            }
        }
    }

    let showChangePassword = function() {

        const changePasswordModal = Y.one(".modals .changepassword-modal");
        changePasswordModal.addClass("is-active");

        changePasswordModal.one(".changepassword-close").on("click", function() {
            changePasswordModal.removeClass("is-active");
        });

    }

    /**
     * Drag Functions
     * */

    //Handle Drag
    let handleDrag = function () {

        if (currentEntityNode) {

            var entity = getCurrentEntity();
            if (entity) {
                toggleMeshVisibility(currentEntityNode, MeshVisibility.HIGHLIGHTED);

                hideEntityActions();                            
                hideAllHighlights();  
             
                let connectorInfos = getPositionConnectorInfo(screenPointerPosition, currentEntityNode);            

                if (connectorInfos.length > 0) {

                    connectorInfos.forEach(function (connectorInfo: ConnectorInfo) {
                        var connectorEntity = moduleHelper.getEntityByID(currentModule, connectorInfo.entityNode.id);
                        var connectorEntityNode = scene.getTransformNodeById(connectorEntity.id);

                        if (connectorInfo.isEnabled) {
                            if (connectorInfos.length === 2) {
                                showHighlight(connectorEntityNode);
                            }
                        }
                    });

                    //connectorInfos.forEach(function (connectorInfo: ConnectorInfo) {
                    var connectorInfo = connectorInfos[0];
                    var connectorEntity = moduleHelper.getEntityByID(currentModule, connectorInfo.entityNode.id);
                    var connector = connectorEntity.connectors.find(c => { return c.id === connectorInfo.connectorNode.name });
                    var matchingConnectors = getMatchingConnectors(connector, entity, connectorEntity);
                    var childConnector = currentEntityNode.getChildMeshes(true, function (m) { return matchingConnectors.includes(m.name) })[0];

                    if (childConnector) {

                        //Highlight connector entity
                        if (connectorInfo.isEnabled) {
                            showHighlight(connectorInfo.entityNode);                          
                            setTargetRotation(entity,connectorInfo.entityNode, connectorInfo.connectorNode, currentEntityNode, childConnector);
                        }
                      
                        if (!currentConnector || currentConnector.uniqueId !== connectorInfo.connectorNode.uniqueId) {

                            currentConnector = connectorInfo.connectorNode as BABYLON.AbstractMesh;                         
                            setTargetRotation(entity, connectorInfo.entityNode, connectorInfo.connectorNode, currentEntityNode, childConnector);
                            currentEntityNode.rotation = targetRotation;                           
                        }
                    }

                } else {                
                    hideAllHighlights();                  
                }
            }
        }
    }

    let createEntityPlacementPopup = function(entity: Entity, matchingConnectors: string[]) {         

        return new Promise((resolve)=> {

            if (entity.category !== "ARM") {
                resolve(undefined)
                return;
            }

            const divPlacementModal = Y.one(".modals .placement-modal");
            const divPlacementModalBody = divPlacementModal.one(".modal-card-body");
            divPlacementModalBody.empty();
      
            const placements = [];
            for (let i = 0; i < matchingConnectors.length; i++) {

                const matchingConnector = matchingConnectors[i];
                if (matchingConnector.includes("_back") || matchingConnector.includes("_center") || matchingConnector.includes("_front")) {
                    let placementName = matchingConnector.split("_")[1];    
                    placements.push(placementName);                         
                }              
            }

            if (placements.length === 0) {
                resolve(undefined)
                return;
            }

            if (placements.length >= 1) {      
                divPlacementModal.addClass("is-active");
        
                const buttonChoice = Y.Node.create(`<button class='align-back' title='back'><img src='/images/icons/align-back.svg'/></button>`);         
                buttonChoice.on('click', function(e) {
                    divPlacementModal.removeClass("is-active");
                    resolve(undefined);
                });   
                divPlacementModalBody.appendChild(buttonChoice);                

                for (let i = 0; i < placements.length; i++) {
                    const buttonChoice = Y.Node.create(`<button class='align-${placements[i]}' title='${placements[i]}'><img src='/images/icons/align-${placements[i]}.svg'/></button>`);         
                    buttonChoice.on('click', function(e) {
                        divPlacementModal.removeClass("is-active");
                        resolve(placements[i]);
                    });   
                    divPlacementModalBody.appendChild(buttonChoice);  
                }
            }        
        })

    }

    //Handle Drag End
    let handleDragEnd = async function () {

        var entity = getCurrentEntity();
        if (entity) {

            toggleMeshVisibility(currentModuleNode, MeshVisibility.VISIBLE);
            hideEntityActions();
            hideAllHighlights();

            //Get effected connectors
            let connectorInfos = getPositionConnectorInfo(screenPointerPosition, currentEntityNode);

            let matchingConnectors = [];
            
            if (connectorInfos.length > 0) {
                let connectorEntity = moduleHelper.getEntityByID(currentModule, connectorInfos[0].entityNode.id);
                let connector = connectorEntity.connectors.find(c => { return c.id === connectorInfos[0].connectorNode.name });
                matchingConnectors = getMatchingConnectors(connector, entity, connectorEntity);
            }

            createEntityPlacementPopup(entity, matchingConnectors).then((placement: string) => {         
                
                if (connectorInfos.length > 0) {
                    //Dragged over single unconnected connector
                    if (connectorInfos.length === 1) {
                        let connectorInfo = connectorInfos[0] as ConnectorInfo;

                        if (connectorInfo.isEnabled) {
                            removeEntityConnections(entity);

                            //Append entity
                            appendEntity(entity, connectorInfo, placement);
                            currentAction = ACTIONS.DRAGOVER
                        }

                        //Dragged over already connected connectors (insert etc.)
                    } else if (connectorInfos.length > 1) {

                        removeEntityConnections(entity);

                        //Insert entity
                        insertEntity(entity, connectorInfos, placement);
                        currentAction = ACTIONS.DRAGOVER
                    }
                } else {

                    //Entity not connected to anything yet (no need to reconstruct)
                    //currentEntityNode.rotation.y = entity.rotation.y;

                    if (entity.connections.length > 0) {
                        removeEntityConnections(entity);
                        currentAction = ACTIONS.DRAGOVER
                    } else {

                        hideAllHighlights();
                        hideEntityActions();
                
                        pauseRender();
                        resumeRender().then(() => {
                            handleModuleUpdating();                        
                        });
                    }
                }

                //Create weights to determine best view
                createEntityWeights(entity);

                currentEntityNode = null;

                if (currentAction == ACTIONS.DRAGOUT || currentAction == ACTIONS.DRAGOVER) {
                    currentAction = ACTIONS.NONE;
                    constructModule(currentModule).then(() => {                      
                        zoomToMeshHierarchy(mainCamera, currentModuleNode, scene, mainCamera.alpha, mainCamera.beta,2);                      
                        handleModuleUpdating();                      
                    })                                    
                }             
            })
        }
    }

    let handleModuleUpdating = function(callback?: () => void) {
        scene.executeWhenReady(() => {
            renderConfigurationThumbnail(currentConfiguration).then((result) => {

                currentConfiguration.data.thumbnail = result;
                window.dispatchEvent(new Event("thumbnail_rendered"));

                validateConstruction(currentModule);
                updateSummaryMenuTotalPrice();
                mainCamera.attachControl(true, false);                
               // fitView(currentModuleNode, mainCamera);

                saveProjectConfiguration().then(() => {                    
                    hideLoadingCanvas();                    
                    if (typeof(callback) === "function")
                        callback();
                });
            });
        });  
    }

    //Drag Start (Canvas)
    let dragStartCanvas = function () {

        isDragging = true;
        var entity = getCurrentEntity();

        if (entity.connections.length > 0) {
            currentAction = ACTIONS.DRAGOUT
        }

        removeEntityConnections(entity);
        currentModule.entities.filter(x => productLibrary.getProductCategory(x.category) === "UPHOLSTRY").forEach(moduleentity => {
            let product = productLibrary.getProductByProductNo(moduleentity.productNo);           
            createEntityConnectors(currentModule, moduleentity, product, scene);
        })    
        
        showAvailableConnectors(currentModule, entity);

    }

    //Drag (Canvas)   
    let dragCanvas = function () {

        if (isDragging) {
            handleDrag();
        }
    }

    //Drag End (Canvas)
    let dragEndCanvas = function () {

        if (isDragging) {

            isDragging = false;
            handleDragEnd();
            hideAvailableConnectors();
        }
    }

    //YUI Drag Drop

    var dropCanvas = Y.one('#renderCanvasDrop').plug(Y.Plugin.Drop);

    var del = new Y.DD.Delegate({
        container: '.config-menu .config-menu__submenues__submenu[data-menuview="modules"] .product-selector .selector__items',
        nodes: 'li.product.draggable img',
        dragMode: 'intersect'
    });

    del.dd.on("drag:start", function (e) {
        e.preventDefault();
        dragUIStart(e);
    });

    del.dd.on("drag:drag", function (e) {
        e.preventDefault();
        if (isOverCanvas && isDragging) {
            dragUI(e);
        }

    });

    dropCanvas.drop.on('drop:over', function (e) {
        isOverCanvas = true;
    });

    dropCanvas.drop.on('drop:hit', function (e) {
        if (isDragging) {
            isOverCanvas = false;
            dragUIEnd();
        }
    });

    /* Y.one(".scrollable__content").on("scroll", function (e) {
         e.preventDefault();
         del.dd.stopDrag();
         isDragging = false;
     });*/

    /*var dropMenu = Y.one('.config-menu').plug(Y.Plugin.Drop);
    dropMenu.drop.on('drop:hit', function (e) {
        if (isDragging) {
            isOverCanvas = false;
            dragUIEnd();
        }
    });*/

    del.dd.plug(Y.Plugin.DDProxy, {
        moveOnEnd: false,
        cloneNode: true
    });

    //Drag Start (UI)
    var dragUIStart = function (evt) {

        hideHighlight(currentEntityNode);
        currentEntityNode = null;

        let elem = evt.target.get("node");
        let productElem = elem.ancestor("li");
        elem.addClass("dragged");

        meshLoading = false;
        isDragging = true;

        mainCamera.detachControl();

        let productNumber = productElem.getData("productnumber") as string;
        currentProduct = productLibrary.getProductByProductNo(productNumber);
    };

    //Drag (UI)
    var dragUI = function (evt) {

        hideEntityActions();

        screenPointerPosition = new BABYLON.Vector2(evt.target.mouseXY[0], evt.target.mouseXY[1] - 60);
        scenePointerPosition = getTargetPosition(screenPointerPosition.x, screenPointerPosition.y);
        dragPosition = getZeroPlaneVector(mainCamera.position, scenePointerPosition);

        var distance = BABYLON.Vector3.Distance(mainCamera.position, scenePointerPosition);

        if (!dragPosition && !distance) {
            isDragging = false;
        }

        if (isDragging) {

            //Create mesh
            if (BABYLON.Vector3.Distance(cameraTarget, dragPosition) <= distance) {

                if (!meshLoading) {
                    meshLoading = true;

                    //Instantiate module
                    instantiateModule(currentConfiguration, currentModule, function (module, moduleNode) {

                        currentModule = module;
                        currentModuleNode = moduleNode;

                        var product = productLibrary.getProductByProductNo(currentProduct.productNo);

                        //Instatiate entity
                        instantiateEntity(module, product, null, function (instantiatedEntity, instantiatedEntityNode) {

                            var productVariant = getProductVariant(instantiatedEntity.productNo, instantiatedEntity);
                            instantiatedEntity.variantProductNo = productVariant.productNo;
                            instantiatedEntityNode.metadata.productNo = productVariant.productNo;

                            var entityBounds = instantiatedEntityNode.getChildMeshes(true, function (m) { return m.id === "entitybounds" })[0];
                            entityBounds.setEnabled(true);

                            //Set current selected entity
                            currentEntityNode = instantiatedEntityNode;                        

                            //Show available connectors
                            showAvailableConnectors(module, instantiatedEntity);

                            //Create leg attachments
                            createLegAttachments(module, instantiatedEntity, productVariant, scene);

                            //Create legs
                            constructLegs(module, instantiatedEntity);

                            //Load entity mesh                        
                            meshLibrary.loadMeshAsync(productVariant.productNo, instantiatedEntity, productVariant.type, "furniture/", productVariant.model + ".glb", productVariant.isFlipped, scene, false, sg, sg2, onProgress, function (clonedMeshEntityId, clonedMesh) {

                                //Set material
                                let material = materialLibrary.getMaterialByProductNumber(currentConfiguration.data["material"]);
                                if (material) {
                                    materialLibrary.assignMaterial(Y, productVariant, [clonedMesh], material, scene, function () {
                                        clonedMesh.setEnabled(true);
                                    });
                                }   

                                clonedMesh.scaling.x = productVariant.isFlipped ? -1 : 1;
                                clonedMesh.position.y = currentConfiguration.data.offsetY;

                                 
                            });                         

                        });                       
                    });
                }
            }

            if (currentEntityNode) {

                //Move according to real center of entity
                var centerNode = currentEntityNode.getChildTransformNodes(false, function (m) { return m.id === "center" })[0];
                dragPosition.subtractInPlace(centerNode.position);

                currentEntityNode.setAbsolutePosition(new BABYLON.Vector3(dragPosition.x, currentEntityNode.position.y, dragPosition.z));

                handleDrag();
            }          
        }

    };

    //Drag End (UI)
    var dragUIEnd = function () {

        if (!currentEntityNode && !currentModuleNode) {
            isDragging = false;
            return false;
        }

        if (isDragging) {

            isDragging = false;

            handleDragEnd();
            hideAvailableConnectors();

            updateSummaryMenuTotalPrice();

            Y.all(".menu .menu--item ul li").each(function (el) {
                el.removeClass("dragged");
            });
        }
    };

    var getZeroPlaneVector = function (pos, rot) {
        return getHorizontalPlaneVector(0, pos, rot);
    };

    var getHorizontalPlaneVector = function (y, pos, rot) {
        if (!rot.y) {
            return null; // no solution, as it will never hit the zero plane
        }
        return new BABYLON.Vector3(
            pos.x - (pos.y - y) * rot.x / rot.y,
            0,
            pos.z - (pos.y - y) * rot.z / rot.y
        );
    };

    var debounce = function (fn, delay) {
        var timer = null;
        return function () {
            var context = this, args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
                fn.apply(context, args);
            }, delay);
        };
    }

    let updateProjectsList = async function () {

        showLoader();

        let pagenationPageCount = Y.one(".pagenation-pagecount");
        pagenationPageCount.setHTML("");

        let firstPage = Y.one(".pagenation button.first");
        let nextPage = Y.one(".pagenation button.next");
        let prevPage = Y.one(".pagenation button.prev");
        let lastPage = Y.one(".pagenation button.last");

        firstPage.setAttribute("disabled");
        nextPage.setAttribute("disabled");
        prevPage.setAttribute("disabled");
        lastPage.setAttribute("disabled");

        let projectTable = Y.one(".configurations-page table.project-list");
        let projectTableBody = projectTable.one("tbody");
        projectTableBody.empty();

        if (projectFilter.currentPage > Math.ceil(projectLibrary.count / projectFilter.itemsShown))
            projectFilter.currentPage = Math.ceil(projectLibrary.count / projectFilter.itemsShown);

        if (projectFilter.currentPage < 1)
            projectFilter.currentPage = 1;

        await projectLibrary.getAllProjects(projectFilter);

        //Page count
        if (Math.ceil(projectLibrary.count / projectFilter.itemsShown) > 0) {
            pagenationPageCount.setHTML(i18next.t("projectlist.currentpages", { count: projectFilter.currentPage, pages: Math.ceil(projectLibrary.count / projectFilter.itemsShown) }));
            // pagenationPageCount.setHTML(`${projectFilter.currentPage} of ${Math.ceil(projectLibrary.count / projectFilter.itemsShown)} pages`);           
        }

        if (projectFilter.currentPage > 1) {
            prevPage.removeAttribute("disabled");
            firstPage.removeAttribute("disabled");
        }
        if (projectFilter.currentPage < Math.ceil(projectLibrary.count / projectFilter.itemsShown)) {
            nextPage.removeAttribute("disabled");
            lastPage.removeAttribute("disabled");
        }

        projectLibrary.projects.forEach(function (project: Project) {

            let projectRow = Y.Node.create("<tr>");

            let projectName = Y.Node.create(`<td>${project.name}</td>`);
            projectRow.appendChild(projectName);
            let projectEmail = Y.Node.create(`<td>${project.seller}</td>`);
            projectRow.appendChild(projectEmail);
            let projectPhone = Y.Node.create(`<td>${project.phone}</td>`);
            projectRow.appendChild(projectPhone);
            let projectDate = Y.Node.create(`<td>${FormatHelper.formatDate(project.added)}</td>`);
            projectRow.appendChild(projectDate);
            let projectStatus = Y.Node.create(`<td><span class="status mr-2"><i class="status-${getStatus(project.status).toLowerCase()}"></i></span><span>${i18next.t('common.statuses.' + getStatus(project.status).toLowerCase())}</span></td>`);
            projectRow.appendChild(projectStatus);

            //let projectActions = Y.Node.create(`<td><a class="contextmenu-handle" data-id=${project.identifier}><span class="icon is-small"><i class="fas fa-ellipsis-h"></i></span></a></td>`);
            //projectRow.appendChild(projectActions);

            let projectActions = Y.Node.create(`<td><div class="project-actions dropdown is-right">
                <div class="dropdown-trigger">
                    <a><span class="icon is-small"><i class="fas fa-ellipsis-h"></i></span></a>
                </div>
                <div class="dropdown-menu">
                    <div class="dropdown-content">
                        <a href="#" class="open-project dropdown-item" data-id=${project.identifier}>
                            <span>${i18next.t('projectlist.open')}</span>
                            <span class="icon is-small is-right"><i class="fas fa-long-arrow-right"></i></span>
                        </a>
                        <a href="#" class="edit-project dropdown-item" data-id=${project.identifier}>
                            <span>${i18next.t('projectlist.edit')}</span>
                            <span class="icon is-small is-right"><i class="fas fa-cog"></i></span>
                        </a>
                        <a href="#" class="delete-project dropdown-item" data-id=${project.identifier}>
                            <span>${i18next.t('projectlist.delete')}</span>
                            <span class="icon is-small is-right"><i class="fas fa-trash"></i></span>
                        </a>
                    </div>
                </div>
                </div></td>`);
            projectRow.appendChild(projectActions);

            projectTableBody.appendChild(projectRow);

        });

        projectTable.appendChild(projectTableBody);

        hideLoader();
    }

    let getStatus = (status: number) => {

        switch (status) {
            case 0:
                return "Inactive";
            case 1:
                return "Active";
            case 2:
                return "Ordered";
        }

    }

    let updateSeriesList = async function () {

        let list = Y.one(".series-page ul.series-list");
        list.empty();

        let heightTypes = ["large", "small", "medium", "medium", "large", "small"];
        let heightType = 0;

        var seriesData = await seriesLibrary.fetchSeries(seriesFilter);
        seriesData.forEach(function (series) {

            var seriesNode = Y.Node.create("<li>");
            seriesNode.addClass("tile-list-item " + heightTypes[heightType]);
            seriesNode.setAttribute("data-series", series.id);

            var imgElem = Y.Node.create("<div>");
            imgElem.addClass("tile-img");

            var img = new Image();
            img.src = series.thumbnail;
            img.onload = function (e) {
                imgElem.setStyle("backgroundImage", "url('" + series.thumbnail + "')");
                imgElem.addClass("is-shown");
            }
            img.onerror = function (e) {
                console.log("Image not found")
            }
            seriesNode.appendChild(imgElem);

            var name = Y.Node.create("<div>");
            name.addClass("tile-name");
            seriesNode.appendChild(name);

            var span = Y.Node.create("<span>");
            span.setHTML(series.name);
            name.appendChild(span);

            list.appendChild(seriesNode);

            heightType++;
            if (heightType >= heightTypes.length) {
                heightType = 0;
            }

        });

        seriesList.fitWidth();

    }

    let updatePresetList = function () {

        let list = Y.one(".series-page ul.preset-list");
        list.empty();

        let heightTypes = ["large", "small", "medium", "medium", "large", "small"];
        let heightType = 0;

        //New item
        var presetNode = Y.Node.create("<li>");
        presetNode.addClass("tile-list-item " + heightTypes[heightType] + " is-new");
        presetNode.setAttribute("data-preset", "");

        var name = Y.Node.create("<div>");
        name.addClass("tile-name");
        presetNode.appendChild(name);

        var span = Y.Node.create("<span>");
        span.setHTML("Configure");
        name.appendChild(span);

        list.appendChild(presetNode);

        let series = seriesLibrary.getSeriesByName(currentConfiguration.series);
        series.presets.forEach(function (preset) {

            var presetNode = Y.Node.create("<li>");
            presetNode.addClass("tile-list-item " + heightTypes[heightType]);
            presetNode.setAttribute("data-preset", preset.id);

            var img = Y.Node.create("<div>");
            img.addClass("tile-img");
            img.setStyle("backgroundImage", "url('" + preset.thumbnail + "')");
            presetNode.appendChild(img);

            var name = Y.Node.create("<div>");
            name.addClass("tile-name");
            presetNode.appendChild(name);

            var span = Y.Node.create("<span>");
            span.setHTML(preset.name);
            name.appendChild(span);

            list.appendChild(presetNode);

            heightType++;
            if (heightType >= heightTypes.length) {
                heightType = 0;
            }

        });

        presetList.fitWidth();
    }

    let updateConfigurationSelector = function () {

        let listNode = Y.one(".configuration-selector ul");
        listNode.empty();

        currentProject.configurations.sort((a, b) => { return a.data.id > b.data.id ? 1 : -1 });
        currentProject.configurations.forEach(function (configuration) {

            var configurationNode = Y.Node.create("<li>");

            if (currentConfiguration.data.id === configuration.data.id) {
                configurationNode.addClass("is-active");
            }

            configurationNode.setAttribute("data-id", configuration.data.id);

            var configurationWrapper = Y.Node.create("<div>");
            var configurationThumbnailWrapper = Y.Node.create("<span>");
            configurationThumbnailWrapper.setStyle("background-image", "url('" + configuration.data.thumbnail + "')");

            var deleteIconElem = Y.Node.create("<a>");
            deleteIconElem.addClass("configuratior-selector__delete");
            var deleteIconInnerElem = Y.Node.create("<i>");
            deleteIconInnerElem.addClass("fas fa-trash-can");

            deleteIconElem.appendChild(deleteIconInnerElem);
            configurationThumbnailWrapper.appendChild(deleteIconElem);

            configurationWrapper.appendChild(configurationThumbnailWrapper)
            configurationNode.appendChild(configurationWrapper);

            listNode.appendChild(configurationNode);

        });

        if (currentProject.configurations.length < 4) {
            var configurationNode = Y.Node.create("<li>");
            configurationNode.addClass("is-new");

            var configurationWrapper = Y.Node.create("<div>");
            var configurationThumbnailWrapper = Y.Node.create("<span>");
            configurationThumbnailWrapper.setHTML("<i class='fas fa-plus-circle fa-2x'></i>");
            configurationWrapper.appendChild(configurationThumbnailWrapper);
            configurationNode.appendChild(configurationWrapper);
            listNode.appendChild(configurationNode);
        }
    }

    let filterMaterials = function (materials: Material[]) {

        let filters = document.querySelectorAll(".materialfilter");

        materialFilters = [];

        let filteredMaterials = [] as Material[];
        filters.forEach(filter => {
            let inputElement = (filter as HTMLInputElement);

            /*if (inputElement.type === "text") {
                materials.filter(x => x.name)

                materialFilters.push({ key: "search", value: inputElement.value } as MaterialFilter);
            }*/

            if (inputElement.type === "checkbox") {
                if (inputElement.checked)
                    materialFilters.push({ key: "type", value: inputElement.value } as MaterialFilter);
            }
        });

        let typeFilters = materialFilters.filter(y => y.key === "type");

        filteredMaterials = materials.filter(x => {
            return typeFilters.some(y => y.value.toLowerCase() === x.type.toLowerCase())
        });

        /*  let searchFilter = materialFilters.find(x => x.key === "search");
           if (searchFilter.value !== "") {
               filteredMaterials = filteredMaterials.filter(x => x.name.toLowerCase().indexOf(searchFilter.value.toLowerCase()) > 0);
           }*/

        return filteredMaterials;

    }

    let updateMaterialGroupModal = function () {

        let listNode = Y.one(".material-group-modal .modal-card-body ul");
        listNode.empty();

        let searchField = Y.one("#materialsearchfilter");
        let searchFilter = searchField.get("value");


        var currentMaterial = materialLibrary.getMaterialByProductNumber(currentConfiguration.data["material"]);
        var materialGroups = materialLibrary.getMaterialGroups();

        Y.Array.each(materialGroups, function (materialGroup) {

            var groupMaterials = materialLibrary.getMaterialsByGroup(materialGroup);

            groupMaterials = filterMaterials(groupMaterials);

            if (groupMaterials.length > 0) {

                if (searchFilter === "" || materialGroup.toLowerCase().includes(searchFilter)) {


                    var groupMaterial = groupMaterials[0];

                    var materialGroupNode = Y.Node.create("<li>");
                    materialGroupNode.setAttribute("data-group", materialGroup);

                    if (currentMaterial) {
                        if (currentMaterial.group === materialGroup) {
                            materialGroupNode.addClass("is-active");
                        }
                    }

                    var materialGroupContentNode = Y.Node.create("<div class='material-group-content'>");

                    var materialGroupImageNode = Y.Node.create("<div class='material-group-image'>");
                    materialGroupImageNode.setStyle("background-image", "url('" + AppSettings.Paths.BaseMaterialsPath + groupMaterial.type + "/" + groupMaterial.group + "/" + groupMaterial.productNumber + "_thumb.jpg')");

                    var materialGroupNameNode = Y.Node.create("<div class='material-group-name'>");
                    materialGroupNameNode.setHTML(materialGroup);

                    var materialGroupInfoNode = Y.Node.create("<div class='material-group-info'>");
                    materialGroupInfoNode.setHTML("(" + groupMaterials.length + " colors)");

                    materialGroupContentNode.appendChild(materialGroupImageNode);
                    materialGroupContentNode.appendChild(materialGroupNameNode);
                    materialGroupContentNode.appendChild(materialGroupInfoNode);
                    materialGroupNode.appendChild(materialGroupContentNode);

                    listNode.appendChild(materialGroupNode);
                }
            }
        });
    }

    let showSeriesWizardStep = function (stepname: string) {

        Y.all(".series-selection .wizard-nav__stepviews .wizard-nav__stepview").each(function (stepview) {
            stepview.removeClass("is-shown");
        });

        var stepview = Y.one(".series-selection .wizard-nav__stepviews .wizard-nav__stepview[data-stepview='" + stepname + "']");
        stepview.addClass("is-shown");
    }

    let renderProject = async function () {

        return new Promise(async (resolve) => {           

            let series = await seriesLibrary.fetchSeriesByName(currentConfiguration.series);

            updateSeriesName(currentConfiguration);

            Promise.all([
              //  seriesLibrary.fetchSeriesByID(series.id),
                productLibrary.fetchProducts(series.id)
            ]).then(() => {

                var selectedMaterial = materialLibrary.getMaterialByProductNumber(currentConfiguration.data["material"]);
                if (selectedMaterial) {
                    productSelector.material = selectedMaterial;
                    productSelector.selectedCategory = productLibrary.productsCategories.filter(function (pc) { return pc.products })[0];

                    materialSelector.setConfiguration(currentConfiguration);
                    materialSelector.setMaterialGroup(selectedMaterial.group);
                    materialSelector.update();
                }

                productSelector.update();
                updateConfigurationSelector();

                //displaySummaryMenu(true);

                if (!rendererInitialized) {
                    initRenderer().then(() => {
                        resolve(true);
                    });
                } else {
                    resolve(true);
                }

                showPage("viewport");
            });
        });

    }

    let updateOptionsModal = function () {
        var optionsModalOptions = Y.one(".modals .options-modal .options");
        var series = seriesLibrary.getSeriesByName(currentConfiguration.series);
        var summaryList = moduleHelper.generateModuleSummaryList(currentModule, currentConfiguration);

        optionsModalOptions.empty();

        if(series.legPackages.length > 1){
            var row = Y.Node.create("<div>");
            row.addClass("field mt-5");

            let label = Y.Node.create("<label>");
            let controlHolder = Y.Node.create("<div>")

            label.addClass("label")
            label.setHTML("Legs");

            controlHolder.addClass("control");
            var selection = currentConfiguration.data.leg;

            let selectHolder = Y.Node.create("<div>");
            selectHolder.addClass("select")
            let select = Y.Node.create("<select>");

            select.setData("option", "leg");

            series.legPackages.forEach(legPackage => {
                let optionElem = Y.Node.create("<option>")
                optionElem.setHTML(legPackage.name || legPackage.identifier);
                optionElem.setAttribute("value", legPackage.identifier);

                if (selection == legPackage.identifier) {
                    optionElem.setAttribute("selected", "selected");
                }

                select.appendChild(optionElem);
            });

            selectHolder.appendChild(select);
            controlHolder.appendChild(selectHolder);
            

            row.appendChild(label)
            row.appendChild(controlHolder)

            optionsModalOptions.appendChild(row);
        };

        series.customOptions.filter(e => e.priceLists.some(e => e.productType == "Frame Cushion Item")).forEach(option => {
            var row = Y.Node.create("<div>");
            row.addClass("field mt-5");

            let label = Y.Node.create("<label>");
            let controlHolder = Y.Node.create("<div>")

            label.addClass("label")
            label.setHTML(option.name);

            controlHolder.addClass("control");
            var selection = currentConfiguration.data.customOptions?.find(e => e.id == option.id);

            if(option.perModule){
                summaryList.elements.forEach(element => {
                    //var product = productLibrary.getProductByProductNo(element.productNo);
                    const elementSelection = element.extras?.find(e => e.optionId == option.id);
                    const isValid = option.priceLists.some(p => p.items.includes(element.variantName));

                    if(isValid){
                        const p = Y.Node.create("<p>");
                        p.addClass("mt-5");

                        const elementLabel = Y.Node.create("<label>");
                        elementLabel.appendChild(element.variantName);

                        p.appendChild(elementLabel);
                        p.appendChild(Y.Node.create("<br>"));

                        let controlLabel = Y.Node.create("<label>")
                        controlLabel.addClass("checkbox");
    
                        let input = Y.Node.create("<input>");
                        input.setAttribute("type", "checkbox");
    
                        if (elementSelection && elementSelection.optionValue == option.id) {
                            input.setAttribute("checked", "checked");
                        }
    
                        input.setData("element", element.entity);
                        input.setData("option", option.id);
                        input.setData("value", option.id);
    
                        controlLabel.appendChild(input);
                        controlLabel.appendChild("&nbsp;" + option.name);
    
                        p.appendChild(controlLabel);
                        
                        controlHolder.appendChild(p);
                    }
                });
            }else{
                let controlLabel = Y.Node.create("<label>")
                controlLabel.addClass("checkbox");

                let input = Y.Node.create("<input>");
                input.setAttribute("type", "checkbox");

                if (selection && selection.value == option.id) {
                    input.setAttribute("checked", "checked");
                }

                input.setData("option", option.id);
                input.setData("value", option.id);

                controlLabel.appendChild(input);
                controlLabel.appendChild("&nbsp;" + option.name);

                controlHolder.appendChild(controlLabel);
            }

            row.appendChild(label)
            row.appendChild(controlHolder)

            optionsModalOptions.appendChild(row);
        });
    }

    let updateSummary = function () {
        if (errorHandler.errors.length === 0) {

            const series = seriesLibrary.getSeriesByName(currentConfiguration.series)
            const legThumb = seriesLibrary.getLegThumbnail(series, currentConfiguration.data.leg);
            const leg = series.legPackages.find(e => e.identifier === currentConfiguration.data.leg);

            const summaryList = moduleHelper.generateModuleSummaryList(currentModule, currentConfiguration);
            var totalPrice = moduleHelper.getTotalModulePrice(currentModule, currentConfiguration);
            const options = [];

            series.customOptions.forEach(option => {
                var selection = currentConfiguration.data.customOptions?.find(e => e.id == option.id);

                if (selection != undefined && selection.value == option.id) {
                    options.push(option.name);
                }
            })

            if (summaryList.elements.length > 0 || summaryList.accessories.length > 0) {

                let currentMaterial = materialLibrary.getMaterialByProductNumber(currentConfiguration.data.material) as Material;

                let summarySeriesImage = Y.one(".summary-page .summary__description--image .summary-image");
                summarySeriesImage.setAttribute("src", currentConfiguration.image);

                let summarySeriesThumbnail = Y.one(".summary-page .summary__description--series .summary-image");
                summarySeriesThumbnail.setAttribute("src", currentConfiguration.data.thumbnail);

                let summarySeriesValue = Y.one(".summary-page .summary__description--series .summary__description--value span");
                summarySeriesValue.setHTML(currentConfiguration.series);

                let summaryMaterialImage = Y.one(".summary-page .summary__description--material .summary-image");
                summaryMaterialImage.setAttribute("src", materialLibrary.getMaterialThumbnailUrl(currentMaterial.productNumber));

                let summaryMaterialValue = Y.one(".summary-page .summary__description--material .summary__description--value span");
                summaryMaterialValue.setHTML(currentMaterial.name);

                let summaryLegsImage = Y.one(".summary-page .summary__description--legs .summary-image");
                summaryLegsImage.setAttribute("src", legThumb);

                let summaryLegsValue = Y.one(".summary-page .summary__description--legs .summary__description--value span");
                summaryLegsValue.setHTML(leg?.name || leg.identifier || "");

                let summaryOptionsValue = Y.one(".summary-page .summary__description--options .summary__description--value span");
                summaryOptionsValue.setHTML(options.join("<br />"));

                let summaryDrawingImage = Y.one(".summary-page .summary__description--drawing .summary-image");
                summaryDrawingImage.setAttribute("src", currentConfiguration.drawing);


                let summaryActionsConfigNumber = Y.one(".summary-page .summary__actions .summary__actions__confignumber--value");
                summaryActionsConfigNumber.setHTML(currentProject.identifier.toUpperCase());

                let summaryProductList = Y.one(".summary-page .summary__products .summary__table__rows");
                let summaryProductListBody = summaryProductList.one("tbody");
                let summaryProductListFooter = summaryProductList.one("tfoot");

                let currency = summaryList.elements[0].currency;

                summaryProductListBody.empty();
                summaryList.elements.forEach(summaryItem => {

                    var row = Y.Node.create("<tr>");                    

                    var product = productLibrary.getProductByProductNo(summaryItem.productNo);

                    let cellProductNameNode = Y.Node.create("<td>");
                    let cellProductDimensionNode = Y.Node.create("<td>");
                    let cellProductNumberNode = Y.Node.create("<td>");
                    let cellProductAmountNode = Y.Node.create("<td>");
                    let cellProductPriceNode = Y.Node.create("<td>");

                    cellProductNameNode.setHTML(product.name);
                    cellProductDimensionNode.setHTML(ProductHelper.getFormattedString(product, ['width', 'depth', 'height']));
                    cellProductNumberNode.setHTML(`${summaryItem.axProductNo} - ${summaryItem.variantProductNo}`);
                    cellProductAmountNode.setHTML(`${summaryItem.amount} stk`);
                    cellProductPriceNode.setHTML(`${FormatHelper.formatNumber(summaryItem.price)} ${currency}`);

                    row.appendChild(cellProductNameNode)
                    row.appendChild(cellProductDimensionNode)
                    row.appendChild(cellProductNumberNode)
                    row.appendChild(cellProductAmountNode)
                    row.appendChild(cellProductPriceNode)

                    summaryProductListBody.appendChild(row);

                    summaryItem.extras.forEach(extra => {
                        var row = Y.Node.create("<tr>");

                        let cellProductNameNode = Y.Node.create("<td>");
                        let cellProductDimensionNode = Y.Node.create("<td>");
                        let cellProductNumberNode = Y.Node.create("<td>");
                        let cellProductAmountNode = Y.Node.create("<td>");
                        let cellProductPriceNode = Y.Node.create("<td>");

                        cellProductNameNode.setHTML();
                        cellProductDimensionNode.addClass("pl-6");
                        cellProductDimensionNode.setHTML(extra.name);
                        cellProductNumberNode.setHTML(extra.productNo);
                        cellProductAmountNode.setHTML();
                        cellProductPriceNode.setHTML(`${FormatHelper.formatNumber(extra.price)} ${currency}`);

                        row.appendChild(cellProductNameNode);
                        row.appendChild(cellProductDimensionNode);
                        row.appendChild(cellProductNumberNode);
                        row.appendChild(cellProductAmountNode);
                        row.appendChild(cellProductPriceNode);

                        summaryProductListBody.appendChild(row);
                    })

                    var entity = moduleHelper.getEntityByID(currentModule,summaryItem.entity);
                    var entityNode = scene.getTransformNodeByUniqueId(entity.uniqueId);
                    var centerNode = entityNode.getChildTransformNodes(true, function (t) { return t.id === "center" })[0];

                   /* var labelContainer = new BABYLON.GUI.Rectangle(currentModule.id + "_" + entity.id + "_label");
                    labelContainer.width = "220px";
                    labelContainer.height = "52px";
                    labelContainer.cornerRadius = 4;
                    labelContainer.color = "black";
                    labelContainer.thickness = 1;
                    labelContainer.background = "white";
                    GUI.addControl(labelContainer);
                    labelContainer.linkWithMesh(centerNode);
                    labelContainer.linkOffsetY = -16;

                    labelContainer.isVisible = true;

                    var productVariant = productLibrary.getProductVariantByConnectionType(product, moduleHelper.getEntityConnectionType(currentModule, entity));

                    var text1 = new BABYLON.GUI.TextBlock(currentModule.id + "_" + entity.id + "_productNo");
                    text1.text = product.productNo.replace("/", "/\r\n") + "\r\n" + productVariant.axProductNo;
                    text1.color = "black";
                    text1.fontSize = 14;
                    labelContainer.addControl(text1);*/

                });

                summaryList.customOptions.forEach(customOption => {

                    var row = Y.Node.create("<tr>");

                    let cellProductNameNode = Y.Node.create("<td>");
                    let cellProductDimensionNode = Y.Node.create("<td>");
                    let cellProductNumberNode = Y.Node.create("<td>");
                    let cellProductAmountNode = Y.Node.create("<td>");
                    let cellProductPriceNode = Y.Node.create("<td>");

                    cellProductNameNode.setHTML(customOption.productNo);
                    cellProductDimensionNode.setHTML("");
                    cellProductNumberNode.setHTML(customOption.name);
                    cellProductAmountNode.setHTML(`${customOption.amount} stk`);
                    cellProductPriceNode.setHTML(`${FormatHelper.formatNumber(customOption.totalprice)} ${currency}`);

                    row.appendChild(cellProductNameNode)
                    row.appendChild(cellProductDimensionNode)
                    row.appendChild(cellProductNumberNode)
                    row.appendChild(cellProductAmountNode)
                    row.appendChild(cellProductPriceNode)

                    summaryProductListBody.appendChild(row);
                });


                let summaryAddOnList = Y.one(".summary-page .summary__accessories .summary__accessories__list");
                let summaryAddOnListBody = summaryAddOnList.one("tbody");
                let summaryAddOnListFooter = summaryAddOnList.one("tfoot");

                summaryAddOnListBody.empty();
                series.accessories.forEach(addOn => {

                    var row = Y.Node.create("<tr>");
                    var amount = summaryList.accessories.find(e => e.productNo == addOn.productNumber)?.amount ?? 0;
                    var price = addOn.priceLists[0]?.prices[currentMaterial.priceGroup] ?? 0;

                    
                    series.customOptions.forEach(option => {
                        const selection = currentConfiguration.data.customOptions?.find(e => e.id == option.id);
                        if (selection) {
                            var pricelists = option.priceLists.filter(e => e.productType == "Accessories");
                            var pricelist = pricelists.find(e => e.accessories.includes(addOn.name));

                            if (pricelist) {
                                price += pricelist.priceLists[0]?.price ?? 0
                            }
                        }
                    })

                    let cellProductNameNode = Y.Node.create("<td>");
                    let cellProductNumberNode = Y.Node.create("<td>");
                    let cellProductAmountNode = Y.Node.create("<td>");
                    let cellProductPriceNode = Y.Node.create("<td>");
                    let cellProductTotalPriceNode = Y.Node.create("<td>");
                    let amountInput = Y.Node.create("<input>");
                    let amountLabel = Y.Node.create("<span>");

                    amountInput.setAttribute("type", "number");
                    amountInput.setAttribute("value", amount);
                    amountInput.setAttribute("min", "0");
                    amountInput.setData("product", addOn.productNumber);
                    amountInput.addClass("addon-amount");

                    cellProductNameNode.setHTML(addOn.name);
                    cellProductNumberNode.setHTML(addOn.productNumber);
                    amountLabel.setHTML(' stk');
                    cellProductPriceNode.setHTML(`${price} ${currency}`);
                    cellProductTotalPriceNode.setHTML(`${FormatHelper.formatNumber(price * amount)} ${currency}`);

                    row.appendChild(cellProductNameNode)
                    row.appendChild(cellProductNumberNode)
                    cellProductAmountNode.appendChild(amountInput)
                    cellProductAmountNode.appendChild(amountLabel)
                    row.appendChild(cellProductAmountNode)
                    row.appendChild(cellProductPriceNode)
                    row.appendChild(cellProductTotalPriceNode)

                    summaryAddOnListBody.appendChild(row);
                });

                summaryAddOnListFooter.empty();
                var row = Y.Node.create("<tr>");

                let cellSpacer = Y.Node.create("<td>");
                cellSpacer.setAttribute("colspan", "3");

                let cellProductTotal = Y.Node.create("<td>");
                cellProductTotal.setHTML(`<b>Total</b>`);

                let cellProductTotalPrice = Y.Node.create("<td>");
                cellProductTotalPrice.setHTML(`<b>${FormatHelper.formatNumber(totalPrice.totalPrice)} ${totalPrice.currency}</b>`);

                row.appendChild(cellSpacer)
                row.appendChild(cellProductTotal)
                row.appendChild(cellProductTotalPrice)

                summaryAddOnListFooter.appendChild(row);


                
            }
        }
    }

    /**
     * UI/UX Functions
     * */

    //Series List
    let seriesList = new window.freewall('.series-list');
    seriesList.reset({
        selector: '.tile-list-item',
        animate: false,
        delay: 0.2,
        gutterY: 20,
        gutterX: 20,
        cellW: function (width) {

            var cellWidth = width;
            if (width >= 600) {
                cellWidth = width / 2;
            }
            if (width >= 1000) {
                cellWidth = width / 3;
            }
            return cellWidth;
        },
        cellH: function (height) {
            return height;
        },
        onResize: function () {
            this.fitWidth();
        }
    });

    //Preset list
    let presetList = new window.freewall('.preset-list');
    presetList.reset({
        selector: '.tile-list-item',
        animate: false,
        delay: 0.2,
        gutterY: 20,
        gutterX: 20,
        cellW: function (width) {

            var cellWidth = width;
            if (width >= 600) {
                cellWidth = width / 2;
            }
            if (width >= 1000) {
                cellWidth = width / 3;
            }
            return cellWidth;
        },
        cellH: function (height) {
            return height;
        },
        onResize: function () {
            this.fitWidth();
        }
    });

    let displaySummaryMenu = function (isShown: boolean) {

        var summaryMenu = Y.one(".summary-menu");

        if (isShown) {
            summaryMenu.addClass("is-active");
        } else {
            summaryMenu.removeClass("is-active");
        }
    }


    //Pagenation
    Y.one("body").delegate("click", async function (evt) {

        projectFilter.currentPage += 1;
        if (projectFilter.currentPage > Math.ceil(projectLibrary.count / projectFilter.itemsShown))
            projectFilter.currentPage = Math.ceil(projectLibrary.count / projectFilter.itemsShown);

        await updateProjectsList();

    }, ".pagenation button.next");

    Y.one("body").delegate("click", async function (evt) {

        projectFilter.currentPage -= 1;
        if (projectFilter.currentPage < 1)
            projectFilter.currentPage = 1;

        await updateProjectsList();

    }, ".pagenation button.prev");

    Y.one("body").delegate("click", async function (evt) {

        projectFilter.currentPage = Math.ceil(projectLibrary.count / projectFilter.itemsShown);
        await updateProjectsList();

    }, ".pagenation button.last");

    Y.one("body").delegate("click", async function (evt) {

        projectFilter.currentPage = 1;
        await updateProjectsList();

    }, ".pagenation button.first");

    Y.one("body").delegate("click", async function (evt) {

        let identifierElem = Y.one(".openconfig-identifier input");
        let identifier = identifierElem.get("value");

        if (identifier) {

            let project = await projectLibrary.getProject(identifier);
            currentProject = project;
            currentConfiguration = project.configurations[0];
            currentModule = currentConfiguration.data.modules[0];

            showLoader();

            seriesLibrary.fetchSeriesByName(currentConfiguration.series).then((series) => {

                var defaultLeg = seriesLibrary.getSeriesLegPackage(series, "standard");

                // currentConfiguration.data.options["defaultLeg"] = series.defaultLeg;
                currentConfiguration.data.leg = currentConfiguration.data.leg || defaultLeg.identifier;

                materialLibrary.defaultMaterial = series.defaultMaterial;
                materialLibrary.materials = series.materials;

                renderProject().then(() => {
                    constructModule(currentModule).then(() => {                        
                        zoomToMeshHierarchy(mainCamera, currentModuleNode, scene, Math.PI/2.5, Math.PI/2.5,2);
                        handleModuleUpdating();                                                      
                    })
                });
            });

        }//

    }, ".landing-page .openconfig-button");

    Y.one("body").delegate("click", async function (evt) {

        let project = {} as Project;
        project.seller = "";
        project.name = "";
        project.phone = "";
        project.status = 1;
        project.configurations = [];

        currentProject = project;
        isNewConfig = true;

        //showLoader();
        /* projectLibrary.createProject(project).then((newProject) => {
             currentProject = newProject;
             showPage("series");
             hideLoader();
         });*/

        showPage("series");

    }, ".landing-page .createconfig-button");

    let enableAllProducts = function () {
        Y.all(".menu .menu__item__content > ul > li").each(function (productElement) {
            productElement.setAttribute("disabled", "");
            productElement.removeClass("disabled");
        });
    }

    Y.one("body").delegate("click", function (e: any) {

        var elem = e.currentTarget;
        var configMenuElem = elem.ancestor(".config-menu");
        var viewportElem = Y.one(".viewport");
        configMenuElem.toggleClass("is-collapsed");
        viewportElem.toggleClass("is-menu-collapsed");
        engine.resize();

    }, ".config-menu .config-menu__close");

    Y.one("body").delegate("click", function (e: any) {

        //Reset selected menu
        var activeMenu = Y.one(".config-menu .config-menu__submenu-selection ul li[data-menu].is-active")
        activeMenu.removeClass("is-active");
        var menu = activeMenu.getData("menu");
        var menuview = Y.one(".config-menu .config-menu__submenues__submenu[data-menuview='" + menu + "']");
        menuview.removeClass("is-shown");

        //Set selected menu
        var elem = e.currentTarget;
        elem.addClass("is-active");
        menu = elem.getData("menu");
        menuview = Y.one(".config-menu .config-menu__submenues__submenu[data-menuview='" + menu + "']");
        menuview.addClass("is-shown");

        switch (menu) {
            case "modules": {
                productSelector.reset();
                productSelector.update();
            }
                break;
            /* case "customize": {
                 optionsSelector.reset();
                 optionsSelector.update();
             }
                 break;*/
        }


    }, ".config-menu .config-menu__submenu-selection ul li[data-menu]");

    Y.one("body").delegate("click", async function (e: any) {

        var elem = e.currentTarget;

        let seriesId = parseInt(elem.getData("series"));

        seriesLibrary.fetchSeriesByID(seriesId).then(() => {

            var series = seriesLibrary.getSeriesById(seriesId);

            //Create configuration
            createProjectConfiguration(currentProject, series.name);

            //Set default legs for series
            var defaultLeg = seriesLibrary.getSeriesLegPackage(series, "standard");

            // currentConfiguration.data.options["defaultLeg"] = series.defaultLeg;
            currentConfiguration.data.leg = defaultLeg.identifier;
          
            materialLibrary.defaultMaterial = series.defaultMaterial;
            materialLibrary.materials = series.materials;

            updatePresetList();
            showSeriesWizardStep("preset");
        });

    }, ".series-list .tile-list-item");

    Y.one("body").delegate("click", async function (e: any) {

        showLoader();

        if (isNewConfig) {
            await projectLibrary.createProject(currentProject).then((newProject) => {
                currentProject = newProject;             
            });
        } else {
            saveProjectConfiguration();
           // window.dispatchEvent(new Event("saveconfigurations"));

        }

        renderProject().then(() => {
            mainCamera.radius = initialCameraRadius;
            hideLoader();
        });

    }, ".preset-list .tile-list-item.is-new");

    Y.one("body").delegate("click", function (e: any) {   
        
        hideAllHighlights();
        hideEntityActions();

        renderDrawingWithGUI(currentConfiguration, () => {
            renderConfigurationImage(currentConfiguration, (image) => {
                currentConfiguration.image = image;    
                updateSummary();          
            },1, Math.PI/2, Math.PI/2.5);
        });
        showPage("summary");
    }, ".summary-menu__button");

    Y.one("body").delegate("change", function (e: any) {
        const amount = Math.max(0, e.target.get("value"));
        const productNo = e.target.getData("product");

        const summary = moduleHelper.generateModuleSummaryList(currentModule, currentConfiguration);
        const summaryItem = summary.accessories.find(e => e.productNo == productNo);

        const dif = amount - (summaryItem?.amount ?? 0);

        if (!currentConfiguration.data.addons) {
            currentConfiguration.data.addons = []
        }

        let addOnItem = currentConfiguration.data.addons.find(e => e.productNo == productNo);
        if (!addOnItem) {
            addOnItem = {
                amount: 0,
                productNo: productNo
            }
            currentConfiguration.data.addons.push(addOnItem);
        }
        addOnItem.amount += dif;

        updateSummary();
    }, ".summary__accessories__list .addon-amount");

    Y.one("body").delegate("change", function(e: any) {

        var terms = Y.one(".summary__actions__terms input");
        var disclaimer =  Y.one(".summary__actions__disclaimer input");
        var orderButton = Y.one(".order-button");

        if (terms.get("checked") && disclaimer.get("checked")) {           
             orderButton.set("disabled","")
        } else {
            orderButton.set("disabled","disabled")
        }

    }, ".summary__actions__terms input, .summary__actions__disclaimer input");

    Y.one("body").delegate("click", function (e: any) {

        var terms = Y.one(".summary__actions__terms input");
        var disclaimer =  Y.one(".summary__actions__disclaimer input");

        if (terms.get("checked") && disclaimer.get("checked")) {
            saveProjectConfiguration();
            //window.dispatchEvent(new Event("saveconfigurations"));
            pdfHandler.generatePDF(currentProject, currentConfiguration, moduleHelper, currentModule);

            var orderModal = Y.one(".modals .order-modal");
            orderModal.addClass("is-active");
        }

    }, ".order-button");


    Y.one("body").delegate("click", function (e: any) {

        switch (currentPage) {

            case "configurations": {
                showPage(previousPage);
            }
                break;
            case "summary": {
                showPage("viewport");
            }
                break;
        }

    }, ".back-button");

    Y.one("body").delegate("click", function (e: any) {

        var elem = e.currentTarget;
        var modal = elem.ancestor(".modal");
        modal.removeClass("is-active");

    }, ".modal-card-close, .modal-close");


    Y.one("body").delegate("click", function (e: any) {

        e.preventDefault();

        Y.all(".configuration-selector ul li").each(function (e) {
            e.removeClass("is-active");
        });

        var elem = e.currentTarget;
        elem.addClass("is-active");

        var configurationId = elem.getData("id");

        if (currentConfiguration.data.id !== configurationId) {

            //clearConfigurationAssets();
            cleanupAssets();                   

            currentConfiguration = projectLibrary.getConfiguration(currentProject, configurationId);
            updateSeriesName(currentConfiguration);    

            seriesLibrary.fetchSeriesByName(currentConfiguration.series).then(series => {
                productLibrary.fetchProducts(series.id).then(() => {
                    let currentMaterial = materialLibrary.getMaterialByProductNumber(currentConfiguration.data["material"]);
    
                    productSelector.material = currentMaterial;
                    productSelector.reset();
                    //productSelector.categories = [];
                    productSelector.update();
    
                    materialSelector.setConfiguration(currentConfiguration);
                    materialSelector.setMaterialGroup(currentMaterial.group);
                    materialSelector.update();
    
                    /* optionsSelector.reset();
                     optionsSelector.setSeries(series);
                     optionsSelector.setupMockData();
                     optionsSelector.setConfiguration(currentConfiguration);
                     optionsSelector.update();*/
    
                    currentModule = currentConfiguration.data.modules[0];                  

                    constructModule(currentModule).then(() => {
                    
                        zoomToMeshHierarchy(mainCamera, currentModuleNode, scene, Math.PI/2.5, Math.PI/2.5,2);
                        handleModuleUpdating();                        

                        engine.resize(true);
                    });
                });
            });
        }

    }, ".configuration-selector ul li[data-id]");

    Y.one("body").delegate("click", async function (e: any) {

        e.preventDefault();

        var elem = e.currentTarget;
        var parent = elem.ancestor("li");
        var configurationId = parent.getData("id");

        var deleteConfiguration = currentProject.configurations.find(x => x.data.id === configurationId);
        projectLibrary.deleteConfiguation(currentProject, deleteConfiguration);

        await projectLibrary.saveProject(currentProject);
       
        if (isSeriesConstrained) {    
            
            cleanupAssets();
           // resetMainCamera();

            if (currentProject.configurations.length > 0) {
                currentConfiguration = currentProject.configurations[0];
                currentModule = currentConfiguration.data.modules[0];
                    constructModule(currentModule).then(() => {                       
                        zoomToMeshHierarchy(mainCamera, currentModuleNode, scene, mainCamera.alpha, mainCamera.beta, 2);       
                        handleModuleUpdating();
                    })  
            }
          
            updateConfigurationSelector();
            
        } else {

            if (currentProject.configurations.length > 0) {

                cleanupAssets();
               // resetMainCamera();
                
                currentConfiguration = currentProject.configurations[0];
                let series = seriesLibrary.getSeriesByName(currentConfiguration.series);
                var currentMaterial = materialLibrary.getMaterialByProductNumber(currentConfiguration.data["material"]);         

                productLibrary.fetchProducts(series.id).then(() => {
                    productSelector.material = currentMaterial;
                    productSelector.reset();              
                    productSelector.update();

                    materialSelector.setConfiguration(currentConfiguration);
                    materialSelector.setMaterialGroup(currentMaterial.group);
                    materialSelector.update();

                    updateConfigurationSelector();

                    currentModule = currentConfiguration.data.modules[0];
                    constructModule(currentModule).then(() => {                       
                        zoomToMeshHierarchy(mainCamera, currentModuleNode, scene, mainCamera.alpha, mainCamera.beta, 2); 
                        handleModuleUpdating();                          
                    })                
                });
                      
            } else {
                showPage("series");
            }
        }
         
    }, ".configuration-selector ul li[data-id] a");

    Y.one("body").delegate("click", function (e: any) {

        if (!isSeriesConstrained) {
            showPage("series");
            productSelector.reset();
            productSelector.update();
           // resetMainCamera();
        } else {
            const series = seriesLibrary.getSeriesById(seriesConstrainedId);
            createProjectConfiguration(currentProject, series.name)           

            cleanupAssets();
            //resetMainCamera();
            updateConfigurationSelector();
            currentModule = currentConfiguration.data.modules[0];
            constructModule(currentModule).then(() => {                
                zoomToMeshHierarchy(mainCamera, currentModuleNode, scene, mainCamera.alpha, mainCamera.beta, 2);
                handleModuleUpdating(); 
            })   
        }

    }, ".configuration-selector ul li.is-new");

    Y.one("body").delegate("change", function (e: any) {

        projectFilter.hideInactive = e.currentTarget.get("checked");
        updateProjectsList();

    }, "#hideinactive-projects");

    Y.one("body").delegate("keyup", debounce(function (e: any) {
        projectFilter.search = e.currentTarget.get("value");
        updateProjectsList();
    }, 250), "#projectsearch");

    Y.one("body").delegate("reset", function (e: any) {
        projectFilter.search = "";
        updateProjectsList();
    }, ".projectsearch form");

     Y.one("body").delegate("keyup", debounce(function (e: any) {
        seriesFilter.search = e.currentTarget.get("value");
        updateSeriesList();
    }, 250), "#seriessearch");

    Y.one("body").delegate("reset", function (e: any) {
        seriesFilter.search = "";
        updateSeriesList();
    }, ".seriessearch form");


    Y.one("body").delegate("click", function (e: any) {

        let contextMenues = Y.all(".project-actions");
        contextMenues.removeClass("is-active");

        let target = e.currentTarget;
        let parent = target.ancestor(".dropdown");
        parent.addClass("is-active");

        target.on("clickoutside", function (e: any) {
            let contextMenues = Y.all(".project-actions");
            contextMenues.removeClass("is-active");
        });

        e.preventDefault();
        e.stopPropagation();

    }, ".project-actions .dropdown-trigger");

    Y.one("body").delegate("click", async function (e: any) {

        let target = e.currentTarget;
        let identifier = target.getData("id");

        if (identifier) {
            if (window.confirm(i18next.t("projectlist.deleteconfirm"))) {          
                projectLibrary.deleteProject(identifier).then(() => {
                    updateProjectsList();
                })
            }
        }

    }, ".delete-project");

    Y.one("body").delegate("click", async function (e: any) {

        let target = e.currentTarget;
        let identifier = target.getData("id");

        if (identifier) {
            let editProjectModal = Y.one(".editproject-modal");
            editProjectModal.addClass("is-active");

            let projectIdentifierElem = Y.one("#project-identifier");
            let projectNameElem = Y.one("#project-name");
            let projectPhoneElem = Y.one("#project-phone");
            let projectEmailElem = Y.one("#project-email");
            let projectStatusElem = Y.one("#project-status");
            let projectAddedElem = Y.one("#project-added");
            let projectModifiedElem = Y.one("#project-modified");

            let project = await projectLibrary.getProject(identifier);
            currentProject = project;

            projectIdentifierElem.setHTML(project.identifier);
            projectNameElem.set("value", project.name);
            projectPhoneElem.set("value", project.phone);
            projectEmailElem.set("value", project.seller);

            projectStatusElem.set("value", project.status);

            projectAddedElem.setHTML(FormatHelper.formatDate(project.added));
            projectModifiedElem.setHTML(FormatHelper.formatDate(project.modified));
        }

    }, ".edit-project");

    Y.one("body").delegate("click", async function (e: any) {

        let target = e.currentTarget;
        let identifier = target.getData("id");

        await openConfig(identifier);       

    }, ".open-project");

    Y.one("body").delegate("submit", async function (e: any) {

        e.preventDefault();
       
        let projectNameElem = Y.one("#project-name");
        let projectPhoneElem = Y.one("#project-phone");
        let projectEmailElem = Y.one("#project-email");
        let projectStatusElem = Y.one("#project-status");
     
        let projectName = projectNameElem.get("value");
        let projectPhone = projectPhoneElem.get("value");
        let projectEmail = projectEmailElem.get("value");
        let projectStatus = projectStatusElem.get("value");

        currentProject.name = projectName;
        currentProject.phone = projectPhone;
        currentProject.seller = projectEmail;
        currentProject.status = projectStatus;

        await projectLibrary.saveProject(currentProject);
        currentProject = null;

        let editProjectModal = Y.one(".editproject-modal");
        editProjectModal.removeClass("is-active");

        await updateProjectsList();

    }, "#editprojectform");

    Y.one("body").delegate("click", function (e: any) {

        let createProjectModal = Y.one(".createproject-modal");
        createProjectModal.addClass("is-active");

        var newProjectName = createProjectModal.one("#newproject-name");
        newProjectName.set("value", "");

    }, "#newproject-button");

    Y.one("body").delegate("submit", function (e: any) {

        e.preventDefault();

        let projectNameElem = Y.one("#newproject-name");
        let projectPhoneElem = Y.one("#newproject-phone");
        let projectEmailElem = Y.one("#newproject-email");

        let project = {} as Project;
        project.name = projectNameElem.get("value");
        project.phone = projectPhoneElem.get("value");
        project.seller = projectEmailElem.get("value");
        project.status = 1;
        project.configurations = [];

        currentProject = project;
        isNewConfig = true;

        let createProjectModal = Y.one(".createproject-modal");
        createProjectModal.removeClass("is-active");

        showPage("series");

    }, "#createprojectform");

    Y.one("body").delegate("submit", async function (e: any) {

        e.preventDefault();

        var elem = e.currentTarget;
        var input = elem.one("input");
        var identifier = input.get("value");

        await openConfig(identifier);

    }, "#openprojectform");

    Y.one("body").delegate("click", function (e: any) {

        showPage("configurations");

    }, "#projects");

    Y.one("body").delegate("click", function (e: any) {

        handleLogout();

    }, "#logout");

    Y.one("body").delegate("click", function (e: any) {

        if (isB2C) return;

        var userDropdownTrigger = Y.one(".user-menu__button");
        userDropdownTrigger.addClass("is-black");

        var userDropdown = Y.one(".user-menu__wrapper .dropdown");
        userDropdown.addClass("is-active");

        e.preventDefault();
        e.stopPropagation();

    }, ".user-menu__button");

    Y.one(".user-menu__button").on("clickoutside", function (e: any) {

         if (isB2C) return;

        var userDropdownTrigger = Y.one(".user-menu__button");
        userDropdownTrigger.removeClass("is-black");

        var userDropdown = Y.one(".user-menu__wrapper .dropdown");
        userDropdown.removeClass("is-active");

    });


    Y.one("body").delegate("click", function (e: any) {       

        if (isPlacing)
            return false;

        var elem = e.currentTarget;

        var productNumber = elem.getData("productnumber");
        let product = productLibrary.getProductByProductNo(productNumber);

        currentProduct = product;
        instantiateModule(currentConfiguration, currentModule, function (module, moduleNode) {

            currentModule = module;
            currentModuleNode = moduleNode;

            instantiateEntity(currentModule, product, null, function (instantiatedEntity, instantiatedEntityNode) {

                hideAllHighlights();
                hideEntityActions();

                var productVariant = getProductVariant(instantiatedEntity.productNo, instantiatedEntity);
                instantiatedEntity.variantProductNo = productVariant.productNo;
                instantiatedEntityNode.metadata.productNo = productVariant.productNo;

                //Set current selected entity                
                currentEntityNode = instantiatedEntityNode;

                if (currentModule.entities.length == 1) {

                    isPlacing = false;

                    currentEntityNode.setAbsolutePosition(new BABYLON.Vector3(0, currentEntityNode.position.y, 0));

                    var entityBounds = currentEntityNode.getChildMeshes(true, function (m) { return m.id === "entitybounds" })[0];
                    entityBounds.setEnabled(false);

                    currentEntityNode = null;

                    meshLibrary.loadMeshAsync(productVariant.productNo, instantiatedEntity, productVariant.type, "furniture/", productVariant.model + ".glb", productVariant.isFlipped, scene, false, sg, sg2, onProgress, function (clonedMeshEntityId, clonedMesh) {
                        
                        

                        //Set material
                        let material = materialLibrary.getMaterialByProductNumber(currentConfiguration.data["material"]);
                        if (material) {
                            materialLibrary.assignMaterial(Y, productVariant, [clonedMesh], material, scene, function () {                           
                                clonedMesh.setEnabled(true);                             
                            });
                        }

                        hideAllHighlights();
                        hideEntityActions();
                        
                        //moveAllEntities(currentModule);
                        constructEntities(currentModule, () => {
                                                         
                            currentModule.entities.filter(x => productLibrary.getProductCategory(x.category) === "UPHOLSTRY").forEach(function (entity: Entity) {       
                                var productVariant = getProductVariant(entity.productNo, entity);
                                //Create leg attachments
                                createLegAttachments(currentModule, entity, productVariant, scene);
                                //Create legs
                                constructLegs(currentModule, entity);        
                            });

                            clonedMesh.scaling.x = productVariant.isFlipped ? -1 : 1;
                            clonedMesh.position.y = currentConfiguration.data.offsetY;

                            displaySummaryButton(true);                                  

                            pauseRender();
                            resumeRender().then(() => {
                                zoomToMeshHierarchy(mainCamera, currentModuleNode, scene, Math.PI/2.5, Math.PI/2.5, 2); 
                                handleModuleUpdating();
                            });
                        });

                    });
                } else {
                    isPlacing = true;
                    hideEntityActions();
                    showAvailableConnectors(currentModule, instantiatedEntity)
                    e.preventDefault();
                    e.stopPropagation();
                }
            });
        });
    }, ".config-menu .config-menu__submenues__submenu[data-menuview='modules'] .product-selector .selector__items li");

    Y.one(".viewport").on("clickoutside", function (e: any) {
        if (isPlacing) {

            isPlacing = false;

            var entity = getCurrentEntity();
            if (entity) {
                deleteEntity(entity);
                hideAvailableConnectors();
            }
        }
    })

    Y.one("body").delegate("click", function (e: any) {

        Y.all(".config-menu .config-menu__submenues__submenu[data-menuview='myeilersen'] .options-selector__items ul li").each(function (e) {
            e.removeClass("is-active");
        });

        // optionsSelector.update(optionsSelector.path[optionsSelector.path.length - 1]);

    }, ".config-menu .config-menu__submenues__submenu[data-menuview='myeilersen'] .options-selector__items ul li");

    Y.one("body").delegate("click", function (e) {

        e.preventDefault();

        var materialGroupModal = Y.one(".modals .material-group-modal");
        materialGroupModal.addClass("is-active");

        updateMaterialGroupModal();

    }, ".config-menu .config-menu__submenues__submenu[data-menuview='fabrics'] .material-selector__items .material-selector__items__group__select");

    Y.one("body").delegate("click", function (e) {

        e.preventDefault();

        updateOptionsModal();
        var optionsModal = Y.one(".modals .options-modal");
        optionsModal.addClass("is-active");

    }, ".config-menu .config-menu__customize");

    Y.one("body").delegate("change", function (e) {
        if (currentConfiguration.data.customOptions == undefined) {
            currentConfiguration.data.customOptions = [];
        }

        let input = e.currentTarget;

        let option = input.getData("option");
        let value = input.get("value");

        if(option == "leg"){
            currentConfiguration.data.leg = value;
        }else{
            currentConfiguration.data.customOptions = currentConfiguration.data.customOptions.filter(e => e.id != option);
            if (value != "-" && value != "") {
                currentConfiguration.data.customOptions.push({ id: option, value: value });
            }
        }

        updateSummaryMenuTotalPrice();
        saveProjectConfiguration();
        //window.dispatchEvent(new Event("saveconfigurations"));
    }, ".options-modal .options select");

    Y.one("body").delegate("change", function (e) {
        if (currentConfiguration.data.customOptions == undefined) {
            currentConfiguration.data.customOptions = [];
        }

        let input = e.currentTarget;

        let element = input.getData("element");
        let option = input.getData("option");
        let value = input.getData("value");
        let selected = input.get("checked");

        if(element){
            const entity = currentModule.entities.find(e => e.id == element);
            if (entity.customOptions == undefined) {
                entity.customOptions = [];
            }

            entity.customOptions = entity.customOptions.filter(e => e.id != option);
            if (selected) {
                entity.customOptions.push({ id: option, value: value });
            }
        }else{
            currentConfiguration.data.customOptions = currentConfiguration.data.customOptions.filter(e => e.id != option);
            if (selected) {
                currentConfiguration.data.customOptions.push({ id: option, value: value });
            }
        }
        updateSummaryMenuTotalPrice();
        saveProjectConfiguration();
        //window.dispatchEvent(new Event("saveconfigurations"));
    }, ".options-modal .options input[type=checkbox]");



    Y.one("body").delegate("change", function (e) {
        updateMaterialGroupModal();
    }, ".materialfilter");

    Y.one("body").delegate("keyup", debounce(function (e) {
        updateMaterialGroupModal();
    }, 250), "#materialsearchfilter");

    /* Y.one("body").delegate("change", function (e) {
 
         showMetrics = !showMetrics;
 
         if (showMetrics) {
             Metrics.CreateModuleRulers(currentModule, productLibrary, scene, rulerGUI);
         } else {
             Metrics.ClearMetrics(scene, rulerGUI);
         }
 
     }, ".config-menu__metrics");*/

    Y.one("body").delegate("click", function (e) {

        var username = Y.one("#email").get("value");
        var password = Y.one("#password").get("value");

        var cfg = {
            method: 'POST',
            data: JSON.stringify({ username: username, password: password }),
            headers: {
                'Content-Type': 'application/json',
            },
            on: {
                success: function (transactionid, response) {
                    var authJSON = JSON.parse(response.responseText);

                    if (authJSON.success) {
                        window.localStorage.setItem("accessToken", authJSON.accessToken);
                        window.localStorage.setItem("refreshToken", authJSON.refreshToken);                       

                        handleLogin();
                    }

                    if (authJSON.changePassword) {                        
                        showChangePassword();
                    }
                },
                failure: function (transactionid, response) {
                    window.localStorage.removeItem("accessToken");
                    window.localStorage.removeItem("refreshToken");
                    handleLogin();
                }
            }

        };

        Y.io('api/auth/login', cfg);

    }, ".login-btn");

    Y.one(".modal").delegate("click", function (e) {

        var target = e.currentTarget;
        var parent = target.ancestor(".modal");
        parent.removeClass("is-active");

    }, ".modal-background, .modal-close");

    Y.one(".material-group-modal").delegate("click", function (e) {

        var target = e.currentTarget;
        var parent = target.ancestor(".modal");

        var groupId = target.getAttribute("data-group");

        // materialSelector.setConfiguration(currentConfiguration);
        materialSelector.setMaterialGroup(groupId);
        materialSelector.update();

        parent.removeClass("is-active");

    }, ".modal-card-body ul li");

    Y.one(".options-modal").delegate("click", function (e) {

        var renderButton = Y.one(e.target);
        renderButton.set("disabled", "disabled");

        renderConfigurationImages(currentConfiguration, () => {
            renderButton.set("disabled", null);
        });
    }, ".renderConfiguration");
});